webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-5738fd0f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {


var pinyin_dict_notone = { "a": "阿啊呵腌嗄吖锕", "e": "额阿俄恶鹅遏鄂厄饿峨扼娥鳄哦蛾噩愕讹锷垩婀鹗萼谔莪腭锇颚呃阏屙苊轭", "ai": "爱埃艾碍癌哀挨矮隘蔼唉皑哎霭捱暧嫒嗳瑷嗌锿砹", "ei": "诶", "xi": "系西席息希习吸喜细析戏洗悉锡溪惜稀袭夕洒晰昔牺腊烯熙媳栖膝隙犀蹊硒兮熄曦禧嬉玺奚汐徙羲铣淅嘻歙熹矽蟋郗唏皙隰樨浠忾蜥檄郄翕阋鳃舾屣葸螅咭粞觋欷僖醯鼷裼穸饩舄禊诶菥蓰", "yi": "一以已意议义益亿易医艺食依移衣异伊仪宜射遗疑毅谊亦疫役忆抑尾乙译翼蛇溢椅沂泄逸蚁夷邑怡绎彝裔姨熠贻矣屹颐倚诣胰奕翌疙弈轶蛾驿壹猗臆弋铱旖漪迤佚翊诒怿痍懿饴峄揖眙镒仡黟肄咿翳挹缢呓刈咦嶷羿钇殪荑薏蜴镱噫癔苡悒嗌瘗衤佾埸圯舣酏劓", "an": "安案按岸暗鞍氨俺胺铵谙庵黯鹌桉埯犴揞厂广", "han": "厂汉韩含旱寒汗涵函喊憾罕焊翰邯撼瀚憨捍酣悍鼾邗颔蚶晗菡旰顸犴焓撖", "ang": "昂仰盎肮", "ao": "奥澳傲熬凹鳌敖遨鏖袄坳翱嗷拗懊岙螯骜獒鏊艹媪廒聱", "wa": "瓦挖娃洼袜蛙凹哇佤娲呙腽", "yu": "于与育余预域予遇奥语誉玉鱼雨渔裕愈娱欲吁舆宇羽逾豫郁寓吾狱喻御浴愉禹俞邪榆愚渝尉淤虞屿峪粥驭瑜禺毓钰隅芋熨瘀迂煜昱汩於臾盂聿竽萸妪腴圄谕觎揄龉谀俣馀庾妤瘐鬻欤鹬阈嵛雩鹆圉蜮伛纡窬窳饫蓣狳肀舁蝓燠", "niu": "牛纽扭钮拗妞忸狃", "o": "哦噢喔", "ba": "把八巴拔伯吧坝爸霸罢芭跋扒叭靶疤笆耙鲅粑岜灞钯捌菝魃茇", "pa": "怕帕爬扒趴琶啪葩耙杷钯筢", "pi": "被批副否皮坏辟啤匹披疲罢僻毗坯脾譬劈媲屁琵邳裨痞癖陂丕枇噼霹吡纰砒铍淠郫埤濞睥芘蚍圮鼙罴蜱疋貔仳庀擗甓陴", "bi": "比必币笔毕秘避闭佛辟壁弊彼逼碧鼻臂蔽拂泌璧庇痹毙弼匕鄙陛裨贲敝蓖吡篦纰俾铋毖筚荸薜婢哔跸濞秕荜愎睥妣芘箅髀畀滗狴萆嬖襞舭", "bai": "百白败摆伯拜柏佰掰呗擘捭稗", "bo": "波博播勃拨薄佛伯玻搏柏泊舶剥渤卜驳簿脖膊簸菠礴箔铂亳钵帛擘饽跛钹趵檗啵鹁擗踣", "bei": "北被备倍背杯勃贝辈悲碑臂卑悖惫蓓陂钡狈呗焙碚褙庳鞴孛鹎邶鐾", "ban": "办版半班般板颁伴搬斑扮拌扳瓣坂阪绊钣瘢舨癍", "pan": "判盘番潘攀盼拚畔胖叛拌蹒磐爿蟠泮袢襻丬", "bin": "份宾频滨斌彬濒殡缤鬓槟摈膑玢镔豳髌傧", "bang": "帮邦彭旁榜棒膀镑绑傍磅蚌谤梆浜蒡", "pang": "旁庞乓磅螃彷滂逄耪", "beng": "泵崩蚌蹦迸绷甭嘣甏堋", "bao": "报保包宝暴胞薄爆炮饱抱堡剥鲍曝葆瀑豹刨褒雹孢苞煲褓趵鸨龅勹", "bu": "不部步布补捕堡埔卜埠簿哺怖钚卟瓿逋晡醭钸", "pu": "普暴铺浦朴堡葡谱埔扑仆蒲曝瀑溥莆圃璞濮菩蹼匍噗氆攵镨攴镤", "mian": "面棉免绵缅勉眠冕娩腼渑湎沔黾宀眄", "po": "破繁坡迫颇朴泊婆泼魄粕鄱珀陂叵笸泺皤钋钷", "fan": "反范犯繁饭泛翻凡返番贩烦拚帆樊藩矾梵蕃钒幡畈蘩蹯燔", "fu": "府服副负富复福夫妇幅付扶父符附腐赴佛浮覆辅傅伏抚赋辐腹弗肤阜袱缚甫氟斧孚敷俯拂俘咐腑孵芙涪釜脯茯馥宓绂讣呋罘麸蝠匐芾蜉跗凫滏蝮驸绋蚨砩桴赙菔呒趺苻拊阝鲋怫稃郛莩幞祓艴黻黼鳆", "ben": "本体奔苯笨夯贲锛畚坌", "feng": "风丰封峰奉凤锋冯逢缝蜂枫疯讽烽俸沣酆砜葑唪", "bian": "变便边编遍辩鞭辨贬匾扁卞汴辫砭苄蝙鳊弁窆笾煸褊碥忭缏", "pian": "便片篇偏骗翩扁骈胼蹁谝犏缏", "zhen": "镇真针圳振震珍阵诊填侦臻贞枕桢赈祯帧甄斟缜箴疹砧榛鸩轸稹溱蓁胗椹朕畛浈", "biao": "表标彪镖裱飚膘飙镳婊骠飑杓髟鳔灬瘭", "piao": "票朴漂飘嫖瓢剽缥殍瞟骠嘌莩螵", "huo": "和活或货获火伙惑霍祸豁嚯藿锪蠖钬耠镬夥灬劐攉", "bie": "别鳖憋瘪蹩", "min": "民敏闽闵皿泯岷悯珉抿黾缗玟愍苠鳘", "fen": "分份纷奋粉氛芬愤粪坟汾焚酚吩忿棼玢鼢瀵偾鲼", "bing": "并病兵冰屏饼炳秉丙摒柄槟禀枋邴冫", "geng": "更耕颈庚耿梗埂羹哽赓绠鲠", "fang": "方放房防访纺芳仿坊妨肪邡舫彷枋鲂匚钫", "xian": "现先县见线限显险献鲜洗宪纤陷闲贤仙衔掀咸嫌掺羡弦腺痫娴舷馅酰铣冼涎暹籼锨苋蚬跹岘藓燹鹇氙莶霰跣猃彡祆筅", "fou": "不否缶", "ca": "拆擦嚓礤", "cha": "查察差茶插叉刹茬楂岔诧碴嚓喳姹杈汊衩搽槎镲苴檫馇锸猹", "cai": "才采财材菜彩裁蔡猜踩睬", "can": "参残餐灿惨蚕掺璨惭粲孱骖黪", "shen": "信深参身神什审申甚沈伸慎渗肾绅莘呻婶娠砷蜃哂椹葚吲糁渖诜谂矧胂", "cen": "参岑涔", "san": "三参散伞叁糁馓毵", "cang": "藏仓苍沧舱臧伧", "zang": "藏脏葬赃臧奘驵", "chen": "称陈沈沉晨琛臣尘辰衬趁忱郴宸谌碜嗔抻榇伧谶龀肜", "cao": "草操曹槽糙嘈漕螬艚屮", "ce": "策测册侧厕栅恻", "ze": "责则泽择侧咋啧仄箦赜笮舴昃迮帻", "zhai": "债择齐宅寨侧摘窄斋祭翟砦瘵哜", "dao": "到道导岛倒刀盗稻蹈悼捣叨祷焘氘纛刂帱忉", "ceng": "层曾蹭噌", "zha": "查扎炸诈闸渣咋乍榨楂札栅眨咤柞喳喋铡蚱吒怍砟揸痄哳齄", "chai": "差拆柴钗豺侪虿瘥", "ci": "次此差词辞刺瓷磁兹慈茨赐祠伺雌疵鹚糍呲粢", "zi": "资自子字齐咨滋仔姿紫兹孜淄籽梓鲻渍姊吱秭恣甾孳訾滓锱辎趑龇赀眦缁呲笫谘嵫髭茈粢觜耔", "cuo": "措错磋挫搓撮蹉锉厝嵯痤矬瘥脞鹾", "chan": "产单阐崭缠掺禅颤铲蝉搀潺蟾馋忏婵孱觇廛谄谗澶骣羼躔蒇冁", "shan": "山单善陕闪衫擅汕扇掺珊禅删膳缮赡鄯栅煽姗跚鳝嬗潸讪舢苫疝掸膻钐剡蟮芟埏彡骟", "zhan": "展战占站崭粘湛沾瞻颤詹斩盏辗绽毡栈蘸旃谵搌", "xin": "新心信辛欣薪馨鑫芯锌忻莘昕衅歆囟忄镡", "lian": "联连练廉炼脸莲恋链帘怜涟敛琏镰濂楝鲢殓潋裢裣臁奁莶蠊蔹", "chang": "场长厂常偿昌唱畅倡尝肠敞倘猖娼淌裳徜昶怅嫦菖鲳阊伥苌氅惝鬯", "zhang": "长张章障涨掌帐胀彰丈仗漳樟账杖璋嶂仉瘴蟑獐幛鄣嫜", "chao": "超朝潮炒钞抄巢吵剿绰嘲晁焯耖怊", "zhao": "着照招找召朝赵兆昭肇罩钊沼嘲爪诏濯啁棹笊", "zhou": "调州周洲舟骤轴昼宙粥皱肘咒帚胄绉纣妯啁诌繇碡籀酎荮", "che": "车彻撤尺扯澈掣坼砗屮", "ju": "车局据具举且居剧巨聚渠距句拒俱柜菊拘炬桔惧矩鞠驹锯踞咀瞿枸掬沮莒橘飓疽钜趄踽遽琚龃椐苣裾榘狙倨榉苴讵雎锔窭鞫犋屦醵", "cheng": "成程城承称盛抢乘诚呈净惩撑澄秤橙骋逞瞠丞晟铛埕塍蛏柽铖酲裎枨", "rong": "容荣融绒溶蓉熔戎榕茸冗嵘肜狨蝾", "sheng": "生声升胜盛乘圣剩牲甸省绳笙甥嵊晟渑眚", "deng": "等登邓灯澄凳瞪蹬噔磴嶝镫簦戥", "zhi": "制之治质职只志至指织支值知识直致执置止植纸拓智殖秩旨址滞氏枝芝脂帜汁肢挚稚酯掷峙炙栉侄芷窒咫吱趾痔蜘郅桎雉祉郦陟痣蛭帙枳踯徵胝栀贽祗豸鸷摭轵卮轾彘觯絷跖埴夂黹忮骘膣踬", "zheng": "政正证争整征郑丁症挣蒸睁铮筝拯峥怔诤狰徵钲", "tang": "堂唐糖汤塘躺趟倘棠烫淌膛搪镗傥螳溏帑羰樘醣螗耥铴瑭", "chi": "持吃池迟赤驰尺斥齿翅匙痴耻炽侈弛叱啻坻眙嗤墀哧茌豉敕笞饬踟蚩柢媸魑篪褫彳鸱螭瘛眵傺", "shi": "是时实事市十使世施式势视识师史示石食始士失适试什泽室似诗饰殖释驶氏硕逝湿蚀狮誓拾尸匙仕柿矢峙侍噬嗜栅拭嘘屎恃轼虱耆舐莳铈谥炻豕鲥饣螫酾筮埘弑礻蓍鲺贳", "qi": "企其起期气七器汽奇齐启旗棋妻弃揭枝歧欺骑契迄亟漆戚岂稽岐琦栖缉琪泣乞砌祁崎绮祺祈凄淇杞脐麒圻憩芪伎俟畦耆葺沏萋骐鳍綦讫蕲屺颀亓碛柒啐汔綮萁嘁蛴槭欹芑桤丌蜞", "chuai": "揣踹啜搋膪", "tuo": "托脱拓拖妥驼陀沱鸵驮唾椭坨佗砣跎庹柁橐乇铊沲酡鼍箨柝", "duo": "多度夺朵躲铎隋咄堕舵垛惰哆踱跺掇剁柁缍沲裰哚隳", "xue": "学血雪削薛穴靴谑噱鳕踅泶彐", "chong": "重种充冲涌崇虫宠忡憧舂茺铳艟", "chou": "筹抽绸酬愁丑臭仇畴稠瞅踌惆俦瘳雠帱", "qiu": "求球秋丘邱仇酋裘龟囚遒鳅虬蚯泅楸湫犰逑巯艽俅蝤赇鼽糗", "xiu": "修秀休宿袖绣臭朽锈羞嗅岫溴庥馐咻髹鸺貅", "chu": "出处础初助除储畜触楚厨雏矗橱锄滁躇怵绌搐刍蜍黜杵蹰亍樗憷楮", "tuan": "团揣湍疃抟彖", "zhui": "追坠缀揣椎锥赘惴隹骓缒", "chuan": "传川船穿串喘椽舛钏遄氚巛舡", "zhuan": "专转传赚砖撰篆馔啭颛", "yuan": "元员院原源远愿园援圆缘袁怨渊苑宛冤媛猿垣沅塬垸鸳辕鸢瑗圜爰芫鼋橼螈眢箢掾", "cuan": "窜攒篡蹿撺爨汆镩", "chuang": "创床窗闯幢疮怆", "zhuang": "装状庄壮撞妆幢桩奘僮戆", "chui": "吹垂锤炊椎陲槌捶棰", "chun": "春纯醇淳唇椿蠢鹑朐莼肫蝽", "zhun": "准屯淳谆肫窀", "cu": "促趋趣粗簇醋卒蹴猝蹙蔟殂徂", "dun": "吨顿盾敦蹲墩囤沌钝炖盹遁趸砘礅", "qu": "区去取曲趋渠趣驱屈躯衢娶祛瞿岖龋觑朐蛐癯蛆苣阒诎劬蕖蘧氍黢蠼璩麴鸲磲", "xu": "需许续须序徐休蓄畜虚吁绪叙旭邪恤墟栩絮圩婿戌胥嘘浒煦酗诩朐盱蓿溆洫顼勖糈砉醑", "chuo": "辍绰戳淖啜龊踔辶", "zu": "组族足祖租阻卒俎诅镞菹", "ji": "济机其技基记计系期际及集级几给积极己纪即继击既激绩急奇吉季齐疾迹鸡剂辑籍寄挤圾冀亟寂暨脊跻肌稽忌饥祭缉棘矶汲畸姬藉瘠骥羁妓讥稷蓟悸嫉岌叽伎鲫诘楫荠戟箕霁嵇觊麂畿玑笈犄芨唧屐髻戢佶偈笄跽蒺乩咭赍嵴虮掎齑殛鲚剞洎丌墼蕺彐芰哜", "cong": "从丛匆聪葱囱琮淙枞骢苁璁", "zong": "总从综宗纵踪棕粽鬃偬枞腙", "cou": "凑辏腠楱", "cui": "衰催崔脆翠萃粹摧璀瘁悴淬啐隹毳榱", "wei": "为位委未维卫围违威伟危味微唯谓伪慰尾魏韦胃畏帷喂巍萎蔚纬潍尉渭惟薇苇炜圩娓诿玮崴桅偎逶倭猥囗葳隗痿猬涠嵬韪煨艉隹帏闱洧沩隈鲔軎", "cun": "村存寸忖皴", "zuo": "作做座左坐昨佐琢撮祚柞唑嘬酢怍笮阼胙", "zuan": "钻纂攥缵躜", "da": "大达打答搭沓瘩惮嗒哒耷鞑靼褡笪怛妲", "dai": "大代带待贷毒戴袋歹呆隶逮岱傣棣怠殆黛甙埭诒绐玳呔迨", "tai": "大台太态泰抬胎汰钛苔薹肽跆邰鲐酞骀炱", "ta": "他它她拓塔踏塌榻沓漯獭嗒挞蹋趿遢铊鳎溻闼", "dan": "但单石担丹胆旦弹蛋淡诞氮郸耽殚惮儋眈疸澹掸膻啖箪聃萏瘅赕", "lu": "路六陆录绿露鲁卢炉鹿禄赂芦庐碌麓颅泸卤潞鹭辘虏璐漉噜戮鲈掳橹轳逯渌蓼撸鸬栌氇胪镥簏舻辂垆", "tan": "谈探坦摊弹炭坛滩贪叹谭潭碳毯瘫檀痰袒坍覃忐昙郯澹钽锬", "ren": "人任认仁忍韧刃纫饪妊荏稔壬仞轫亻衽", "jie": "家结解价界接节她届介阶街借杰洁截姐揭捷劫戒皆竭桔诫楷秸睫藉拮芥诘碣嗟颉蚧孑婕疖桀讦疥偈羯袷哜喈卩鲒骱", "yan": "研严验演言眼烟沿延盐炎燕岩宴艳颜殷彦掩淹阎衍铅雁咽厌焰堰砚唁焉晏檐蜒奄俨腌妍谚兖筵焱偃闫嫣鄢湮赝胭琰滟阉魇酽郾恹崦芫剡鼹菸餍埏谳讠厣罨", "dang": "当党档荡挡宕砀铛裆凼菪谠", "tao": "套讨跳陶涛逃桃萄淘掏滔韬叨洮啕绦饕鼗", "tiao": "条调挑跳迢眺苕窕笤佻啁粜髫铫祧龆蜩鲦", "te": "特忑忒铽慝", "de": "的地得德底锝", "dei": "得", "di": "的地第提低底抵弟迪递帝敌堤蒂缔滴涤翟娣笛棣荻谛狄邸嘀砥坻诋嫡镝碲骶氐柢籴羝睇觌", "ti": "体提题弟替梯踢惕剔蹄棣啼屉剃涕锑倜悌逖嚏荑醍绨鹈缇裼", "tui": "推退弟腿褪颓蜕忒煺", "you": "有由又优游油友右邮尤忧幼犹诱悠幽佑釉柚铀鱿囿酉攸黝莠猷蝣疣呦蚴莸莜铕宥繇卣牖鼬尢蚰侑", "dian": "电点店典奠甸碘淀殿垫颠滇癫巅惦掂癜玷佃踮靛钿簟坫阽", "tian": "天田添填甜甸恬腆佃舔钿阗忝殄畋栝掭", "zhu": "主术住注助属逐宁著筑驻朱珠祝猪诸柱竹铸株瞩嘱贮煮烛苎褚蛛拄铢洙竺蛀渚伫杼侏澍诛茱箸炷躅翥潴邾槠舳橥丶瘃麈疰", "nian": "年念酿辗碾廿捻撵拈蔫鲶埝鲇辇黏", "diao": "调掉雕吊钓刁貂凋碉鲷叼铫铞", "yao": "要么约药邀摇耀腰遥姚窑瑶咬尧钥谣肴夭侥吆疟妖幺杳舀窕窈曜鹞爻繇徭轺铫鳐崾珧", "die": "跌叠蝶迭碟爹谍牒耋佚喋堞瓞鲽垤揲蹀", "she": "设社摄涉射折舍蛇拾舌奢慑赦赊佘麝歙畲厍猞揲滠", "ye": "业也夜叶射野液冶喝页爷耶邪咽椰烨掖拽曳晔谒腋噎揶靥邺铘揲", "xie": "些解协写血叶谢械鞋胁斜携懈契卸谐泄蟹邪歇泻屑挟燮榭蝎撷偕亵楔颉缬邂鲑瀣勰榍薤绁渫廨獬躞", "zhe": "这者着著浙折哲蔗遮辙辄柘锗褶蜇蛰鹧谪赭摺乇磔螫", "ding": "定订顶丁鼎盯钉锭叮仃铤町酊啶碇腚疔玎耵", "diu": "丢铥", "ting": "听庭停厅廷挺亭艇婷汀铤烃霆町蜓葶梃莛", "dong": "动东董冬洞懂冻栋侗咚峒氡恫胴硐垌鸫岽胨", "tong": "同通统童痛铜桶桐筒彤侗佟潼捅酮砼瞳恸峒仝嗵僮垌茼", "zhong": "中重种众终钟忠仲衷肿踵冢盅蚣忪锺舯螽夂", "dou": "都斗读豆抖兜陡逗窦渎蚪痘蔸钭篼", "du": "度都独督读毒渡杜堵赌睹肚镀渎笃竺嘟犊妒牍蠹椟黩芏髑", "duan": "断段短端锻缎煅椴簖", "dui": "对队追敦兑堆碓镦怼憝", "rui": "瑞兑锐睿芮蕊蕤蚋枘", "yue": "月说约越乐跃兑阅岳粤悦曰钥栎钺樾瀹龠哕刖", "tun": "吞屯囤褪豚臀饨暾氽", "hui": "会回挥汇惠辉恢徽绘毁慧灰贿卉悔秽溃荟晖彗讳诲珲堕诙蕙晦睢麾烩茴喙桧蛔洄浍虺恚蟪咴隳缋哕", "wu": "务物无五武午吴舞伍污乌误亡恶屋晤悟吾雾芜梧勿巫侮坞毋诬呜钨邬捂鹜兀婺妩於戊鹉浯蜈唔骛仵焐芴鋈庑鼯牾怃圬忤痦迕杌寤阢", "ya": "亚压雅牙押鸭呀轧涯崖邪芽哑讶鸦娅衙丫蚜碣垭伢氩桠琊揠吖睚痖疋迓岈砑", "he": "和合河何核盖贺喝赫荷盒鹤吓呵苛禾菏壑褐涸阂阖劾诃颌嗬貉曷翮纥盍", "wo": "我握窝沃卧挝涡斡渥幄蜗喔倭莴龌肟硪", "en": "恩摁蒽", "n": "嗯唔", "er": "而二尔儿耳迩饵洱贰铒珥佴鸸鲕", "fa": "发法罚乏伐阀筏砝垡珐", "quan": "全权券泉圈拳劝犬铨痊诠荃醛蜷颧绻犭筌鬈悛辁畎", "fei": "费非飞肥废菲肺啡沸匪斐蜚妃诽扉翡霏吠绯腓痱芾淝悱狒榧砩鲱篚镄", "pei": "配培坏赔佩陪沛裴胚妃霈淠旆帔呸醅辔锫", "ping": "平评凭瓶冯屏萍苹乒坪枰娉俜鲆", "fo": "佛", "hu": "和护许户核湖互乎呼胡戏忽虎沪糊壶葫狐蝴弧瑚浒鹄琥扈唬滹惚祜囫斛笏芴醐猢怙唿戽槲觳煳鹕冱瓠虍岵鹱烀轷", "ga": "夹咖嘎尬噶旮伽尕钆尜", "ge": "个合各革格歌哥盖隔割阁戈葛鸽搁胳舸疙铬骼蛤咯圪镉颌仡硌嗝鬲膈纥袼搿塥哿虼", "ha": "哈蛤铪", "xia": "下夏峡厦辖霞夹虾狭吓侠暇遐瞎匣瑕唬呷黠硖罅狎瘕柙", "gai": "改该盖概溉钙丐芥赅垓陔戤", "hai": "海还害孩亥咳骸骇氦嗨胲醢", "gan": "干感赶敢甘肝杆赣乾柑尴竿秆橄矸淦苷擀酐绀泔坩旰疳澉", "gang": "港钢刚岗纲冈杠缸扛肛罡戆筻", "jiang": "将强江港奖讲降疆蒋姜浆匠酱僵桨绛缰犟豇礓洚茳糨耩", "hang": "行航杭巷夯吭桁沆绗颃", "gong": "工公共供功红贡攻宫巩龚恭拱躬弓汞蚣珙觥肱廾", "hong": "红宏洪轰虹鸿弘哄烘泓訇蕻闳讧荭黉薨", "guang": "广光逛潢犷胱咣桄", "qiong": "穷琼穹邛茕筇跫蛩銎", "gao": "高告搞稿膏糕镐皋羔锆杲郜睾诰藁篙缟槁槔", "hao": "好号毫豪耗浩郝皓昊皋蒿壕灏嚎濠蚝貉颢嗥薅嚆", "li": "理力利立里李历例离励礼丽黎璃厉厘粒莉梨隶栗荔沥犁漓哩狸藜罹篱鲤砺吏澧俐骊溧砾莅锂笠蠡蛎痢雳俪傈醴栎郦俚枥喱逦娌鹂戾砬唳坜疠蜊黧猁鬲粝蓠呖跞疬缡鲡鳢嫠詈悝苈篥轹", "jia": "家加价假佳架甲嘉贾驾嫁夹稼钾挟拮迦伽颊浃枷戛荚痂颉镓笳珈岬胛袈郏葭袷瘕铗跏蛱恝哿", "luo": "落罗络洛逻螺锣骆萝裸漯烙摞骡咯箩珞捋荦硌雒椤镙跞瘰泺脶猡倮蠃", "ke": "可科克客刻课颗渴壳柯棵呵坷恪苛咳磕珂稞瞌溘轲窠嗑疴蝌岢铪颏髁蚵缂氪骒钶锞", "qia": "卡恰洽掐髂袷咭葜", "gei": "给", "gen": "根跟亘艮哏茛", "hen": "很狠恨痕哏", "gou": "构购够句沟狗钩拘勾苟垢枸篝佝媾诟岣彀缑笱鞲觏遘", "kou": "口扣寇叩抠佝蔻芤眍筘", "gu": "股古顾故固鼓骨估谷贾姑孤雇辜菇沽咕呱锢钴箍汩梏痼崮轱鸪牯蛊诂毂鹘菰罟嘏臌觚瞽蛄酤牿鲴", "pai": "牌排派拍迫徘湃俳哌蒎", "gua": "括挂瓜刮寡卦呱褂剐胍诖鸹栝呙", "tou": "投头透偷愉骰亠", "guai": "怪拐乖", "kuai": "会快块筷脍蒯侩浍郐蒉狯哙", "guan": "关管观馆官贯冠惯灌罐莞纶棺斡矜倌鹳鳏盥掼涫", "wan": "万完晚湾玩碗顽挽弯蔓丸莞皖宛婉腕蜿惋烷琬畹豌剜纨绾脘菀芄箢", "ne": "呢哪呐讷疒", "gui": "规贵归轨桂柜圭鬼硅瑰跪龟匮闺诡癸鳜桧皈鲑刽晷傀眭妫炅庋簋刿宄匦", "jun": "军均俊君峻菌竣钧骏龟浚隽郡筠皲麇捃", "jiong": "窘炯迥炅冂扃", "jue": "决绝角觉掘崛诀獗抉爵嚼倔厥蕨攫珏矍蹶谲镢鳜噱桷噘撅橛孓觖劂爝", "gun": "滚棍辊衮磙鲧绲丨", "hun": "婚混魂浑昏棍珲荤馄诨溷阍", "guo": "国过果郭锅裹帼涡椁囗蝈虢聒埚掴猓崞蜾呙馘", "hei": "黑嘿嗨", "kan": "看刊勘堪坎砍侃嵌槛瞰阚龛戡凵莰", "heng": "衡横恒亨哼珩桁蘅", "mo": "万没么模末冒莫摩墨默磨摸漠脉膜魔沫陌抹寞蘑摹蓦馍茉嘿谟秣蟆貉嫫镆殁耱嬷麽瘼貊貘", "peng": "鹏朋彭膨蓬碰苹棚捧亨烹篷澎抨硼怦砰嘭蟛堋", "hou": "后候厚侯猴喉吼逅篌糇骺後鲎瘊堠", "hua": "化华划话花画滑哗豁骅桦猾铧砉", "huai": "怀坏淮徊槐踝", "huan": "还环换欢患缓唤焕幻痪桓寰涣宦垸洹浣豢奂郇圜獾鲩鬟萑逭漶锾缳擐", "xun": "讯训迅孙寻询循旬巡汛勋逊熏徇浚殉驯鲟薰荀浔洵峋埙巽郇醺恂荨窨蕈曛獯", "huang": "黄荒煌皇凰慌晃潢谎惶簧璜恍幌湟蝗磺隍徨遑肓篁鳇蟥癀", "nai": "能乃奶耐奈鼐萘氖柰佴艿", "luan": "乱卵滦峦鸾栾銮挛孪脔娈", "qie": "切且契窃茄砌锲怯伽惬妾趄挈郄箧慊", "jian": "建间件见坚检健监减简艰践兼鉴键渐柬剑尖肩舰荐箭浅剪俭碱茧奸歼拣捡煎贱溅槛涧堑笺谏饯锏缄睑謇蹇腱菅翦戬毽笕犍硷鞯牮枧湔鲣囝裥踺搛缣鹣蒹谫僭戋趼楗", "nan": "南难男楠喃囡赧腩囝蝻", "qian": "前千钱签潜迁欠纤牵浅遣谦乾铅歉黔谴嵌倩钳茜虔堑钎骞阡掮钤扦芊犍荨仟芡悭缱佥愆褰凵肷岍搴箝慊椠", "qiang": "强抢疆墙枪腔锵呛羌蔷襁羟跄樯戕嫱戗炝镪锖蜣", "xiang": "向项相想乡象响香降像享箱羊祥湘详橡巷翔襄厢镶飨饷缃骧芗庠鲞葙蟓", "jiao": "教交较校角觉叫脚缴胶轿郊焦骄浇椒礁佼蕉娇矫搅绞酵剿嚼饺窖跤蛟侥狡姣皎茭峤铰醮鲛湫徼鹪僬噍艽挢敫", "zhuo": "着著缴桌卓捉琢灼浊酌拙茁涿镯淖啄濯焯倬擢斫棹诼浞禚", "qiao": "桥乔侨巧悄敲俏壳雀瞧翘窍峭锹撬荞跷樵憔鞘橇峤诮谯愀鞒硗劁缲", "xiao": "小效销消校晓笑肖削孝萧俏潇硝宵啸嚣霄淆哮筱逍姣箫骁枭哓绡蛸崤枵魈", "si": "司四思斯食私死似丝饲寺肆撕泗伺嗣祀厮驷嘶锶俟巳蛳咝耜笥纟糸鸶缌澌姒汜厶兕", "kai": "开凯慨岂楷恺揩锴铠忾垲剀锎蒈", "jin": "进金今近仅紧尽津斤禁锦劲晋谨筋巾浸襟靳瑾烬缙钅矜觐堇馑荩噤廑妗槿赆衿卺", "qin": "亲勤侵秦钦琴禽芹沁寝擒覃噙矜嗪揿溱芩衾廑锓吣檎螓", "jing": "经京精境竞景警竟井惊径静劲敬净镜睛晶颈荆兢靖泾憬鲸茎腈菁胫阱旌粳靓痉箐儆迳婧肼刭弪獍", "ying": "应营影英景迎映硬盈赢颖婴鹰荧莹樱瑛蝇萦莺颍膺缨瀛楹罂荥萤鹦滢蓥郢茔嘤璎嬴瘿媵撄潆", "jiu": "就究九酒久救旧纠舅灸疚揪咎韭玖臼柩赳鸠鹫厩啾阄桕僦鬏", "zui": "最罪嘴醉咀蕞觜", "juan": "卷捐圈眷娟倦绢隽镌涓鹃鄄蠲狷锩桊", "suan": "算酸蒜狻", "yun": "员运云允孕蕴韵酝耘晕匀芸陨纭郧筠恽韫郓氲殒愠昀菀狁", "qun": "群裙逡麇", "ka": "卡喀咖咔咯佧胩", "kang": "康抗扛慷炕亢糠伉钪闶", "keng": "坑铿吭", "kao": "考靠烤拷铐栲尻犒", "ken": "肯垦恳啃龈裉", "yin": "因引银印音饮阴隐姻殷淫尹荫吟瘾寅茵圻垠鄞湮蚓氤胤龈窨喑铟洇狺夤廴吲霪茚堙", "kong": "空控孔恐倥崆箜", "ku": "苦库哭酷裤枯窟挎骷堀绔刳喾", "kua": "跨夸垮挎胯侉", "kui": "亏奎愧魁馈溃匮葵窥盔逵睽馗聩喟夔篑岿喹揆隗傀暌跬蒉愦悝蝰", "kuan": "款宽髋", "kuang": "况矿框狂旷眶匡筐邝圹哐贶夼诳诓纩", "que": "确却缺雀鹊阙瘸榷炔阕悫", "kun": "困昆坤捆琨锟鲲醌髡悃阃", "kuo": "扩括阔廓蛞", "la": "拉落垃腊啦辣蜡喇剌旯砬邋瘌", "lai": "来莱赖睐徕籁涞赉濑癞崃疠铼", "lan": "兰览蓝篮栏岚烂滥缆揽澜拦懒榄斓婪阑褴罱啉谰镧漤", "lin": "林临邻赁琳磷淋麟霖鳞凛拎遴蔺吝粼嶙躏廪檩啉辚膦瞵懔", "lang": "浪朗郎廊狼琅榔螂阆锒莨啷蒗稂", "liang": "量两粮良辆亮梁凉谅粱晾靓踉莨椋魉墚", "lao": "老劳落络牢捞涝烙姥佬崂唠酪潦痨醪铑铹栳耢", "mu": "目模木亩幕母牧莫穆姆墓慕牟牡募睦缪沐暮拇姥钼苜仫毪坶", "le": "了乐勒肋叻鳓嘞仂泐", "lei": "类累雷勒泪蕾垒磊擂镭肋羸耒儡嫘缧酹嘞诔檑", "sui": "随岁虽碎尿隧遂髓穗绥隋邃睢祟濉燧谇眭荽", "lie": "列烈劣裂猎冽咧趔洌鬣埒捩躐", "leng": "冷愣棱楞塄", "ling": "领令另零灵龄陵岭凌玲铃菱棱伶羚苓聆翎泠瓴囹绫呤棂蛉酃鲮柃", "lia": "俩", "liao": "了料疗辽廖聊寥缪僚燎缭撂撩嘹潦镣寮蓼獠钌尥鹩", "liu": "流刘六留柳瘤硫溜碌浏榴琉馏遛鎏骝绺镏旒熘鹨锍", "lun": "论轮伦仑纶沦抡囵", "lv": "率律旅绿虑履吕铝屡氯缕滤侣驴榈闾偻褛捋膂稆", "lou": "楼露漏陋娄搂篓喽镂偻瘘髅耧蝼嵝蒌", "mao": "贸毛矛冒貌茂茅帽猫髦锚懋袤牦卯铆耄峁瑁蟊茆蝥旄泖昴瞀", "long": "龙隆弄垄笼拢聋陇胧珑窿茏咙砻垅泷栊癃", "nong": "农浓弄脓侬哝", "shuang": "双爽霜孀泷", "shu": "术书数属树输束述署朱熟殊蔬舒疏鼠淑叔暑枢墅俞曙抒竖蜀薯梳戍恕孰沭赎庶漱塾倏澍纾姝菽黍腧秫毹殳疋摅", "shuai": "率衰帅摔甩蟀", "lve": "略掠锊", "ma": "么马吗摩麻码妈玛嘛骂抹蚂唛蟆犸杩", "me": "么麽", "mai": "买卖麦迈脉埋霾荬劢", "man": "满慢曼漫埋蔓瞒蛮鳗馒幔谩螨熳缦镘颟墁鞔", "mi": "米密秘迷弥蜜谜觅靡泌眯麋猕谧咪糜宓汨醚嘧弭脒冖幂祢縻蘼芈糸敉", "men": "们门闷瞒汶扪焖懑鞔钔", "mang": "忙盲茫芒氓莽蟒邙硭漭", "meng": "蒙盟梦猛孟萌氓朦锰檬勐懵蟒蜢虻黾蠓艨甍艋瞢礞", "miao": "苗秒妙描庙瞄缪渺淼藐缈邈鹋杪眇喵", "mou": "某谋牟缪眸哞鍪蛑侔厶", "miu": "缪谬", "mei": "美没每煤梅媒枚妹眉魅霉昧媚玫酶镁湄寐莓袂楣糜嵋镅浼猸鹛", "wen": "文问闻稳温纹吻蚊雯紊瘟汶韫刎璺玟阌", "mie": "灭蔑篾乜咩蠛", "ming": "明名命鸣铭冥茗溟酩瞑螟暝", "na": "内南那纳拿哪娜钠呐捺衲镎肭", "nei": "内那哪馁", "nuo": "难诺挪娜糯懦傩喏搦锘", "ruo": "若弱偌箬", "nang": "囊馕囔曩攮", "nao": "脑闹恼挠瑙淖孬垴铙桡呶硇猱蛲", "ni": "你尼呢泥疑拟逆倪妮腻匿霓溺旎昵坭铌鲵伲怩睨猊", "nen": "嫩恁", "neng": "能", "nin": "您恁", "niao": "鸟尿溺袅脲茑嬲", "nie": "摄聂捏涅镍孽捻蘖啮蹑嗫臬镊颞乜陧", "niang": "娘酿", "ning": "宁凝拧泞柠咛狞佞聍甯", "nu": "努怒奴弩驽帑孥胬", "nv": "女钕衄恧", "ru": "入如女乳儒辱汝茹褥孺濡蠕嚅缛溽铷洳薷襦颥蓐", "nuan": "暖", "nve": "虐疟", "re": "热若惹喏", "ou": "区欧偶殴呕禺藕讴鸥瓯沤耦怄", "pao": "跑炮泡抛刨袍咆疱庖狍匏脬", "pou": "剖掊裒", "pen": "喷盆湓", "pie": "瞥撇苤氕丿", "pin": "品贫聘频拼拚颦姘嫔榀牝", "se": "色塞瑟涩啬穑铯槭", "qing": "情青清请亲轻庆倾顷卿晴氢擎氰罄磬蜻箐鲭綮苘黥圊檠謦", "zan": "赞暂攒堑昝簪糌瓒錾趱拶", "shao": "少绍召烧稍邵哨韶捎勺梢鞘芍苕劭艄筲杓潲", "sao": "扫骚嫂梢缫搔瘙臊埽缲鳋", "sha": "沙厦杀纱砂啥莎刹杉傻煞鲨霎嗄痧裟挲铩唼歃", "xuan": "县选宣券旋悬轩喧玄绚渲璇炫萱癣漩眩暄煊铉楦泫谖痃碹揎镟儇", "ran": "然染燃冉苒髯蚺", "rang": "让壤攘嚷瓤穰禳", "rao": "绕扰饶娆桡荛", "reng": "仍扔", "ri": "日", "rou": "肉柔揉糅鞣蹂", "ruan": "软阮朊", "run": "润闰", "sa": "萨洒撒飒卅仨脎", "suo": "所些索缩锁莎梭琐嗦唆唢娑蓑羧挲桫嗍睃", "sai": "思赛塞腮噻鳃", "shui": "说水税谁睡氵", "sang": "桑丧嗓搡颡磉", "sen": "森", "seng": "僧", "shai": "筛晒", "shang": "上商尚伤赏汤裳墒晌垧觞殇熵绱", "xing": "行省星腥猩惺兴刑型形邢饧醒幸杏性姓陉荇荥擤悻硎", "shou": "收手受首售授守寿瘦兽狩绶艏扌", "shuo": "说数硕烁朔铄妁槊蒴搠", "su": "速素苏诉缩塑肃俗宿粟溯酥夙愫簌稣僳谡涑蔌嗉觫", "shua": "刷耍唰", "shuan": "栓拴涮闩", "shun": "顺瞬舜吮", "song": "送松宋讼颂耸诵嵩淞怂悚崧凇忪竦菘", "sou": "艘搜擞嗽嗖叟馊薮飕嗾溲锼螋瞍", "sun": "损孙笋荪榫隼狲飧", "teng": "腾疼藤滕誊", "tie": "铁贴帖餮萜", "tu": "土突图途徒涂吐屠兔秃凸荼钍菟堍酴", "wai": "外歪崴", "wang": "王望往网忘亡旺汪枉妄惘罔辋魍", "weng": "翁嗡瓮蓊蕹", "zhua": "抓挝爪", "yang": "样养央阳洋扬杨羊详氧仰秧痒漾疡泱殃恙鸯徉佯怏炀烊鞅蛘", "xiong": "雄兄熊胸凶匈汹芎", "yo": "哟唷", "yong": "用永拥勇涌泳庸俑踊佣咏雍甬镛臃邕蛹恿慵壅痈鳙墉饔喁", "za": "杂扎咱砸咋匝咂拶", "zai": "在再灾载栽仔宰哉崽甾", "zao": "造早遭枣噪灶燥糟凿躁藻皂澡蚤唣", "zei": "贼", "zen": "怎谮", "zeng": "增曾综赠憎锃甑罾缯", "zhei": "这", "zou": "走邹奏揍诹驺陬楱鄹鲰", "zhuai": "转拽", "zun": "尊遵鳟樽撙", "dia": "嗲", "nou": "耨" };
module.exports = pinyin_dict_notone;

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABKVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgIHBwcODg4YGBgiIiInJycvLy81NTU6Ojo8PDxKSkpZWVlra2twcHCCgoKFhYWUlJSioqKjo6Ompqanp6e2tra2tra5ubnHx8fHx8fJycnR0dHR0dHU1NTY2NjY2Njb29vc3Nzc3Nzd3d3d3d3k5OTm5ubm5ubo6Ojr6+vr6+vt7e3w8PDw8PD09PT29vb5+fn7+/v9/f3///////8xb8adAAAAYnRSTlMAAgMFBgcICQoLDBkaGx0iLS4xMjs8QkNERkhLTE1OT1BRUlNUWVpbX2BhZGVmZ2hqbG9wc3R2d3yBiIuTlZ2lpqeosrO1v8DCyMnLz9DT09TU1dzd3uLk5ebp6+/y9vn7/tN8C6cAAAH6SURBVEjHrZdnWwIxDMcLoixlyFLUY6nMKCgq7i1uxYWiIvT7fwgLog9cU+1d/b+AcsnvudImbUIIKpsnEImncwC5dDwS8NiItJz+WAEGVIj5XVKoO6oje3zU/Sc6qoFQ2uivqCMMvyrsELPeLPyhrFeAWoIgoaAVY4emQEozwzw7kgRJpUa4qJBmAZK6mLFMgwFNWwbgEBhSaGCPwKD6dsyZNQpnnT/wJBjW5E88gwmN9WDNDKz1chBM6StDo+bgaIe1583BeTuDfWBSPrPL1VsyW0Fsrrw8rYqtBRvxiK1rr5TWl8R2DxkX2pbrlOmhJHQIkIjIVHqkXV0XRR4REhdYijUGPjfYx9mCwCVO0rhh8ZxhjZXKO/uqCuA0yeGGKoPeKgDrTTY4wn1yBH9+zJDmeme0+cGGe7gXDh8w4GPja7zdorS9gwYoOu2dNqWtLfxXnzLYgunftd83j37NI1vV/Ze7+ArotooLku76HuJrrw+SgP7RPXM8wXa9xocnlxhXWEwVbym95BODS8nyzSkSzaWLuzKfkkqHgdoxpHQAKh29aoe+0nVDxlQuOqUrVu1yVyor1Aoag6XUjEVXAM7Ks7NcCWhPSbN2pK2QnLk2jJW9VqmSOWT9/2JdsU1Qa1AUW6OOXOabsu92cCIxl8nnM3OJCWE7+AnXcAgl9CH4gwAAAABJRU5ErkJggg=="

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a5dc46c.png";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-793a89b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-3a058a0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	return {
		randomNum: function randomNum(min, max) {
			var res = parseInt(Math.random() * (max - min + 1)) + min;
			return res;
		},

		factorial: function (_factorial) {
			function factorial(_x) {
				return _factorial.apply(this, arguments);
			}

			factorial.toString = function () {
				return _factorial.toString();
			};

			return factorial;
		}(function (num) {
			if (num <= 1) {
				return 1;
			}

			return num * factorial(num - 1);
		}),

		square: function square(num) {
			var res = num * num;
			return res;
		},

		cubic: function cubic(num) {
			var res = num * num * num;
			return res;
		},

		fibSequence: function (_fibSequence) {
			function fibSequence(_x2) {
				return _fibSequence.apply(this, arguments);
			}

			fibSequence.toString = function () {
				return _fibSequence.toString();
			};

			return fibSequence;
		}(function (num) {
			if (num <= 2) {
				return 1;
			}
			return fibSequence(num - 1) + fibSequence(num - 2);
		}),

		creatTable: function creatTable(_rows, _cols) {
			var res = '';

			for (var i = 1; i <= _rows; i++) {
				res += '<tr>';

				for (var j = 1; j <= _cols; j++) {
					res += '<td>' + i + '行' + j + '列' + '</td>';
				}
				res += '</tr>';
			}
			res = '<table>' + res + '</table>';
			return res;
		},

		randomColor: function randomColor() {
			var r = randomNum(0, 255);
			var g = randomNum(0, 255);
			var b = randomNum(0, 255);
			var res = 'rgb(' + r + ',' + g + ',' + b + ')';
			return res;
		},

		has: function has(arr, item) {
			for (i = 0; i <= arr.length - 1; i++) {
				if (arr[i] === item) {
					console.log('这个数组中有' + item + '这个元素');
				} else {
					console.log('这个数组中没有' + item + '这个元素');
					break;
				}
			}
		},

		numPlusWord: function numPlusWord(len) {
			for (var res = ''; res.length < len; res.length++) {
				var num = parseInt(Math.random() * 128);
				if (num >= 48 && num <= 57 || num >= 65 && num <= 90 || num <= 122 && num >= 97) {
					res += String.fromCharCode(num);
				}
			}
			return res;
		},

		norepeat: function norepeat(arr) {
			var newArr = [];
			for (i = 0; i < arr.length; i++) {
				for (j = 0; j < newArr.length; j++) {
					if (arr[i] === newArr[j]) {
						break;
					}
				}

				if (j === newArr.length) {
					newArr.push(arr[i]);
				}
			}
			return newArr;
		},

		count: function count(str) {
			var obj = {};
			for (i = 0; i < str.length; i++) {
				var char = str[i];
				if (obj[char] === undefined) {
					obj[char] = 1;
				} else {
					obj[char]++;
				}
			}
			return obj;
		},

		afterDate: function afterDate(date, n) {
			var inputDate = new Date(date);

			var dayNum = inputDate.getDate();

			inputDate.setDate(dayNum + n);

			var year = inputDate.getFullYear();
			var month = inputDate.getMonth() + 1;
			var date = inputDate.getDate();
			var week = inputDate.getDay();
			var hour = inputDate.getHours();
			var min = inputDate.getMinutes();
			var sec = inputDate.getSeconds();
			var res = year + '年' + month + '月' + date + '日';
			return res;
		},

		currentTime: function currentTime() {
			var now = new Date();

			var year = now.getFullYear();

			var month = now.getMonth() + 1;
			var date = now.getDate();

			var str_week = '星期天,星期一,星期二,星期三,星期四,星期五,星期六'.split(',');
			var week = str_week[now.getDay()];
			var hour = now.getHours();
			var min = now.getMinutes();
			var sec = now.getSeconds();

			hour = hour < 10 ? '0' + hour : hour;
			min = min < 10 ? '0' + min : min;
			sec = sec < 10 ? '0' + sec : sec;

			var res = year + '-' + month + '-' + date + '' + ' ' + week + ' ' + hour + ':' + min + ':' + sec;

			return res;
		},

		toTop: function toTop() {
			var scrollTop = window.scrollY;
			var speed = scrollTop / 20;
			scrollTop = scrollTop - speed;

			if (scrollTop <= 10) {
				clearInterval(timer);
				scrollTop = 0;
			}

			window.scrollTo(0, scrollTop);
		},

		getElement: function getElement(nodes) {
			var res = [];

			for (var i = 0; i < nodes.length; i++) {
				if (nodes[i].nodeType === 1) {
					res.push(nodes[i]);
				}
			}
			return res;
		},

		getStyle: function getStyle(ele, attr) {
			var res;
			if (window.getComputedStyle) {
				res = getComputedStyle(ele)[attr];
			} else if (ele.currentStyle) {
				res = ele.currentStyle[attr];
			} else {
				res = ele.style[attr];
			}

			return res;
		},

		addEvent: function addEvent(ele, type, handler, capture) {
			if (ele.addEventListener) {
				ele.addEventListener(type, handler, capture);
			} else if (ele.attachEvent) {
					ele.attachEvent('on' + type, handler);
				} else {
						ele['on' + type] = handler;
					}
		},

		setCookie: function setCookie(name, val, expires, path) {
			var str_cookie = name + '=' + val;

			if (expires) {
				str_cookie += ';expires=' + expires;
			}

			if (path) {
				str_cookie += ';path=' + path;
			}

			document.cookie = str_cookie;
		},

		removeCookie: function removeCookie(name) {
			var now = new Date();
			now.setDate(now.getDate() - 1);
			now = now.toUTCString();

			setCookie(name, null, now);
		},

		getCookie: function getCookie(name) {
			var cookies = document.cookie;
			if (!cookies) {
				return '';
			}

			var res = '';
			var arr = cookies.split('; ');
			arr.forEach(function (item) {
				var temp = item.split('=');
				if (temp[0] === name) {
					res = temp[1];
				}
			});

			return res;
		},

		animate: function animate(ele, opt, callback) {
			var timerLen = 0;

			for (var attr in opt) {
				timerLen++;

				createTimer(attr);
			}

			function createTimer(attr) {
				var target = opt[attr];

				var timerName = attr + 'timer';

				clearInterval(ele[timerName]);

				ele[timerName] = setInterval(function () {
					var current = getStyle(ele, attr);
					var unit = current.match(/[a-z]+$/i);
					unit = unit ? unit[0] : '';

					current = parseFloat(current);

					var speed = (target - current) / 10;
					if (attr === 'opacity') {
						speed = speed > 0 ? 0.1 : -0.1;
					} else {
						speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
					}

					if (speed === 0 || current === target) {
						clearInterval(ele[timerName]);

						current = target - speed;

						timerLen--;

						if (typeof callback === 'function' && timerLen === 0) {
							callback();
						}
					}

					ele.style[attr] = current + speed + unit;
				}, 50);
			}
		},

		ajax: function ajax(opt) {

			if (!opt.type) {
				opt.type = 'get';
			}
			if (!opt.async) {
				opt.async = true;
			}

			var xhr = null;
			try {
				xhr = new XMLHttpRequest();
			} catch (err) {
				try {
					xhr = new ActiveXObject("Msxml2.XMLHTTP");
				} catch (err) {
					try {
						xhr = new ActiveXObject("Microsoft.XMLHTTP");
					} catch (err) {
						alert('你的浏览器太low了，换个浏览器吧');
					}
				}
			}

			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status)) {
					opt.callback(xhr.responseText);
				}
			};

			for (var attr in opt.data) {
				var res = '?';
				res += attr + '=' + opt.data[attr] + '&';
			}
			res = res.splice(0, -1);

			if (opt.type === 'get') {

				xhr.open(opt.type, opt.url + res, opt.async);
				xhr.send();
			}

			if (opt.type === 'post') {

				xhr.open(opt.type, opt.url, opt.async);

				xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
				xhr.send(res);
			}
		},

		type: function type(data) {
			return Object.prototype.toString.call(data).slice(8, -1).toLowerCase();
		}
	};
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js__);




window.pinyin_dict_notone = __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default.a;

;(function () {
	var dict = {};
	var pinyinUtil = {
		parseDict: function parseDict() {
			if (window.pinyin_dict_firstletter) {
				dict.firstletter = pinyin_dict_firstletter;
			}

			if (window.pinyin_dict_notone) {
				dict.notone = {};
				dict.py2hz = __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default.a;
				for (var i in __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default.a) {
					var temp = __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default.a[i];
					for (var j = 0, len = temp.length; j < len; j++) {
						dict.notone[temp[j]] = i;
					}
				}
			}

			if (window.pinyin_dict_withtone) {
				dict.withtone = {};
				var temp = pinyin_dict_withtone.split(',');
				for (var i = 0, len = temp.length; i < len; i++) {
					dict.withtone[String.fromCharCode(i + 19968)] = temp[i];
				}

				if (window.pinyin_dict_notone) {
					dict.py2hz = __WEBPACK_IMPORTED_MODULE_1__pinyin_dict_notone_js___default.a;
				} else {
					var notone = pinyinUtil.removeTone(pinyin_dict_withtone).split(',');
					var py2hz = {},
					    py,
					    hz;
					for (var i = 0, len = notone.length; i < len; i++) {
						hz = String.fromCharCode(i + 19968);
						py = notone[i].split(' ');
						for (var j = 0; j < py.length; j++) {
							py2hz[py[j]] = (py2hz[py[j]] || '') + hz;
						}
					}
					dict.py2hz = py2hz;
				}
			}
		},

		getPinyin: function getPinyin(chinese, splitter, withtone, polyphone) {
			if (!chinese || /^ +$/g.test(chinese)) return '';
			splitter = splitter == undefined ? ' ' : splitter;
			withtone = withtone == undefined ? true : withtone;
			polyphone = polyphone == undefined ? false : polyphone;
			var result = [];
			if (dict.withtone) {
					for (var i = 0, len = chinese.length; i < len; i++) {
						var pinyin = dict.withtone[chinese[i]];
						if (pinyin) {
							if (!polyphone) pinyin = pinyin.replace(/ .*$/g, '');
							if (!withtone) pinyin = this.removeTone(pinyin);
						}
						result.push(pinyin || chinese[i]);
					}
				} else if (dict.notone) {
					if (withtone) console.warn('pinyin_dict_notone 字典文件不支持声调！');
					if (polyphone) console.warn('pinyin_dict_notone 字典文件不支持多音字！');
					for (var i = 0, len = chinese.length; i < len; i++) {
						var temp = chinese.charAt(i);
						result.push(dict.notone[temp] || temp);
					}
				} else {
				throw '抱歉，未找到合适的拼音字典文件！';
			}
			if (!polyphone) return result.join(splitter);else {
				if (window.pinyin_dict_polyphone) return parsePolyphone(chinese, result, splitter, withtone);else return handlePolyphone(result, ' ', splitter);
			}
		},

		getFirstLetter: function getFirstLetter(str, polyphone) {
			polyphone = polyphone == undefined ? false : polyphone;
			if (!str || /^ +$/g.test(str)) return '';
			if (dict.firstletter) {
					var result = [];
					for (var i = 0; i < str.length; i++) {
						var unicode = str.charCodeAt(i);
						var ch = str.charAt(i);
						if (unicode >= 19968 && unicode <= 40869) {
							ch = dict.firstletter.all.charAt(unicode - 19968);
							if (polyphone) ch = dict.firstletter.polyphone[unicode] || ch;
						}
						result.push(ch);
					}
					if (!polyphone) return result.join('');else return handlePolyphone(result, '', '');
				} else {
				var py = this.getPinyin(str, ' ', false, polyphone);
				py = py instanceof Array ? py : [py];
				var result = [];
				for (var i = 0; i < py.length; i++) {
					result.push(py[i].replace(/(^| )(\w)\w*/g, function (m, $1, $2) {
						return $2.toUpperCase();
					}));
				}
				if (!polyphone) return result[0];else return simpleUnique(result);
			}
		},

		getHanzi: function getHanzi(pinyin) {
			if (!dict.py2hz) {
				throw '抱歉，未找到合适的拼音字典文件！';
			}
			return dict.py2hz[pinyin] || '';
		},

		removeTone: function removeTone(pinyin) {
			var toneMap = {
				"ā": "a1",
				"á": "a2",
				"ǎ": "a3",
				"à": "a4",
				"ō": "o1",
				"ó": "o2",
				"ǒ": "o3",
				"ò": "o4",
				"ē": "e1",
				"é": "e2",
				"ě": "e3",
				"è": "e4",
				"ī": "i1",
				"í": "i2",
				"ǐ": "i3",
				"ì": "i4",
				"ū": "u1",
				"ú": "u2",
				"ǔ": "u3",
				"ù": "u4",
				"ü": "v0",
				"ǖ": "v1",
				"ǘ": "v2",
				"ǚ": "v3",
				"ǜ": "v4",
				"ń": "n2",
				"ň": "n3",
				"": "m2"
			};
			return pinyin.replace(/[āáǎàōóǒòēéěèīíǐìūúǔùüǖǘǚǜńň]/g, function (m) {
				return toneMap[m][0];
			});
		}
	};

	function handlePolyphone(array, splitter, joinChar) {
		splitter = splitter || '';
		var result = [''],
		    temp = [];
		for (var i = 0; i < array.length; i++) {
			temp = [];
			var t = array[i].split(splitter);
			for (var j = 0; j < t.length; j++) {
				for (var k = 0; k < result.length; k++) {
					temp.push(result[k] + (result[k] ? joinChar : '') + t[j]);
				}
			}
			result = temp;
		}
		return simpleUnique(result);
	}

	function parsePolyphone(chinese, result, splitter, withtone) {
		var poly = window.pinyin_dict_polyphone;
		var max = 7;
		var temp = poly[chinese];
		if (temp) {
				temp = temp.split(' ');
				for (var i = 0; i < temp.length; i++) {
					result[i] = temp[i] || result[i];
					if (!withtone) result[i] = pinyinUtil.removeTone(result[i]);
				}
				return result.join(splitter);
			}
		for (var i = 0; i < chinese.length; i++) {
			temp = '';
			for (var j = 0; j < max && i + j < chinese.length; j++) {
				if (!/^[\u2E80-\u9FFF]+$/.test(chinese[i + j])) break;
				temp += chinese[i + j];
				var res = poly[temp];
				if (res) {
						res = res.split(' ');
						for (var k = 0; k <= j; k++) {
							if (res[k]) result[i + k] = withtone ? res[k] : pinyinUtil.removeTone(res[k]);
						}
						break;
					}
			}
		}

		for (var i = 0; i < result.length; i++) {
			result[i] = result[i].replace(/ .*$/g, '');
		}
		return result.join(splitter);
	}

	function simpleUnique(array) {
		var result = [];
		var hash = {};
		for (var i = 0; i < array.length; i++) {
			var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(array[i]) + array[i];
			if (!hash[key]) {
				result.push(array[i]);
				hash[key] = true;
			}
		}
		return result;
	}

	pinyinUtil.parseDict();
	pinyinUtil.dict = dict;
	window.pinyinUtil = pinyinUtil;
})();

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_App__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_rangeDetails__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_rangeDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_rangeDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_search__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_newSong__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_newSong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_newSong__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_range__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_songSheet__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_songSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_songSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_singer__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_singer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_singer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_db__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_db___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_db__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mod__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_mod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_passageDetail__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_passageDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_passageDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_song__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_song___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_song__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_connection__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_connection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_connection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_register_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_login_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_shoucang_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_shoucang_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_shoucang_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ZhenV_RT_xtotallist_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ZhenV_RT_xtotallist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ZhenV_RT_xtotallist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ZhenV_RT_xsong_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ZhenV_RT_xsong_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ZhenV_RT_xsong_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ZhenV_RT_xsinglist_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ZhenV_RT_xsinglist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ZhenV_RT_xsinglist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_search_hotSearch_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_search_hotSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_search_hotSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_search_keywordSearch_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_search_keywordSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_search_keywordSearch_vue__);


























/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/app',
    component: __WEBPACK_IMPORTED_MODULE_0__views_App___default.a,
    children: [{
        path: 'newSong',
        component: __WEBPACK_IMPORTED_MODULE_3__views_newSong___default.a
    }, {
        path: 'range',
        component: __WEBPACK_IMPORTED_MODULE_4__views_range___default.a
    }, {
        path: 'songSheet',
        component: __WEBPACK_IMPORTED_MODULE_5__views_songSheet___default.a
    }, {
        path: 'singer',
        component: __WEBPACK_IMPORTED_MODULE_6__views_singer___default.a,
        children: [{
            path: 'tolist',
            component: __WEBPACK_IMPORTED_MODULE_15__components_ZhenV_RT_xtotallist_vue___default.a
        }, {
            path: '/app/singer',
            redirect: '/app/singer/tolist'
        }]
    }]
}, {
    path: '/rangeDetails/:id',
    component: __WEBPACK_IMPORTED_MODULE_1__views_rangeDetails___default.a
}, {
    path: '/singlist/:id',
    component: __WEBPACK_IMPORTED_MODULE_17__components_ZhenV_RT_xsinglist_vue___default.a
}, {
    path: '/xsong/:id',
    component: __WEBPACK_IMPORTED_MODULE_16__components_ZhenV_RT_xsong_vue___default.a
}, {
    path: '/db',
    component: __WEBPACK_IMPORTED_MODULE_7__views_db___default.a
}, {
    path: '/mod/:id',
    component: __WEBPACK_IMPORTED_MODULE_8__views_mod___default.a
}, {
    path: '/passageDetail/:id',
    component: __WEBPACK_IMPORTED_MODULE_9__views_passageDetail___default.a
}, {
    path: "/song",
    component: __WEBPACK_IMPORTED_MODULE_10__views_song___default.a
}, {
    path: '/register',
    component: __WEBPACK_IMPORTED_MODULE_12__views_register_vue___default.a
}, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_13__views_login_vue___default.a
}, {
    path: '/search',
    component: __WEBPACK_IMPORTED_MODULE_2__views_search___default.a,
    children: [{
        path: 'hotSearch',
        component: __WEBPACK_IMPORTED_MODULE_18__components_search_hotSearch_vue___default.a
    }, {
        path: 'keywordSearch',
        component: __WEBPACK_IMPORTED_MODULE_19__components_search_keywordSearch_vue___default.a
    }, {
        path: '/search',
        redirect: '/search/hotSearch'
    }]
}, {
    path: '/shoucang',
    component: __WEBPACK_IMPORTED_MODULE_14__views_shoucang_vue___default.a
}, {
    path: '/connection',
    component: __WEBPACK_IMPORTED_MODULE_11__views_connection___default.a
}, {
    path: '/',
    redirect: '/app/newSong'
}]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        newSong: null,
        newClass: null,
        newDetails: null,
        range_id: null,
        range_page: 1,
        songsPlay: [],
        scrolly: null,
        showComment: false,

        showPlay: false,
        imgUrl: '',
        isshow: false,
        getIndex: null,
        getMusic: null,

        record: '',

        direction: 'left',
        telephone: '',
        password: '',

        singername: [],
        louti: false,
        zimu: null,
        commentNum: null,
        isShowContainer: true,
        loginStatus: null,

        recordCover: '',
        zxrm: null,
        newsearch: '',
        getsearch: null,
        newId: 1,
        newComment: null,
        newCommentCount: null,
        arrHight: [],
        getshou: [],
        sildeShow: false,
        baseUrl: 'https://bird.ioliu.cn/v1?url=http://mobilecdn.kugou.com',
        baseUrlsetRecord: 'https://bird.ioliu.cn/v1?url=http://www.kugou.com',
        baseUrlMusic: 'https://bird.ioliu.cn/v1?url=http://m.kugou.com'
    },
    getters: {
        getRange: function getRange(state) {
            return state.newClass;
        },
        getDetails: function getDetails(state) {
            return state.newDetails;
        },
        giePage: function giePage(state) {
            return state.range_page;
        },
        getImgurl: function getImgurl(state) {
            return state.imgUrl;
        },
        showPlay: function showPlay(state) {
            return state.showPlay;
        },
        songsPlay: function songsPlay(state) {
            return state.songsPlay;
        },
        Index: function Index(state) {
            return state.getIndex;
        },
        newMusic: function newMusic(state) {
            return state.getMusic;
        },
        getRecord: function getRecord(state) {
            return state.record;
        },
        getrecordCover: function getrecordCover(state) {
            return state.recordCover = state.record[0].cover;
        },
        getzxrm: function getzxrm(state) {
            return state.zxrm;
        },
        getsearch: function getsearch(state) {
            return state.getsearch;
        },
        getId: function getId(state) {
            return state.newId;
        }
    },
    mutations: {
        getMusic: function getMusic(state) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:6787/').then(function (response) {
                state.newSong = response.data;
                console.log(state.newSong);
            }).catch(function (error) {
                console.log(error);
            });
        },
        getRange: function getRange(state) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrlMusic + '/rank/list&json=true').then(function (response) {
                state.newClass = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        rangeDetails: function rangeDetails(state) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrlMusic + '/rank/info/?rankid=' + state.range_id + '&page=' + state.range_page + '&json=true', {}).then(function (response) {
                state.newDetails = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        setDetails: function setDetails(state, data) {
            state.range_id = data;
        },
        setPage: function setPage(state, data) {
            state.range_page = data;
        },
        setImg: function setImg(state, data) {
            state.imgUrl = data[0];
            state.showPlay = data[1];
        },
        setSongs: function setSongs(state, data) {
            state.songsPlay = data;
        },
        setIndex: function setIndex(state, data) {
            state.getIndex = data;
        },
        setMusic: function setMusic(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrlMusic + '/app/i/getSongInfo.php?cmd=playInfo&hash=' + data).then(function (response) {
                state.getMusic = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        setRecord: function setRecord(state, data) {
            var arr = [];
            data.forEach(function (item) {
                item.hash;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrlsetRecord + '/yy/index.php?r=play/getdata&hash=' + item.hash).then(function (response) {
                    var temp = {};
                    temp.name = response.data.data.song_name;
                    temp.author = response.data.data.author_name;
                    temp.src = response.data.data.play_url;
                    temp.cover = response.data.data.img.replace('{size}', '400');
                    temp.lyric = response.data.data.lyrics;
                    arr.push(temp);
                }).catch(function (error) {
                    console.log(error);
                });
            });
            state.record = arr;
        },
        setrecordCover: function setrecordCover(state, data) {
            state.recordCover = data;
        },
        getzxrm: function getzxrm(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrl + '/api/v3/search/hot?format=json&plat=0&count=30').then(function (response) {
                state.zxrm = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        setsearch: function setsearch(state, data) {
            state.newsearch = data;
        },
        getsearch: function getsearch(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(state.baseUrl + '/api/v3/search/song?format=json&keyword=' + state.newsearch + '&page=' + state.newId + '&pagesize=30&showtype=1').then(function (response) {
                state.getsearch = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        },
        setId: function setId(state, data) {
            state.newId = data;
        },
        setgq: function setgq(state, data) {
            state.newsearch = data;
        }
    },
    actions: {
        getMusic: function getMusic(context, data) {
            context.commit('getMusic');
        },
        getRange: function getRange(context, data) {
            context.commit('getRange');
        },
        rangeDetails: function rangeDetails(context, data) {
            context.commit('rangeDetails');
        },
        setDetails: function setDetails(context, data) {
            context.commit('setDetails', data);
        },
        setPage: function setPage(context, data) {
            context.commit('setPage', data);
        },
        setImg: function setImg(context, data) {
            context.commit("setImg", data);
        },
        setSongs: function setSongs(context, data) {
            context.commit("setSongs", data);
        },
        setIndex: function setIndex(context, data) {
            context.commit("setIndex", data);
        },
        setMusic: function setMusic(context, data) {
            context.commit("setMusic", data);
        },
        setRecord: function setRecord(context, data) {
            context.commit('setRecord', data);
        },
        setrecordCover: function setrecordCover(context, data) {
            context.commit('setrecordCover', data);
        },
        getzxrm: function getzxrm(context, data) {
            context.commit("getzxrm", data);
        },
        setsearch: function setsearch(context, data) {
            context.commit("setsearch", data);
        },
        getsearch: function getsearch(context, data) {
            context.commit("getsearch", data);
        },
        setId: function setId(context, data) {
            context.commit("setId", data);
        },
        setgq: function setgq(context, data) {
            context.commit("setgq", data);
        }
    }
});

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _pinyin_dict_firstlet;

var pinyin_dict_firstletter = {};

pinyin_dict_firstletter.all = "YDYQSXMWZSSXJBYMGCCZQPSSQBYCDSCDQLDYLYBSSJGYZZJJFKCCLZDHWDWZJLJPFYYNWJJTMYHZWZHFLZPPQHGSCYYYNJQYXXGJHHSDSJNKKTMOMLCRXYPSNQSECCQZGGLLYJLMYZZSECYKYYHQWJSSGGYXYZYJWWKDJHYCHMYXJTLXJYQBYXZLDWRDJRWYSRLDZJPCBZJJBRCFTLECZSTZFXXZHTRQHYBDLYCZSSYMMRFMYQZPWWJJYFCRWFDFZQPYDDWYXKYJAWJFFXYPSFTZYHHYZYSWCJYXSCLCXXWZZXNBGNNXBXLZSZSBSGPYSYZDHMDZBQBZCWDZZYYTZHBTSYYBZGNTNXQYWQSKBPHHLXGYBFMJEBJHHGQTJCYSXSTKZHLYCKGLYSMZXYALMELDCCXGZYRJXSDLTYZCQKCNNJWHJTZZCQLJSTSTBNXBTYXCEQXGKWJYFLZQLYHYXSPSFXLMPBYSXXXYDJCZYLLLSJXFHJXPJBTFFYABYXBHZZBJYZLWLCZGGBTSSMDTJZXPTHYQTGLJSCQFZKJZJQNLZWLSLHDZBWJNCJZYZSQQYCQYRZCJJWYBRTWPYFTWEXCSKDZCTBZHYZZYYJXZCFFZZMJYXXSDZZOTTBZLQWFCKSZSXFYRLNYJMBDTHJXSQQCCSBXYYTSYFBXDZTGBCNSLCYZZPSAZYZZSCJCSHZQYDXLBPJLLMQXTYDZXSQJTZPXLCGLQTZWJBHCTSYJSFXYEJJTLBGXSXJMYJQQPFZASYJNTYDJXKJCDJSZCBARTDCLYJQMWNQNCLLLKBYBZZSYHQQLTWLCCXTXLLZNTYLNEWYZYXCZXXGRKRMTCNDNJTSYYSSDQDGHSDBJGHRWRQLYBGLXHLGTGXBQJDZPYJSJYJCTMRNYMGRZJCZGJMZMGXMPRYXKJNYMSGMZJYMKMFXMLDTGFBHCJHKYLPFMDXLQJJSMTQGZSJLQDLDGJYCALCMZCSDJLLNXDJFFFFJCZFMZFFPFKHKGDPSXKTACJDHHZDDCRRCFQYJKQCCWJDXHWJLYLLZGCFCQDSMLZPBJJPLSBCJGGDCKKDEZSQCCKJGCGKDJTJDLZYCXKLQSCGJCLTFPCQCZGWPJDQYZJJBYJHSJDZWGFSJGZKQCCZLLPSPKJGQJHZZLJPLGJGJJTHJJYJZCZMLZLYQBGJWMLJKXZDZNJQSYZMLJLLJKYWXMKJLHSKJGBMCLYYMKXJQLBMLLKMDXXKWYXYSLMLPSJQQJQXYXFJTJDXMXXLLCXQBSYJBGWYMBGGBCYXPJYGPEPFGDJGBHBNSQJYZJKJKHXQFGQZKFHYGKHDKLLSDJQXPQYKYBNQSXQNSZSWHBSXWHXWBZZXDMNSJBSBKBBZKLYLXGWXDRWYQZMYWSJQLCJXXJXKJEQXSCYETLZHLYYYSDZPAQYZCMTLSHTZCFYZYXYLJSDCJQAGYSLCQLYYYSHMRQQKLDXZSCSSSYDYCJYSFSJBFRSSZQSBXXPXJYSDRCKGJLGDKZJZBDKTCSYQPYHSTCLDJDHMXMCGXYZHJDDTMHLTXZXYLYMOHYJCLTYFBQQXPFBDFHHTKSQHZYYWCNXXCRWHOWGYJLEGWDQCWGFJYCSNTMYTOLBYGWQWESJPWNMLRYDZSZTXYQPZGCWXHNGPYXSHMYQJXZTDPPBFYHZHTJYFDZWKGKZBLDNTSXHQEEGZZYLZMMZYJZGXZXKHKSTXNXXWYLYAPSTHXDWHZYMPXAGKYDXBHNHXKDPJNMYHYLPMGOCSLNZHKXXLPZZLBMLSFBHHGYGYYGGBHSCYAQTYWLXTZQCEZYDQDQMMHTKLLSZHLSJZWFYHQSWSCWLQAZYNYTLSXTHAZNKZZSZZLAXXZWWCTGQQTDDYZTCCHYQZFLXPSLZYGPZSZNGLNDQTBDLXGTCTAJDKYWNSYZLJHHZZCWNYYZYWMHYCHHYXHJKZWSXHZYXLYSKQYSPSLYZWMYPPKBYGLKZHTYXAXQSYSHXASMCHKDSCRSWJPWXSGZJLWWSCHSJHSQNHCSEGNDAQTBAALZZMSSTDQJCJKTSCJAXPLGGXHHGXXZCXPDMMHLDGTYBYSJMXHMRCPXXJZCKZXSHMLQXXTTHXWZFKHCCZDYTCJYXQHLXDHYPJQXYLSYYDZOZJNYXQEZYSQYAYXWYPDGXDDXSPPYZNDLTWRHXYDXZZJHTCXMCZLHPYYYYMHZLLHNXMYLLLMDCPPXHMXDKYCYRDLTXJCHHZZXZLCCLYLNZSHZJZZLNNRLWHYQSNJHXYNTTTKYJPYCHHYEGKCTTWLGQRLGGTGTYGYHPYHYLQYQGCWYQKPYYYTTTTLHYHLLTYTTSPLKYZXGZWGPYDSSZZDQXSKCQNMJJZZBXYQMJRTFFBTKHZKBXLJJKDXJTLBWFZPPTKQTZTGPDGNTPJYFALQMKGXBDCLZFHZCLLLLADPMXDJHLCCLGYHDZFGYDDGCYYFGYDXKSSEBDHYKDKDKHNAXXYBPBYYHXZQGAFFQYJXDMLJCSQZLLPCHBSXGJYNDYBYQSPZWJLZKSDDTACTBXZDYZYPJZQSJNKKTKNJDJGYYPGTLFYQKASDNTCYHBLWDZHBBYDWJRYGKZYHEYYFJMSDTYFZJJHGCXPLXHLDWXXJKYTCYKSSSMTWCTTQZLPBSZDZWZXGZAGYKTYWXLHLSPBCLLOQMMZSSLCMBJCSZZKYDCZJGQQDSMCYTZQQLWZQZXSSFPTTFQMDDZDSHDTDWFHTDYZJYQJQKYPBDJYYXTLJHDRQXXXHAYDHRJLKLYTWHLLRLLRCXYLBWSRSZZSYMKZZHHKYHXKSMDSYDYCJPBZBSQLFCXXXNXKXWYWSDZYQOGGQMMYHCDZTTFJYYBGSTTTYBYKJDHKYXBELHTYPJQNFXFDYKZHQKZBYJTZBXHFDXKDASWTAWAJLDYJSFHBLDNNTNQJTJNCHXFJSRFWHZFMDRYJYJWZPDJKZYJYMPCYZNYNXFBYTFYFWYGDBNZZZDNYTXZEMMQBSQEHXFZMBMFLZZSRXYMJGSXWZJSPRYDJSJGXHJJGLJJYNZZJXHGXKYMLPYYYCXYTWQZSWHWLYRJLPXSLSXMFSWWKLCTNXNYNPSJSZHDZEPTXMYYWXYYSYWLXJQZQXZDCLEEELMCPJPCLWBXSQHFWWTFFJTNQJHJQDXHWLBYZNFJLALKYYJLDXHHYCSTYYWNRJYXYWTRMDRQHWQCMFJDYZMHMYYXJWMYZQZXTLMRSPWWCHAQBXYGZYPXYYRRCLMPYMGKSJSZYSRMYJSNXTPLNBAPPYPYLXYYZKYNLDZYJZCZNNLMZHHARQMPGWQTZMXXMLLHGDZXYHXKYXYCJMFFYYHJFSBSSQLXXNDYCANNMTCJCYPRRNYTYQNYYMBMSXNDLYLYSLJRLXYSXQMLLYZLZJJJKYZZCSFBZXXMSTBJGNXYZHLXNMCWSCYZYFZLXBRNNNYLBNRTGZQYSATSWRYHYJZMZDHZGZDWYBSSCSKXSYHYTXXGCQGXZZSHYXJSCRHMKKBXCZJYJYMKQHZJFNBHMQHYSNJNZYBKNQMCLGQHWLZNZSWXKHLJHYYBQLBFCDSXDLDSPFZPSKJYZWZXZDDXJSMMEGJSCSSMGCLXXKYYYLNYPWWWGYDKZJGGGZGGSYCKNJWNJPCXBJJTQTJWDSSPJXZXNZXUMELPXFSXTLLXCLJXJJLJZXCTPSWXLYDHLYQRWHSYCSQYYBYAYWJJJQFWQCQQCJQGXALDBZZYJGKGXPLTZYFXJLTPADKYQHPMATLCPDCKBMTXYBHKLENXDLEEGQDYMSAWHZMLJTWYGXLYQZLJEEYYBQQFFNLYXRDSCTGJGXYYNKLLYQKCCTLHJLQMKKZGCYYGLLLJDZGYDHZWXPYSJBZKDZGYZZHYWYFQYTYZSZYEZZLYMHJJHTSMQWYZLKYYWZCSRKQYTLTDXWCTYJKLWSQZWBDCQYNCJSRSZJLKCDCDTLZZZACQQZZDDXYPLXZBQJYLZLLLQDDZQJYJYJZYXNYYYNYJXKXDAZWYRDLJYYYRJLXLLDYXJCYWYWNQCCLDDNYYYNYCKCZHXXCCLGZQJGKWPPCQQJYSBZZXYJSQPXJPZBSBDSFNSFPZXHDWZTDWPPTFLZZBZDMYYPQJRSDZSQZSQXBDGCPZSWDWCSQZGMDHZXMWWFYBPDGPHTMJTHZSMMBGZMBZJCFZWFZBBZMQCFMBDMCJXLGPNJBBXGYHYYJGPTZGZMQBQTCGYXJXLWZKYDPDYMGCFTPFXYZTZXDZXTGKMTYBBCLBJASKYTSSQYYMSZXFJEWLXLLSZBQJJJAKLYLXLYCCTSXMCWFKKKBSXLLLLJYXTYLTJYYTDPJHNHNNKBYQNFQYYZBYYESSESSGDYHFHWTCJBSDZZTFDMXHCNJZYMQWSRYJDZJQPDQBBSTJGGFBKJBXTGQHNGWJXJGDLLTHZHHYYYYYYSXWTYYYCCBDBPYPZYCCZYJPZYWCBDLFWZCWJDXXHYHLHWZZXJTCZLCDPXUJCZZZLYXJJTXPHFXWPYWXZPTDZZBDZCYHJHMLXBQXSBYLRDTGJRRCTTTHYTCZWMXFYTWWZCWJWXJYWCSKYBZSCCTZQNHXNWXXKHKFHTSWOCCJYBCMPZZYKBNNZPBZHHZDLSYDDYTYFJPXYNGFXBYQXCBHXCPSXTYZDMKYSNXSXLHKMZXLYHDHKWHXXSSKQYHHCJYXGLHZXCSNHEKDTGZXQYPKDHEXTYKCNYMYYYPKQYYYKXZLTHJQTBYQHXBMYHSQCKWWYLLHCYYLNNEQXQWMCFBDCCMLJGGXDQKTLXKGNQCDGZJWYJJLYHHQTTTNWCHMXCXWHWSZJYDJCCDBQCDGDNYXZTHCQRXCBHZTQCBXWGQWYYBXHMBYMYQTYEXMQKYAQYRGYZSLFYKKQHYSSQYSHJGJCNXKZYCXSBXYXHYYLSTYCXQTHYSMGSCPMMGCCCCCMTZTASMGQZJHKLOSQYLSWTMXSYQKDZLJQQYPLSYCZTCQQPBBQJZCLPKHQZYYXXDTDDTSJCXFFLLCHQXMJLWCJCXTSPYCXNDTJSHJWXDQQJSKXYAMYLSJHMLALYKXCYYDMNMDQMXMCZNNCYBZKKYFLMCHCMLHXRCJJHSYLNMTJZGZGYWJXSRXCWJGJQHQZDQJDCJJZKJKGDZQGJJYJYLXZXXCDQHHHEYTMHLFSBDJSYYSHFYSTCZQLPBDRFRZTZYKYWHSZYQKWDQZRKMSYNBCRXQBJYFAZPZZEDZCJYWBCJWHYJBQSZYWRYSZPTDKZPFPBNZTKLQYHBBZPNPPTYZZYBQNYDCPJMMCYCQMCYFZZDCMNLFPBPLNGQJTBTTNJZPZBBZNJKLJQYLNBZQHKSJZNGGQSZZKYXSHPZSNBCGZKDDZQANZHJKDRTLZLSWJLJZLYWTJNDJZJHXYAYNCBGTZCSSQMNJPJYTYSWXZFKWJQTKHTZPLBHSNJZSYZBWZZZZLSYLSBJHDWWQPSLMMFBJDWAQYZTCJTBNNWZXQXCDSLQGDSDPDZHJTQQPSWLYYJZLGYXYZLCTCBJTKTYCZJTQKBSJLGMGZDMCSGPYNJZYQYYKNXRPWSZXMTNCSZZYXYBYHYZAXYWQCJTLLCKJJTJHGDXDXYQYZZBYWDLWQCGLZGJGQRQZCZSSBCRPCSKYDZNXJSQGXSSJMYDNSTZTPBDLTKZWXQWQTZEXNQCZGWEZKSSBYBRTSSSLCCGBPSZQSZLCCGLLLZXHZQTHCZMQGYZQZNMCOCSZJMMZSQPJYGQLJYJPPLDXRGZYXCCSXHSHGTZNLZWZKJCXTCFCJXLBMQBCZZWPQDNHXLJCTHYZLGYLNLSZZPCXDSCQQHJQKSXZPBAJYEMSMJTZDXLCJYRYYNWJBNGZZTMJXLTBSLYRZPYLSSCNXPHLLHYLLQQZQLXYMRSYCXZLMMCZLTZSDWTJJLLNZGGQXPFSKYGYGHBFZPDKMWGHCXMSGDXJMCJZDYCABXJDLNBCDQYGSKYDQTXDJJYXMSZQAZDZFSLQXYJSJZYLBTXXWXQQZBJZUFBBLYLWDSLJHXJYZJWTDJCZFQZQZZDZSXZZQLZCDZFJHYSPYMPQZMLPPLFFXJJNZZYLSJEYQZFPFZKSYWJJJHRDJZZXTXXGLGHYDXCSKYSWMMZCWYBAZBJKSHFHJCXMHFQHYXXYZFTSJYZFXYXPZLCHMZMBXHZZSXYFYMNCWDABAZLXKTCSHHXKXJJZJSTHYGXSXYYHHHJWXKZXSSBZZWHHHCWTZZZPJXSNXQQJGZYZYWLLCWXZFXXYXYHXMKYYSWSQMNLNAYCYSPMJKHWCQHYLAJJMZXHMMCNZHBHXCLXTJPLTXYJHDYYLTTXFSZHYXXSJBJYAYRSMXYPLCKDUYHLXRLNLLSTYZYYQYGYHHSCCSMZCTZQXKYQFPYYRPFFLKQUNTSZLLZMWWTCQQYZWTLLMLMPWMBZSSTZRBPDDTLQJJBXZCSRZQQYGWCSXFWZLXCCRSZDZMCYGGDZQSGTJSWLJMYMMZYHFBJDGYXCCPSHXNZCSBSJYJGJMPPWAFFYFNXHYZXZYLREMZGZCYZSSZDLLJCSQFNXZKPTXZGXJJGFMYYYSNBTYLBNLHPFZDCYFBMGQRRSSSZXYSGTZRNYDZZCDGPJAFJFZKNZBLCZSZPSGCYCJSZLMLRSZBZZLDLSLLYSXSQZQLYXZLSKKBRXBRBZCYCXZZZEEYFGKLZLYYHGZSGZLFJHGTGWKRAAJYZKZQTSSHJJXDCYZUYJLZYRZDQQHGJZXSSZBYKJPBFRTJXLLFQWJHYLQTYMBLPZDXTZYGBDHZZRBGXHWNJTJXLKSCFSMWLSDQYSJTXKZSCFWJLBXFTZLLJZLLQBLSQMQQCGCZFPBPHZCZJLPYYGGDTGWDCFCZQYYYQYSSCLXZSKLZZZGFFCQNWGLHQYZJJCZLQZZYJPJZZBPDCCMHJGXDQDGDLZQMFGPSYTSDYFWWDJZJYSXYYCZCYHZWPBYKXRYLYBHKJKSFXTZJMMCKHLLTNYYMSYXYZPYJQYCSYCWMTJJKQYRHLLQXPSGTLYYCLJSCPXJYZFNMLRGJJTYZBXYZMSJYJHHFZQMSYXRSZCWTLRTQZSSTKXGQKGSPTGCZNJSJCQCXHMXGGZTQYDJKZDLBZSXJLHYQGGGTHQSZPYHJHHGYYGKGGCWJZZYLCZLXQSFTGZSLLLMLJSKCTBLLZZSZMMNYTPZSXQHJCJYQXYZXZQZCPSHKZZYSXCDFGMWQRLLQXRFZTLYSTCTMJCXJJXHJNXTNRZTZFQYHQGLLGCXSZSJDJLJCYDSJTLNYXHSZXCGJZYQPYLFHDJSBPCCZHJJJQZJQDYBSSLLCMYTTMQTBHJQNNYGKYRQYQMZGCJKPDCGMYZHQLLSLLCLMHOLZGDYYFZSLJCQZLYLZQJESHNYLLJXGJXLYSYYYXNBZLJSSZCQQCJYLLZLTJYLLZLLBNYLGQCHXYYXOXCXQKYJXXXYKLXSXXYQXCYKQXQCSGYXXYQXYGYTQOHXHXPYXXXULCYEYCHZZCBWQBBWJQZSCSZSSLZYLKDESJZWMYMCYTSDSXXSCJPQQSQYLYYZYCMDJDZYWCBTJSYDJKCYDDJLBDJJSODZYSYXQQYXDHHGQQYQHDYXWGMMMAJDYBBBPPBCMUUPLJZSMTXERXJMHQNUTPJDCBSSMSSSTKJTSSMMTRCPLZSZMLQDSDMJMQPNQDXCFYNBFSDQXYXHYAYKQYDDLQYYYSSZBYDSLNTFQTZQPZMCHDHCZCWFDXTMYQSPHQYYXSRGJCWTJTZZQMGWJJTJHTQJBBHWZPXXHYQFXXQYWYYHYSCDYDHHQMNMTMWCPBSZPPZZGLMZFOLLCFWHMMSJZTTDHZZYFFYTZZGZYSKYJXQYJZQBHMBZZLYGHGFMSHPZFZSNCLPBQSNJXZSLXXFPMTYJYGBXLLDLXPZJYZJYHHZCYWHJYLSJEXFSZZYWXKZJLUYDTMLYMQJPWXYHXSKTQJEZRPXXZHHMHWQPWQLYJJQJJZSZCPHJLCHHNXJLQWZJHBMZYXBDHHYPZLHLHLGFWLCHYYTLHJXCJMSCPXSTKPNHQXSRTYXXTESYJCTLSSLSTDLLLWWYHDHRJZSFGXTSYCZYNYHTDHWJSLHTZDQDJZXXQHGYLTZPHCSQFCLNJTCLZPFSTPDYNYLGMJLLYCQHYSSHCHYLHQYQTMZYPBYWRFQYKQSYSLZDQJMPXYYSSRHZJNYWTQDFZBWWTWWRXCWHGYHXMKMYYYQMSMZHNGCEPMLQQMTCWCTMMPXJPJJHFXYYZSXZHTYBMSTSYJTTQQQYYLHYNPYQZLCYZHZWSMYLKFJXLWGXYPJYTYSYXYMZCKTTWLKSMZSYLMPWLZWXWQZSSAQSYXYRHSSNTSRAPXCPWCMGDXHXZDZYFJHGZTTSBJHGYZSZYSMYCLLLXBTYXHBBZJKSSDMALXHYCFYGMQYPJYCQXJLLLJGSLZGQLYCJCCZOTYXMTMTTLLWTGPXYMZMKLPSZZZXHKQYSXCTYJZYHXSHYXZKXLZWPSQPYHJWPJPWXQQYLXSDHMRSLZZYZWTTCYXYSZZSHBSCCSTPLWSSCJCHNLCGCHSSPHYLHFHHXJSXYLLNYLSZDHZXYLSXLWZYKCLDYAXZCMDDYSPJTQJZLNWQPSSSWCTSTSZLBLNXSMNYYMJQBQHRZWTYYDCHQLXKPZWBGQYBKFCMZWPZLLYYLSZYDWHXPSBCMLJBSCGBHXLQHYRLJXYSWXWXZSLDFHLSLYNJLZYFLYJYCDRJLFSYZFSLLCQYQFGJYHYXZLYLMSTDJCYHBZLLNWLXXYGYYHSMGDHXXHHLZZJZXCZZZCYQZFNGWPYLCPKPYYPMCLQKDGXZGGWQBDXZZKZFBXXLZXJTPJPTTBYTSZZDWSLCHZHSLTYXHQLHYXXXYYZYSWTXZKHLXZXZPYHGCHKCFSYHUTJRLXFJXPTZTWHPLYXFCRHXSHXKYXXYHZQDXQWULHYHMJTBFLKHTXCWHJFWJCFPQRYQXCYYYQYGRPYWSGSUNGWCHKZDXYFLXXHJJBYZWTSXXNCYJJYMSWZJQRMHXZWFQSYLZJZGBHYNSLBGTTCSYBYXXWXYHXYYXNSQYXMQYWRGYQLXBBZLJSYLPSYTJZYHYZAWLRORJMKSCZJXXXYXCHDYXRYXXJDTSQFXLYLTSFFYXLMTYJMJUYYYXLTZCSXQZQHZXLYYXZHDNBRXXXJCTYHLBRLMBRLLAXKYLLLJLYXXLYCRYLCJTGJCMTLZLLCYZZPZPCYAWHJJFYBDYYZSMPCKZDQYQPBPCJPDCYZMDPBCYYDYCNNPLMTMLRMFMMGWYZBSJGYGSMZQQQZTXMKQWGXLLPJGZBQCDJJJFPKJKCXBLJMSWMDTQJXLDLPPBXCWRCQFBFQJCZAHZGMYKPHYYHZYKNDKZMBPJYXPXYHLFPNYYGXJDBKXNXHJMZJXSTRSTLDXSKZYSYBZXJLXYSLBZYSLHXJPFXPQNBYLLJQKYGZMCYZZYMCCSLCLHZFWFWYXZMWSXTYNXJHPYYMCYSPMHYSMYDYSHQYZCHMJJMZCAAGCFJBBHPLYZYLXXSDJGXDHKXXTXXNBHRMLYJSLTXMRHNLXQJXYZLLYSWQGDLBJHDCGJYQYCMHWFMJYBMBYJYJWYMDPWHXQLDYGPDFXXBCGJSPCKRSSYZJMSLBZZJFLJJJLGXZGYXYXLSZQYXBEXYXHGCXBPLDYHWETTWWCJMBTXCHXYQXLLXFLYXLLJLSSFWDPZSMYJCLMWYTCZPCHQEKCQBWLCQYDPLQPPQZQFJQDJHYMMCXTXDRMJWRHXCJZYLQXDYYNHYYHRSLSRSYWWZJYMTLTLLGTQCJZYABTCKZCJYCCQLJZQXALMZYHYWLWDXZXQDLLQSHGPJFJLJHJABCQZDJGTKHSSTCYJLPSWZLXZXRWGLDLZRLZXTGSLLLLZLYXXWGDZYGBDPHZPBRLWSXQBPFDWOFMWHLYPCBJCCLDMBZPBZZLCYQXLDOMZBLZWPDWYYGDSTTHCSQSCCRSSSYSLFYBFNTYJSZDFNDPDHDZZMBBLSLCMYFFGTJJQWFTMTPJWFNLBZCMMJTGBDZLQLPYFHYYMJYLSDCHDZJWJCCTLJCLDTLJJCPDDSQDSSZYBNDBJLGGJZXSXNLYCYBJXQYCBYLZCFZPPGKCXZDZFZTJJFJSJXZBNZYJQTTYJYHTYCZHYMDJXTTMPXSPLZCDWSLSHXYPZGTFMLCJTYCBPMGDKWYCYZCDSZZYHFLYCTYGWHKJYYLSJCXGYWJCBLLCSNDDBTZBSCLYZCZZSSQDLLMQYYHFSLQLLXFTYHABXGWNYWYYPLLSDLDLLBJCYXJZMLHLJDXYYQYTDLLLBUGBFDFBBQJZZMDPJHGCLGMJJPGAEHHBWCQXAXHHHZCHXYPHJAXHLPHJPGPZJQCQZGJJZZUZDMQYYBZZPHYHYBWHAZYJHYKFGDPFQSDLZMLJXKXGALXZDAGLMDGXMWZQYXXDXXPFDMMSSYMPFMDMMKXKSYZYSHDZKXSYSMMZZZMSYDNZZCZXFPLSTMZDNMXCKJMZTYYMZMZZMSXHHDCZJEMXXKLJSTLWLSQLYJZLLZJSSDPPMHNLZJCZYHMXXHGZCJMDHXTKGRMXFWMCGMWKDTKSXQMMMFZZYDKMSCLCMPCGMHSPXQPZDSSLCXKYXTWLWJYAHZJGZQMCSNXYYMMPMLKJXMHLMLQMXCTKZMJQYSZJSYSZHSYJZJCDAJZYBSDQJZGWZQQXFKDMSDJLFWEHKZQKJPEYPZYSZCDWYJFFMZZYLTTDZZEFMZLBNPPLPLPEPSZALLTYLKCKQZKGENQLWAGYXYDPXLHSXQQWQCQXQCLHYXXMLYCCWLYMQYSKGCHLCJNSZKPYZKCQZQLJPDMDZHLASXLBYDWQLWDNBQCRYDDZTJYBKBWSZDXDTNPJDTCTQDFXQQMGNXECLTTBKPWSLCTYQLPWYZZKLPYGZCQQPLLKCCYLPQMZCZQCLJSLQZDJXLDDHPZQDLJJXZQDXYZQKZLJCYQDYJPPYPQYKJYRMPCBYMCXKLLZLLFQPYLLLMBSGLCYSSLRSYSQTMXYXZQZFDZUYSYZTFFMZZSMZQHZSSCCMLYXWTPZGXZJGZGSJSGKDDHTQGGZLLBJDZLCBCHYXYZHZFYWXYZYMSDBZZYJGTSMTFXQYXQSTDGSLNXDLRYZZLRYYLXQHTXSRTZNGZXBNQQZFMYKMZJBZYMKBPNLYZPBLMCNQYZZZSJZHJCTZKHYZZJRDYZHNPXGLFZTLKGJTCTSSYLLGZRZBBQZZKLPKLCZYSSUYXBJFPNJZZXCDWXZYJXZZDJJKGGRSRJKMSMZJLSJYWQSKYHQJSXPJZZZLSNSHRNYPZTWCHKLPSRZLZXYJQXQKYSJYCZTLQZYBBYBWZPQDWWYZCYTJCJXCKCWDKKZXSGKDZXWWYYJQYYTCYTDLLXWKCZKKLCCLZCQQDZLQLCSFQCHQHSFSMQZZLNBJJZBSJHTSZDYSJQJPDLZCDCWJKJZZLPYCGMZWDJJBSJQZSYZYHHXJPBJYDSSXDZNCGLQMBTSFSBPDZDLZNFGFJGFSMPXJQLMBLGQCYYXBQKDJJQYRFKZTJDHCZKLBSDZCFJTPLLJGXHYXZCSSZZXSTJYGKGCKGYOQXJPLZPBPGTGYJZGHZQZZLBJLSQFZGKQQJZGYCZBZQTLDXRJXBSXXPZXHYZYCLWDXJJHXMFDZPFZHQHQMQGKSLYHTYCGFRZGNQXCLPDLBZCSCZQLLJBLHBZCYPZZPPDYMZZSGYHCKCPZJGSLJLNSCDSLDLXBMSTLDDFJMKDJDHZLZXLSZQPQPGJLLYBDSZGQLBZLSLKYYHZTTNTJYQTZZPSZQZTLLJTYYLLQLLQYZQLBDZLSLYYZYMDFSZSNHLXZNCZQZPBWSKRFBSYZMTHBLGJPMCZZLSTLXSHTCSYZLZBLFEQHLXFLCJLYLJQCBZLZJHHSSTBRMHXZHJZCLXFNBGXGTQJCZTMSFZKJMSSNXLJKBHSJXNTNLZDNTLMSJXGZJYJCZXYJYJWRWWQNZTNFJSZPZSHZJFYRDJSFSZJZBJFZQZZHZLXFYSBZQLZSGYFTZDCSZXZJBQMSZKJRHYJZCKMJKHCHGTXKXQGLXPXFXTRTYLXJXHDTSJXHJZJXZWZLCQSBTXWXGXTXXHXFTSDKFJHZYJFJXRZSDLLLTQSQQZQWZXSYQTWGWBZCGZLLYZBCLMQQTZHZXZXLJFRMYZFLXYSQXXJKXRMQDZDMMYYBSQBHGZMWFWXGMXLZPYYTGZYCCDXYZXYWGSYJYZNBHPZJSQSYXSXRTFYZGRHZTXSZZTHCBFCLSYXZLZQMZLMPLMXZJXSFLBYZMYQHXJSXRXSQZZZSSLYFRCZJRCRXHHZXQYDYHXSJJHZCXZBTYNSYSXJBQLPXZQPYMLXZKYXLXCJLCYSXXZZLXDLLLJJYHZXGYJWKJRWYHCPSGNRZLFZWFZZNSXGXFLZSXZZZBFCSYJDBRJKRDHHGXJLJJTGXJXXSTJTJXLYXQFCSGSWMSBCTLQZZWLZZKXJMLTMJYHSDDBXGZHDLBMYJFRZFSGCLYJBPMLYSMSXLSZJQQHJZFXGFQFQBPXZGYYQXGZTCQWYLTLGWSGWHRLFSFGZJMGMGBGTJFSYZZGZYZAFLSSPMLPFLCWBJZCLJJMZLPJJLYMQDMYYYFBGYGYZMLYZDXQYXRQQQHSYYYQXYLJTYXFSFSLLGNQCYHYCWFHCCCFXPYLYPLLZYXXXXXKQHHXSHJZCFZSCZJXCPZWHHHHHAPYLQALPQAFYHXDYLUKMZQGGGDDESRNNZLTZGCHYPPYSQJJHCLLJTOLNJPZLJLHYMHEYDYDSQYCDDHGZUNDZCLZYZLLZNTNYZGSLHSLPJJBDGWXPCDUTJCKLKCLWKLLCASSTKZZDNQNTTLYYZSSYSSZZRYLJQKCQDHHCRXRZYDGRGCWCGZQFFFPPJFZYNAKRGYWYQPQXXFKJTSZZXSWZDDFBBXTBGTZKZNPZZPZXZPJSZBMQHKCYXYLDKLJNYPKYGHGDZJXXEAHPNZKZTZCMXCXMMJXNKSZQNMNLWBWWXJKYHCPSTMCSQTZJYXTPCTPDTNNPGLLLZSJLSPBLPLQHDTNJNLYYRSZFFJFQWDPHZDWMRZCCLODAXNSSNYZRESTYJWJYJDBCFXNMWTTBYLWSTSZGYBLJPXGLBOCLHPCBJLTMXZLJYLZXCLTPNCLCKXTPZJSWCYXSFYSZDKNTLBYJCYJLLSTGQCBXRYZXBXKLYLHZLQZLNZCXWJZLJZJNCJHXMNZZGJZZXTZJXYCYYCXXJYYXJJXSSSJSTSSTTPPGQTCSXWZDCSYFPTFBFHFBBLZJCLZZDBXGCXLQPXKFZFLSYLTUWBMQJHSZBMDDBCYSCCLDXYCDDQLYJJWMQLLCSGLJJSYFPYYCCYLTJANTJJPWYCMMGQYYSXDXQMZHSZXPFTWWZQSWQRFKJLZJQQYFBRXJHHFWJJZYQAZMYFRHCYYBYQWLPEXCCZSTYRLTTDMQLYKMBBGMYYJPRKZNPBSXYXBHYZDJDNGHPMFSGMWFZMFQMMBCMZZCJJLCNUXYQLMLRYGQZCYXZLWJGCJCGGMCJNFYZZJHYCPRRCMTZQZXHFQGTJXCCJEAQCRJYHPLQLSZDJRBCQHQDYRHYLYXJSYMHZYDWLDFRYHBPYDTSSCNWBXGLPZMLZZTQSSCPJMXXYCSJYTYCGHYCJWYRXXLFEMWJNMKLLSWTXHYYYNCMMCWJDQDJZGLLJWJRKHPZGGFLCCSCZMCBLTBHBQJXQDSPDJZZGKGLFQYWBZYZJLTSTDHQHCTCBCHFLQMPWDSHYYTQWCNZZJTLBYMBPDYYYXSQKXWYYFLXXNCWCXYPMAELYKKJMZZZBRXYYQJFLJPFHHHYTZZXSGQQMHSPGDZQWBWPJHZJDYSCQWZKTXXSQLZYYMYSDZGRXCKKUJLWPYSYSCSYZLRMLQSYLJXBCXTLWDQZPCYCYKPPPNSXFYZJJRCEMHSZMSXLXGLRWGCSTLRSXBZGBZGZTCPLUJLSLYLYMTXMTZPALZXPXJTJWTCYYZLBLXBZLQMYLXPGHDSLSSDMXMBDZZSXWHAMLCZCPJMCNHJYSNSYGCHSKQMZZQDLLKABLWJXSFMOCDXJRRLYQZKJMYBYQLYHETFJZFRFKSRYXFJTWDSXXSYSQJYSLYXWJHSNLXYYXHBHAWHHJZXWMYLJCSSLKYDZTXBZSYFDXGXZJKHSXXYBSSXDPYNZWRPTQZCZENYGCXQFJYKJBZMLJCMQQXUOXSLYXXLYLLJDZBTYMHPFSTTQQWLHOKYBLZZALZXQLHZWRRQHLSTMYPYXJJXMQSJFNBXYXYJXXYQYLTHYLQYFMLKLJTMLLHSZWKZHLJMLHLJKLJSTLQXYLMBHHLNLZXQJHXCFXXLHYHJJGBYZZKBXSCQDJQDSUJZYYHZHHMGSXCSYMXFEBCQWWRBPYYJQTYZCYQYQQZYHMWFFHGZFRJFCDPXNTQYZPDYKHJLFRZXPPXZDBBGZQSTLGDGYLCQMLCHHMFYWLZYXKJLYPQHSYWMQQGQZMLZJNSQXJQSYJYCBEHSXFSZPXZWFLLBCYYJDYTDTHWZSFJMQQYJLMQXXLLDTTKHHYBFPWTYYSQQWNQWLGWDEBZWCMYGCULKJXTMXMYJSXHYBRWFYMWFRXYQMXYSZTZZTFYKMLDHQDXWYYNLCRYJBLPSXCXYWLSPRRJWXHQYPHTYDNXHHMMYWYTZCSQMTSSCCDALWZTCPQPYJLLQZYJSWXMZZMMYLMXCLMXCZMXMZSQTZPPQQBLPGXQZHFLJJHYTJSRXWZXSCCDLXTYJDCQJXSLQYCLZXLZZXMXQRJMHRHZJBHMFLJLMLCLQNLDXZLLLPYPSYJYSXCQQDCMQJZZXHNPNXZMEKMXHYKYQLXSXTXJYYHWDCWDZHQYYBGYBCYSCFGPSJNZDYZZJZXRZRQJJYMCANYRJTLDPPYZBSTJKXXZYPFDWFGZZRPYMTNGXZQBYXNBUFNQKRJQZMJEGRZGYCLKXZDSKKNSXKCLJSPJYYZLQQJYBZSSQLLLKJXTBKTYLCCDDBLSPPFYLGYDTZJYQGGKQTTFZXBDKTYYHYBBFYTYYBCLPDYTGDHRYRNJSPTCSNYJQHKLLLZSLYDXXWBCJQSPXBPJZJCJDZFFXXBRMLAZHCSNDLBJDSZBLPRZTSWSBXBCLLXXLZDJZSJPYLYXXYFTFFFBHJJXGBYXJPMMMPSSJZJMTLYZJXSWXTYLEDQPJMYGQZJGDJLQJWJQLLSJGJGYGMSCLJJXDTYGJQJQJCJZCJGDZZSXQGSJGGCXHQXSNQLZZBXHSGZXCXYLJXYXYYDFQQJHJFXDHCTXJYRXYSQTJXYEFYYSSYYJXNCYZXFXMSYSZXYYSCHSHXZZZGZZZGFJDLTYLNPZGYJYZYYQZPBXQBDZTZCZYXXYHHSQXSHDHGQHJHGYWSZTMZMLHYXGEBTYLZKQWYTJZRCLEKYSTDBCYKQQSAYXCJXWWGSBHJYZYDHCSJKQCXSWXFLTYNYZPZCCZJQTZWJQDZZZQZLJJXLSBHPYXXPSXSHHEZTXFPTLQYZZXHYTXNCFZYYHXGNXMYWXTZSJPTHHGYMXMXQZXTSBCZYJYXXTYYZYPCQLMMSZMJZZLLZXGXZAAJZYXJMZXWDXZSXZDZXLEYJJZQBHZWZZZQTZPSXZTDSXJJJZNYAZPHXYYSRNQDTHZHYYKYJHDZXZLSWCLYBZYECWCYCRYLCXNHZYDZYDYJDFRJJHTRSQTXYXJRJHOJYNXELXSFSFJZGHPZSXZSZDZCQZBYYKLSGSJHCZSHDGQGXYZGXCHXZJWYQWGYHKSSEQZZNDZFKWYSSTCLZSTSYMCDHJXXYWEYXCZAYDMPXMDSXYBSQMJMZJMTZQLPJYQZCGQHXJHHLXXHLHDLDJQCLDWBSXFZZYYSCHTYTYYBHECXHYKGJPXHHYZJFXHWHBDZFYZBCAPNPGNYDMSXHMMMMAMYNBYJTMPXYYMCTHJBZYFCGTYHWPHFTWZZEZSBZEGPFMTSKFTYCMHFLLHGPZJXZJGZJYXZSBBQSCZZLZCCSTPGXMJSFTCCZJZDJXCYBZLFCJSYZFGSZLYBCWZZBYZDZYPSWYJZXZBDSYUXLZZBZFYGCZXBZHZFTPBGZGEJBSTGKDMFHYZZJHZLLZZGJQZLSFDJSSCBZGPDLFZFZSZYZYZSYGCXSNXXCHCZXTZZLJFZGQSQYXZJQDCCZTQCDXZJYQJQCHXZTDLGSCXZSYQJQTZWLQDQZTQCHQQJZYEZZZPBWKDJFCJPZTYPQYQTTYNLMBDKTJZPQZQZZFPZSBNJLGYJDXJDZZKZGQKXDLPZJTCJDQBXDJQJSTCKNXBXZMSLYJCQMTJQWWCJQNJNLLLHJCWQTBZQYDZCZPZZDZYDDCYZZZCCJTTJFZDPRRTZTJDCQTQZDTJNPLZBCLLCTZSXKJZQZPZLBZRBTJDCXFCZDBCCJJLTQQPLDCGZDBBZJCQDCJWYNLLZYZCCDWLLXWZLXRXNTQQCZXKQLSGDFQTDDGLRLAJJTKUYMKQLLTZYTDYYCZGJWYXDXFRSKSTQTENQMRKQZHHQKDLDAZFKYPBGGPZREBZZYKZZSPEGJXGYKQZZZSLYSYYYZWFQZYLZZLZHWCHKYPQGNPGBLPLRRJYXCCSYYHSFZFYBZYYTGZXYLXCZWXXZJZBLFFLGSKHYJZEYJHLPLLLLCZGXDRZELRHGKLZZYHZLYQSZZJZQLJZFLNBHGWLCZCFJYSPYXZLZLXGCCPZBLLCYBBBBUBBCBPCRNNZCZYRBFSRLDCGQYYQXYGMQZWTZYTYJXYFWTEHZZJYWLCCNTZYJJZDEDPZDZTSYQJHDYMBJNYJZLXTSSTPHNDJXXBYXQTZQDDTJTDYYTGWSCSZQFLSHLGLBCZPHDLYZJYCKWTYTYLBNYTSDSYCCTYSZYYEBHEXHQDTWNYGYCLXTSZYSTQMYGZAZCCSZZDSLZCLZRQXYYELJSBYMXSXZTEMBBLLYYLLYTDQYSHYMRQWKFKBFXNXSBYCHXBWJYHTQBPBSBWDZYLKGZSKYHXQZJXHXJXGNLJKZLYYCDXLFYFGHLJGJYBXQLYBXQPQGZTZPLNCYPXDJYQYDYMRBESJYYHKXXSTMXRCZZYWXYQYBMCLLYZHQYZWQXDBXBZWZMSLPDMYSKFMZKLZCYQYCZLQXFZZYDQZPZYGYJYZMZXDZFYFYTTQTZHGSPCZMLCCYTZXJCYTJMKSLPZHYSNZLLYTPZCTZZCKTXDHXXTQCYFKSMQCCYYAZHTJPCYLZLYJBJXTPNYLJYYNRXSYLMMNXJSMYBCSYSYLZYLXJJQYLDZLPQBFZZBLFNDXQKCZFYWHGQMRDSXYCYTXNQQJZYYPFZXDYZFPRXEJDGYQBXRCNFYYQPGHYJDYZXGRHTKYLNWDZNTSMPKLBTHBPYSZBZTJZSZZJTYYXZPHSSZZBZCZPTQFZMYFLYPYBBJQXZMXXDJMTSYSKKBJZXHJCKLPSMKYJZCXTMLJYXRZZQSLXXQPYZXMKYXXXJCLJPRMYYGADYSKQLSNDHYZKQXZYZTCGHZTLMLWZYBWSYCTBHJHJFCWZTXWYTKZLXQSHLYJZJXTMPLPYCGLTBZZTLZJCYJGDTCLKLPLLQPJMZPAPXYZLKKTKDZCZZBNZDYDYQZJYJGMCTXLTGXSZLMLHBGLKFWNWZHDXUHLFMKYSLGXDTWWFRJEJZTZHYDXYKSHWFZCQSHKTMQQHTZHYMJDJSKHXZJZBZZXYMPAGQMSTPXLSKLZYNWRTSQLSZBPSPSGZWYHTLKSSSWHZZLYYTNXJGMJSZSUFWNLSOZTXGXLSAMMLBWLDSZYLAKQCQCTMYCFJBSLXCLZZCLXXKSBZQCLHJPSQPLSXXCKSLNHPSFQQYTXYJZLQLDXZQJZDYYDJNZPTUZDSKJFSLJHYLZSQZLBTXYDGTQFDBYAZXDZHZJNHHQBYKNXJJQCZMLLJZKSPLDYCLBBLXKLELXJLBQYCXJXGCNLCQPLZLZYJTZLJGYZDZPLTQCSXFDMNYCXGBTJDCZNBGBQYQJWGKFHTNPYQZQGBKPBBYZMTJDYTBLSQMPSXTBNPDXKLEMYYCJYNZCTLDYKZZXDDXHQSHDGMZSJYCCTAYRZLPYLTLKXSLZCGGEXCLFXLKJRTLQJAQZNCMBYDKKCXGLCZJZXJHPTDJJMZQYKQSECQZDSHHADMLZFMMZBGNTJNNLGBYJBRBTMLBYJDZXLCJLPLDLPCQDHLXZLYCBLCXZZJADJLNZMMSSSMYBHBSQKBHRSXXJMXSDZNZPXLGBRHWGGFCXGMSKLLTSJYYCQLTSKYWYYHYWXBXQYWPYWYKQLSQPTNTKHQCWDQKTWPXXHCPTHTWUMSSYHBWCRWXHJMKMZNGWTMLKFGHKJYLSYYCXWHYECLQHKQHTTQKHFZLDXQWYZYYDESBPKYRZPJFYYZJCEQDZZDLATZBBFJLLCXDLMJSSXEGYGSJQXCWBXSSZPDYZCXDNYXPPZYDLYJCZPLTXLSXYZYRXCYYYDYLWWNZSAHJSYQYHGYWWAXTJZDAXYSRLTDPSSYYFNEJDXYZHLXLLLZQZSJNYQYQQXYJGHZGZCYJCHZLYCDSHWSHJZYJXCLLNXZJJYYXNFXMWFPYLCYLLABWDDHWDXJMCXZTZPMLQZHSFHZYNZTLLDYWLSLXHYMMYLMBWWKYXYADTXYLLDJPYBPWUXJMWMLLSAFDLLYFLBHHHBQQLTZJCQJLDJTFFKMMMBYTHYGDCQRDDWRQJXNBYSNWZDBYYTBJHPYBYTTJXAAHGQDQTMYSTQXKBTZPKJLZRBEQQSSMJJBDJOTGTBXPGBKTLHQXJJJCTHXQDWJLWRFWQGWSHCKRYSWGFTGYGBXSDWDWRFHWYTJJXXXJYZYSLPYYYPAYXHYDQKXSHXYXGSKQHYWFDDDPPLCJLQQEEWXKSYYKDYPLTJTHKJLTCYYHHJTTPLTZZCDLTHQKZXQYSTEEYWYYZYXXYYSTTJKLLPZMCYHQGXYHSRMBXPLLNQYDQHXSXXWGDQBSHYLLPJJJTHYJKYPPTHYYKTYEZYENMDSHLCRPQFDGFXZPSFTLJXXJBSWYYSKSFLXLPPLBBBLBSFXFYZBSJSSYLPBBFFFFSSCJDSTZSXZRYYSYFFSYZYZBJTBCTSBSDHRTJJBYTCXYJEYLXCBNEBJDSYXYKGSJZBXBYTFZWGENYHHTHZHHXFWGCSTBGXKLSXYWMTMBYXJSTZSCDYQRCYTWXZFHMYMCXLZNSDJTTTXRYCFYJSBSDYERXJLJXBBDEYNJGHXGCKGSCYMBLXJMSZNSKGXFBNBPTHFJAAFXYXFPXMYPQDTZCXZZPXRSYWZDLYBBKTYQPQJPZYPZJZNJPZJLZZFYSBTTSLMPTZRTDXQSJEHBZYLZDHLJSQMLHTXTJECXSLZZSPKTLZKQQYFSYGYWPCPQFHQHYTQXZKRSGTTSQCZLPTXCDYYZXSQZSLXLZMYCPCQBZYXHBSXLZDLTCDXTYLZJYYZPZYZLTXJSJXHLPMYTXCQRBLZSSFJZZTNJYTXMYJHLHPPLCYXQJQQKZZSCPZKSWALQSBLCCZJSXGWWWYGYKTJBBZTDKHXHKGTGPBKQYSLPXPJCKBMLLXDZSTBKLGGQKQLSBKKTFXRMDKBFTPZFRTBBRFERQGXYJPZSSTLBZTPSZQZSJDHLJQLZBPMSMMSXLQQNHKNBLRDDNXXDHDDJCYYGYLXGZLXSYGMQQGKHBPMXYXLYTQWLWGCPBMQXCYZYDRJBHTDJYHQSHTMJSBYPLWHLZFFNYPMHXXHPLTBQPFBJWQDBYGPNZTPFZJGSDDTQSHZEAWZZYLLTYYBWJKXXGHLFKXDJTMSZSQYNZGGSWQSPHTLSSKMCLZXYSZQZXNCJDQGZDLFNYKLJCJLLZLMZZNHYDSSHTHZZLZZBBHQZWWYCRZHLYQQJBEYFXXXWHSRXWQHWPSLMSSKZTTYGYQQWRSLALHMJTQJSMXQBJJZJXZYZKXBYQXBJXSHZTSFJLXMXZXFGHKZSZGGYLCLSARJYHSLLLMZXELGLXYDJYTLFBHBPNLYZFBBHPTGJKWETZHKJJXZXXGLLJLSTGSHJJYQLQZFKCGNNDJSSZFDBCTWWSEQFHQJBSAQTGYPQLBXBMMYWXGSLZHGLZGQYFLZBYFZJFRYSFMBYZHQGFWZSYFYJJPHZBYYZFFWODGRLMFTWLBZGYCQXCDJYGZYYYYTYTYDWEGAZYHXJLZYYHLRMGRXXZCLHNELJJTJTPWJYBJJBXJJTJTEEKHWSLJPLPSFYZPQQBDLQJJTYYQLYZKDKSQJYYQZLDQTGJQYZJSUCMRYQTHTEJMFCTYHYPKMHYZWJDQFHYYXWSHCTXRLJHQXHCCYYYJLTKTTYTMXGTCJTZAYYOCZLYLBSZYWJYTSJYHBYSHFJLYGJXXTMZYYLTXXYPZLXYJZYZYYPNHMYMDYYLBLHLSYYQQLLNJJYMSOYQBZGDLYXYLCQYXTSZEGXHZGLHWBLJHEYXTWQMAKBPQCGYSHHEGQCMWYYWLJYJHYYZLLJJYLHZYHMGSLJLJXCJJYCLYCJPCPZJZJMMYLCQLNQLJQJSXYJMLSZLJQLYCMMHCFMMFPQQMFYLQMCFFQMMMMHMZNFHHJGTTHHKHSLNCHHYQDXTMMQDCYZYXYQMYQYLTDCYYYZAZZCYMZYDLZFFFMMYCQZWZZMABTBYZTDMNZZGGDFTYPCGQYTTSSFFWFDTZQSSYSTWXJHXYTSXXYLBYQHWWKXHZXWZNNZZJZJJQJCCCHYYXBZXZCYZTLLCQXYNJYCYYCYNZZQYYYEWYCZDCJYCCHYJLBTZYYCQWMPWPYMLGKDLDLGKQQBGYCHJXY";

pinyin_dict_firstletter.polyphone = (_pinyin_dict_firstlet = { "19969": "DZ", "19975": "WM", "19988": "QJ", "20048": "YL", "20056": "SC", "20060": "NM", "20094": "QG", "20127": "QJ", "20167": "QC", "20193": "YG", "20250": "KH", "20256": "ZC", "20282": "SC", "20285": "QJG", "20291": "TD", "20314": "YD", "20340": "NE", "20375": "TD", "20389": "YJ", "20391": "CZ", "20415": "PB", "20446": "YS", "20447": "SQ", "20504": "TC", "20608": "KG", "20854": "QJ", "20857": "ZC", "20911": "PF" }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20504", "TC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20608", "KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20854", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20857", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20911", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "20985", "AW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21032", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21048", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21049", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21089", "YS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21119", "JC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21242", "SB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21273", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21305", "YP"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21306", "QO"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21330", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21333", "SDC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21345", "QK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21378", "CA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21397", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21414", "XS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21442", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21477", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21480", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21484", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21494", "YX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21505", "YX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21512", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21523", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21537", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21542", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21549", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21571", "E"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21574", "DA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21588", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21589", "O"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21618", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21621", "KHA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21632", "ZJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21654", "KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21679", "LKG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21683", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21710", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21719", "YH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21734", "WOE"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21769", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21780", "WN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21804", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21834", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21899", "ZD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21903", "RN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21908", "WO"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21939", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21956", "SA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21964", "YA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "21970", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22003", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22031", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22040", "XS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22060", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22066", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22079", "MH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22129", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22179", "XA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22237", "NJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22244", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22280", "JQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22300", "YH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22313", "XW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22331", "YQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22343", "YJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22351", "PH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22395", "DC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22412", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22484", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22500", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22534", "ZD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22549", "DH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22561", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22612", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22771", "KQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22831", "HB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22841", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22855", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "22865", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23013", "ML"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23081", "WM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23487", "SX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23558", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23561", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23586", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23614", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23615", "SN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23631", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23646", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23663", "ZT"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23673", "YG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23762", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23769", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23780", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "23884", "QK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24055", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24113", "DC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24162", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24191", "GA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24273", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24324", "NL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24377", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24378", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24439", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24554", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24683", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24694", "WE"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24733", "LK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "24925", "TN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25094", "ZG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25100", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25103", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25153", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25170", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25179", "KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25203", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25240", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25282", "FB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25303", "NA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25324", "KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25341", "ZY"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25373", "WZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25375", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25384", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25457", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25528", "SD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25530", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25552", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25774", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "25874", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26044", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26080", "WM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26292", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26333", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26355", "ZY"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26366", "CZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26397", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26399", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26415", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26451", "SB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26526", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26552", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26561", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26588", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26597", "CZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26629", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26638", "YL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26646", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26653", "KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26657", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26727", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26894", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26937", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26946", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "26999", "KJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27099", "KJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27449", "YQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27481", "XS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27542", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27663", "ZS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27748", "TS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27784", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27788", "ZD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27795", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27812", "O"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27850", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27852", "MB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27895", "SL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27898", "PL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27973", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27981", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27986", "HX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "27994", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28044", "YC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28065", "WG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28177", "SM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28267", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28291", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28337", "ZQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28463", "TL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28548", "DC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28601", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28689", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28805", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28820", "QG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28846", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28952", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "28975", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "29100", "A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "29325", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "29575", "SL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "29602", "FB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30010", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30044", "CX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30058", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30091", "YSP"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30111", "YN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30229", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30427", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30465", "SX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30631", "YQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30655", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30684", "QJG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30707", "SD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30729", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30796", "LG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "30917", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31074", "NM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31085", "JZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31109", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31181", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31192", "MLB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31293", "JQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31400", "YX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31584", "YJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31896", "ZN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31909", "ZY"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "31995", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32321", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32327", "ZY"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32418", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32420", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32421", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32438", "LG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32473", "GJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32488", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32521", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32527", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32562", "ZSQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32564", "JZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32735", "ZD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "32793", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33071", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33098", "XL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33100", "YA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33152", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33261", "CX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33324", "BP"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33333", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33406", "YA"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33426", "WM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33432", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33445", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33486", "ZN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33493", "TS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33507", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33540", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33544", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33564", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33617", "YT"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33632", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33636", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33637", "YX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33694", "WG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33705", "PF"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33728", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "33882", "SR"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34067", "WM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34074", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34121", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34255", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34259", "XL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34425", "JH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34430", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34485", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34503", "YS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34532", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34552", "XS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34558", "YE"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34593", "ZL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34660", "YQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34892", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34928", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "34999", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35048", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35059", "SC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35098", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35203", "TQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35265", "JX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35299", "JX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35782", "SZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35828", "YS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35830", "E"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35843", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35895", "YG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "35977", "MH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36158", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36228", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36426", "XQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36466", "DC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36710", "JC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36711", "ZYG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36767", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36866", "SK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "36951", "YW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "37034", "YX"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "37063", "XH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "37218", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "37325", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38063", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38079", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38085", "QY"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38107", "DC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38116", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38123", "YD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38224", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38241", "XTC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38271", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38415", "YE"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38426", "KH"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38461", "YD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38463", "AE"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38466", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38477", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38518", "YT"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38551", "WK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38585", "ZC"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38704", "XS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38739", "LJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38761", "GJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "38808", "SQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39048", "JG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39049", "XJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39052", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39076", "CZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39271", "XT"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39534", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39552", "TD"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39584", "PB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39647", "SB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39730", "LG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "39748", "TPB"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40109", "ZQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40479", "ND"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40516", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40536", "HG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40583", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40765", "YQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40784", "QJ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40840", "YK"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_pinyin_dict_firstlet, "40863", "QJG"), _pinyin_dict_firstlet);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);





var Util = {
    leftDistance: function leftDistance(el) {
        var left = el.offsetLeft;
        var scrollLeft = void 0;
        while (el.offsetParent) {
            el = el.offsetParent;
            left += el.offsetLeft;
        }
        scrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        return left - scrollLeft;
    },
    timeFormat: function timeFormat(time) {
        var tempMin = parseInt(time / 60);
        var tempSec = parseInt(time % 60);
        var curMin = tempMin < 10 ? '0' + tempMin : tempMin;
        var curSec = tempSec < 10 ? '0' + tempSec : tempSec;
        return curMin + ':' + curSec;
    },
    percentFormat: function percentFormat(percent) {
        return (percent * 100).toFixed(2) + '%';
    },
    ajax: function ajax(option) {
        option.beforeSend && option.beforeSend();
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    option.success && option.success(xhr.responseText);
                } else {
                    option.fail && option.fail(xhr.status);
                }
            }
        };
        xhr.open('GET', option.url);
        xhr.send(null);
    }
};

var instance = false;
var baseUrl = 'http://163.opdays.com/';

var skPlayer = function () {
    function skPlayer(option) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, skPlayer);

        var defaultOption = {
            element: document.getElementById('skPlayer'),
            autoplay: false,
            mode: 'listloop',
            listshow: true };

        for (var defaultKey in defaultOption) {
            if (!option.hasOwnProperty(defaultKey)) {
                option[defaultKey] = defaultOption[defaultKey];
            }
        }
        this.option = option;

        if (!(this.option.music && this.option.music.type && this.option.music.source)) {
            console.error('请正确配置对象！');
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
        }
        this.root = this.option.element;
        this.type = this.option.music.type;
        this.music = this.option.music.source;
        this.isMobile = /mobile/i.test(window.navigator.userAgent);

        this.toggle = this.toggle.bind(this);
        this.toggleList = this.toggleList.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.switchMode = this.switchMode.bind(this);

        if (this.type === 'file') {
            this.root.innerHTML = this.template();
            this.init();
            this.bind();
        } else if (this.type === 'cloud') {
            this.root.innerHTML = '<p class="skPlayer-tip-loading">LOADING</p>';
            Util.ajax({
                url: baseUrl + 'playlist?id=' + this.music,
                beforeSend: function beforeSend() {
                    console.log('SKPlayer正在努力的拉取歌单 ...');
                },
                success: function success(data) {
                    console.log('歌单拉取成功！');
                    _this.music = JSON.parse(data);
                    _this.root.innerHTML = _this.template();
                    _this.init();
                    _this.bind();
                },
                fail: function fail(status) {
                    console.error('歌单拉取失败！ 错误码：' + status);
                }
            });
        }
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(skPlayer, [{
        key: 'template',
        value: function template() {
            var html = '\n            <audio class="skPlayer-source" src="' + (this.type === 'file' ? this.music[0].src : '') + '" preload="auto"></audio>\n            <div class="skPlayer-picture">\n                <img class="skPlayer-cover" src="' + this.music[0].cover + '" alt="">\n                <a href="javascript:;" class="skPlayer-play-btn">\n                    <span class="skPlayer-left"></span>\n                    <span class="skPlayer-right"></span>\n                </a>\n            </div>\n            <div class="skPlayer-control">\n                <p class="skPlayer-name">' + this.music[0].name + '</p>\n                <p class="skPlayer-author">' + this.music[0].author + '</p>\n                <div class="skPlayer-percent">\n                    <div class="skPlayer-line-loading"></div>\n                    <div class="skPlayer-line"></div>\n                </div>\n                <p class="skPlayer-time">\n                    <span class="skPlayer-cur">' + '00:00' + '</span>/<span class="skPlayer-total">' + '00:00' + '</span>\n                </p>\n                <div class="skPlayer-volume" style="' + (this.isMobile ? 'display:none;' : '') + '">\n                    <i class="skPlayer-icon"></i>\n                    <div class="skPlayer-percent">\n                        <div class="skPlayer-line"></div>\n                    </div>\n                </div>\n                <div class="skPlayer-list-switch">\n                    <i class="skPlayer-list-icon"></i>\n                </div>\n                <i class="' + (this.option.mode === 'singleloop' ? 'skPlayer-mode skPlayer-mode-loop' : 'skPlayer-mode') + '"></i>\n            </div>\n            <ul class="skPlayer-list">\n        ';
            for (var index in this.music) {
                html += '\n                <li data-index="' + index + '">\n                    <i class="skPlayer-list-sign"></i>\n                    <span class="skPlayer-list-index">' + (parseInt(index) + 1) + '</span>\n                    <span class="skPlayer-list-name" title="' + this.music[index].name + '">' + this.music[index].name + '</span>\n                    <span class="skPlayer-list-author" title="' + this.music[index].author + '">' + this.music[index].author + '</span>\n                </li>\n            ';
            }
            html += '\n            </ul>\n        ';
            return html;
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.dom = {
                cover: this.root.querySelector('.skPlayer-cover'),
                playbutton: this.root.querySelector('.skPlayer-play-btn'),
                name: this.root.querySelector('.skPlayer-name'),
                author: this.root.querySelector('.skPlayer-author'),
                timeline_total: this.root.querySelector('.skPlayer-percent'),
                timeline_loaded: this.root.querySelector('.skPlayer-line-loading'),
                timeline_played: this.root.querySelector('.skPlayer-percent .skPlayer-line'),
                timetext_total: this.root.querySelector('.skPlayer-total'),
                timetext_played: this.root.querySelector('.skPlayer-cur'),
                volumebutton: this.root.querySelector('.skPlayer-icon'),
                volumeline_total: this.root.querySelector('.skPlayer-volume .skPlayer-percent'),
                volumeline_value: this.root.querySelector('.skPlayer-volume .skPlayer-line'),
                switchbutton: this.root.querySelector('.skPlayer-list-switch'),
                modebutton: this.root.querySelector('.skPlayer-mode'),
                musiclist: this.root.querySelector('.skPlayer-list'),
                musicitem: this.root.querySelectorAll('.skPlayer-list li')
            };
            this.audio = this.root.querySelector('.skPlayer-source');
            if (this.option.listshow) {
                this.root.className = 'skPlayer-list-on';
            }
            if (this.option.mode === 'singleloop') {
                this.audio.loop = true;
            }
            this.dom.musicitem[0].className = 'skPlayer-curMusic';
            if (this.type === 'cloud') {
                Util.ajax({
                    url: baseUrl + 'song/detail?id=' + this.music[0].song_id,
                    beforeSend: function beforeSend() {
                        console.log('SKPlayer正在努力的拉取歌曲 ...');
                    },
                    success: function success(data) {
                        console.log('歌曲拉取成功！');
                        var url = JSON.parse(data).url;
                        _this2.audio.src = url;
                    },
                    fail: function fail(status) {
                        console.error('歌曲拉取失败！ 错误码：' + status);
                    }
                });
            }
        }
    }, {
        key: 'bind',
        value: function bind() {
            var _this3 = this;

            this.updateLine = function () {
                var percent = _this3.audio.buffered.length ? _this3.audio.buffered.end(_this3.audio.buffered.length - 1) / _this3.audio.duration : 0;
                _this3.dom.timeline_loaded.style.width = Util.percentFormat(percent);
            };

            this.audio.addEventListener('durationchange', function (e) {
                _this3.dom.timetext_total.innerHTML = Util.timeFormat(_this3.audio.duration);
                _this3.updateLine();
            });
            this.audio.addEventListener('progress', function (e) {
                _this3.updateLine();
            });
            this.audio.addEventListener('canplay', function (e) {
                if (_this3.option.autoplay && !_this3.isMobile) {
                    _this3.play();
                }
            });
            this.audio.addEventListener('timeupdate', function (e) {
                var percent = _this3.audio.currentTime / _this3.audio.duration;
                _this3.dom.timeline_played.style.width = Util.percentFormat(percent);
                _this3.dom.timetext_played.innerHTML = Util.timeFormat(_this3.audio.currentTime);
            });
            this.audio.addEventListener('seeked', function (e) {
                _this3.play();
            });
            this.audio.addEventListener('ended', function (e) {
                _this3.next();
            });

            this.dom.playbutton.addEventListener('click', this.toggle);
            this.dom.switchbutton.addEventListener('click', this.toggleList);
            if (!this.isMobile) {
                this.dom.volumebutton.addEventListener('click', this.toggleMute);
            }
            this.dom.modebutton.addEventListener('click', this.switchMode);
            this.dom.musiclist.addEventListener('click', function (e) {
                var target = void 0,
                    index = void 0,
                    curIndex = void 0;
                if (e.target.tagName.toUpperCase() === 'LI') {
                    target = e.target;
                } else if (e.target.parentElement.tagName.toUpperCase() === 'LI') {
                    target = e.target.parentElement;
                } else {
                    return;
                }
                index = parseInt(target.getAttribute('data-index'));
                curIndex = parseInt(_this3.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
                if (index === curIndex) {
                    _this3.play();
                } else {
                    _this3.switchMusic(index + 1);
                }
            });
            this.dom.timeline_total.addEventListener('click', function (event) {
                var e = event || window.event;
                var percent = (e.clientX - Util.leftDistance(_this3.dom.timeline_total)) / _this3.dom.timeline_total.clientWidth;
                if (!isNaN(_this3.audio.duration)) {
                    _this3.dom.timeline_played.style.width = Util.percentFormat(percent);
                    _this3.dom.timetext_played.innerHTML = Util.timeFormat(percent * _this3.audio.duration);
                    _this3.audio.currentTime = percent * _this3.audio.duration;
                }
            });
            if (!this.isMobile) {
                this.dom.volumeline_total.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percent = (e.clientX - Util.leftDistance(_this3.dom.volumeline_total)) / _this3.dom.volumeline_total.clientWidth;
                    _this3.dom.volumeline_value.style.width = Util.percentFormat(percent);
                    _this3.audio.volume = percent;
                    if (_this3.audio.muted) {
                        _this3.toggleMute();
                    }
                });
            }
        }
    }, {
        key: 'prev',
        value: function prev() {
            var index = parseInt(this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
            if (index === 0) {
                if (this.music.length === 1) {
                    this.play();
                } else {
                    this.switchMusic(this.music.length - 1 + 1);
                }
            } else {
                this.switchMusic(index - 1 + 1);
            }
        }
    }, {
        key: 'next',
        value: function next() {
            var index = parseInt(this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index'));
            if (index === this.music.length - 1) {
                if (this.music.length === 1) {
                    this.play();
                } else {
                    this.switchMusic(0 + 1);
                }
            } else {
                this.switchMusic(index + 1 + 1);
            }
        }
    }, {
        key: 'switchMusic',
        value: function switchMusic(index) {
            var _this4 = this;

            if (typeof index !== 'number') {
                console.error('请输入正确的歌曲序号！');
                return;
            }
            index -= 1;
            if (index < 0 || index >= this.music.length) {
                console.error('请输入正确的歌曲序号！');
                return;
            }
            if (index == this.dom.musiclist.querySelector('.skPlayer-curMusic').getAttribute('data-index')) {
                this.play();
                return;
            }

            this.dom.musiclist.querySelector('.skPlayer-curMusic').classList.remove('skPlayer-curMusic');
            this.dom.musicitem[index].classList.add('skPlayer-curMusic');
            this.dom.name.innerHTML = this.music[index].name;
            this.dom.author.innerHTML = this.music[index].author;
            this.dom.cover.src = this.music[index].cover;
            if (this.type === 'file') {
                this.audio.src = this.music[index].src;
                this.play();
            } else if (this.type === 'cloud') {
                Util.ajax({
                    url: baseUrl + 'song/detail?id=' + this.music[index].song_id,
                    beforeSend: function beforeSend() {
                        console.log('SKPlayer正在努力的拉取歌曲 ...');
                    },
                    success: function success(data) {
                        console.log('歌曲拉取成功！');
                        var url = JSON.parse(data).url;
                        _this4.audio.src = url;
                        _this4.play();
                    },
                    fail: function fail(status) {
                        console.error('歌曲拉取失败！ 错误码：' + status);
                    }
                });
            }
        }
    }, {
        key: 'play',
        value: function play() {
            if (this.audio.paused) {
                this.audio.play();
                this.dom.playbutton.classList.add('skPlayer-pause');
                this.dom.cover.classList.add('skPlayer-pause');
            }
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this.audio.paused) {
                this.audio.pause();
                this.dom.playbutton.classList.remove('skPlayer-pause');
                this.dom.cover.classList.remove('skPlayer-pause');
            }
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            this.audio.paused ? this.play() : this.pause();
        }
    }, {
        key: 'toggleList',
        value: function toggleList() {
            this.root.classList.contains('skPlayer-list-on') ? this.root.classList.remove('skPlayer-list-on') : this.root.classList.add('skPlayer-list-on');
        }
    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            if (this.audio.muted) {
                this.audio.muted = false;
                this.dom.volumebutton.classList.remove('skPlayer-quiet');
                this.dom.volumeline_value.style.width = Util.percentFormat(this.audio.volume);
            } else {
                this.audio.muted = true;
                this.dom.volumebutton.classList.add('skPlayer-quiet');
                this.dom.volumeline_value.style.width = '0%';
            }
        }
    }, {
        key: 'switchMode',
        value: function switchMode() {
            if (this.audio.loop) {
                this.audio.loop = false;
                this.dom.modebutton.classList.remove('skPlayer-mode-loop');
            } else {
                this.audio.loop = true;
                this.dom.modebutton.classList.add('skPlayer-mode-loop');
            }
        }
    }]);

    return skPlayer;
}();

/* harmony default export */ __webpack_exports__["a"] = (skPlayer);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weui__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_weui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_muse_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_pinyin_dict_notone_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_pinyin_dict_notone_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lib_pinyin_dict_notone_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_pinyinUtil_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_common_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_common_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_index_js__ = __webpack_require__(66);














window.com = __WEBPACK_IMPORTED_MODULE_11__lib_common_js___default.a;
window.pinyin_dict_notone = __WEBPACK_IMPORTED_MODULE_9__lib_pinyin_dict_notone_js___default.a;




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_muse_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload___default.a, {
    preLoad: 1.3,
    error: 'static/images/404.png',
    loading: 'static/images/404.png',
    attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_13__store_index_js__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    router: router,
    store: store,
    template: '\n  <router-view></router-view>\n  '
}).$mount('#app-box');

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(38);
  __webpack_require__(184);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String]
  },
  computed: {
    barLeft: function barLeft() {
      return this.currentIndex * (100 / this.number) + '%';
    },
    barRight: function barRight() {
      return (this.number - this.currentIndex - 1) * (100 / this.number) + '%';
    },
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent';
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xload_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xtitle_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xtitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__xtitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xlouti_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xlouti_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__xlouti_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pinyin_dict_firstletter__ = __webpack_require__(90);










/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			isShow: 0,
			getid: '',
			list: '',
			title: [],
			totlelist: [],
			load: false,
			bool: 0,
			mytitle: "",
			page: 0,
			myA: [],
			myB: [],
			myC: [],
			myD: [],
			myE: [],
			myF: [],
			myG: [],
			myH: [],
			myI: [],
			myJ: [],
			myK: [],
			myL: [],
			myM: [],
			myN: [],
			myO: [],
			myP: [],
			myQ: [],
			myR: [],
			myS: [],
			myT: [],
			myU: [],
			myV: [],
			myW: [],
			myX: [],
			myY: [],
			myZ: [],
			my: [],
			xianA: false,
			xianB: false,
			xianC: false,
			xianD: false,
			xianE: false,
			xianF: false,
			xianG: false,
			xianH: false,
			xianI: false,
			xianJ: false,
			xianK: false,
			xianL: false,
			xianM: false,
			xianN: false,
			xianO: false,
			xianP: false,
			xianQ: false,
			xianR: false,
			xianS: false,
			xianT: false,
			xianU: false,
			xianV: false,
			xianW: false,
			xianX: false,
			xianY: false,
			xianZ: false,
			xian: false,
			shouzimu: []
		};
	},

	methods: {
		getlist: function getlist() {
			var salf = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default()({
				method: 'get',
				url: 'https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/list/' + salf.getid + '?json=true'

			}).then(function (response) {

				salf.list = response.data.singers.list.info.map(function (item) {
					item.imgurl = item.imgurl.replace('{size}', '400');
					return item;
				});

				for (var i = 0; i < salf.list.length; i++) {
					salf.title = salf.title.concat(salf.list[i]);
					if (i > 6) {

						break;
					}
				}
			});
		},
		songlist: function songlist(getid) {

			window.location.href = "#/xsong/" + getid;
		},
		setscroll: function setscroll(ele, e) {

			this.isShow = e;
			this.$store.state.louti = true;
			this.$store.state.zimu = ele;
			var salf = this;
			setTimeout(function () {

				salf.$store.state.louti = false;
			}, 1000);
			var $top = null;
			try {
				if (ele === "热") {
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').animate({
						scrollTop: 0
					});
				} else {
					$top = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("." + ele + "").offset().top - 49;
					__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').animate({
						scrollTop: $top
					});
				}
			} catch (error) {
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".hot").offset().top;
			}
		},
		setsl: function setsl() {

			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').animate({
				scrollTop: 0
			});
		},
		getl: function getl() {
			this.load = true;
			var salf = this;

			this.page++;

			__WEBPACK_IMPORTED_MODULE_0_axios___default()({
				method: 'get',
				url: 'https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/list/' + salf.getid + '/' + salf.page + '?json=true'

			}).then(function (response) {
				var mylist = response.data.singers.list.info;

				salf.totlelist = salf.totlelist.concat(mylist);

				if (salf.page < 10) {
					salf.getl();
				} else {
					salf.getl1();
					return;
				}
			});
		},
		getl1: function getl1() {
			var _this = this;

			var salf = this;

			this.page++;
			__WEBPACK_IMPORTED_MODULE_0_axios___default()({
				method: 'get',
				url: 'https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/list/' + salf.getid + '/' + salf.page + '?json=true'

			}).then(function (response) {
				var mylist = response.data.singers.list.info;

				salf.totlelist = salf.totlelist.concat(mylist);

				var res = [_this.totlelist[0].singername];
				for (var c = 1; c < _this.totlelist.length; c++) {
					var repeat = false;
					for (var j = 0; j < res.length; j++) {
						if (_this.totlelist[c].singername == res[j]) {
							repeat = true;
							break;
						}
					}
					if (!repeat) {
						res.push(_this.totlelist[c].singername);
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "A") {
							salf.myA = salf.myA.concat(_this.totlelist[c]);
							salf.xianA = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "B") {
							salf.myB = salf.myB.concat(_this.totlelist[c]);
							salf.xianB = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "C") {
							salf.myC = salf.myC.concat(_this.totlelist[c]);
							salf.xianC = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "D") {
							salf.myD = salf.myD.concat(_this.totlelist[c]);
							salf.xianD = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "E") {
							salf.myE = salf.myE.concat(_this.totlelist[c]);
							salf.xianE = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "F") {
							salf.myF = salf.myF.concat(_this.totlelist[c]);
							salf.xianF = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "G") {
							salf.myG = salf.myG.concat(_this.totlelist[c]);
							salf.xianG = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "H") {
							salf.myH = salf.myH.concat(_this.totlelist[c]);
							salf.xianH = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "I") {
							salf.myI = salf.myI.concat(_this.totlelist[c]);
							salf.xianI = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "J") {
							salf.myJ = salf.myJ.concat(_this.totlelist[c]);
							salf.xianJ = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "K") {
							salf.myK = salf.myK.concat(_this.totlelist[c]);
							salf.xianK = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "L") {
							salf.myL = salf.myL.concat(_this.totlelist[c]);
							salf.xianL = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "M") {
							salf.myM = salf.myM.concat(_this.totlelist[c]);
							salf.xianM = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "N") {
							salf.myN = salf.myN.concat(_this.totlelist[c]);
							salf.xianN = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "O") {
							salf.myO = salf.myO.concat(_this.totlelist[c]);
							salf.xianO = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "P") {
							salf.myP = salf.myP.concat(_this.totlelist[c]);
							salf.xianP = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "Q") {
							salf.myQ = salf.myQ.concat(_this.totlelist[c]);
							salf.xianQ = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "R") {
							salf.myR = salf.myR.concat(_this.totlelist[c]);
							salf.xianR = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "S") {
							salf.myS = salf.myS.concat(_this.totlelist[c]);
							salf.xianS = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "T") {
							salf.myT = salf.myT.concat(_this.totlelist[c]);
							salf.xianT = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "U") {
							salf.myU = salf.myU.concat(_this.totlelist[c]);
							salf.xianU = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "V") {
							salf.myV = salf.myV.concat(_this.totlelist[c]);
							salf.xianV = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "W") {
							salf.myW = salf.myW.concat(_this.totlelist[c]);
							salf.xianW = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "X") {
							salf.myX = salf.myX.concat(_this.totlelist[c]);
							salf.xianX = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "Y") {
							salf.myY = salf.myY.concat(_this.totlelist[c]);
							salf.xianY = true;
						}
						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) == "Z") {
							salf.myZ = salf.myZ.concat(_this.totlelist[c]);
							salf.xianZ = true;
						}

						if (pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "A" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "B" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "C" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "D" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "E" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "F" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "G" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "H" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "I" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "G" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "K" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "L" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "M" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "N" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "O" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "P" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "Q" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "R" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "S" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "T" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "U" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "V" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "W" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "X" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "Y" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "Z" && pinyinUtil.getFirstLetter(_this.totlelist[c].singername.charAt(0)) !== "J") {
							salf.my = salf.my.concat(_this.totlelist[c]);
							salf.xian = true;
						}
					}
				}
				salf.load = false;
				var getlis = [];
				for (var i = 0; i < res.length; i++) {
					var mylis = pinyinUtil.getFirstLetter(res[i].charAt(0));

					getlis = getlis.concat(mylis);
				}
				var bcc = [getlis[0]];
				var bbb = "";
				var panduan = false;
				for (var a = 1; a < getlis.length; a++) {
					var repeat = false;
					for (var b = 0; b < getlis.length; b++) {
						if (getlis[a] == bcc[b]) {
							repeat = true;
							break;
						}
					}
					if (!repeat) {
						bcc.push(getlis[a]);
						bcc.sort();
					}
				}
				var bbb;
				for (var f = 0; f < bcc.length; f++) {
					if (bcc[f] !== "A" && bcc[f] !== "B" && bcc[f] !== "C" && bcc[f] !== "D" && bcc[f] !== "E" && bcc[f] !== "F" && bcc[f] !== "G" && bcc[f] !== "S" && bcc[f] !== "H" && bcc[f] !== "I" && bcc[f] !== "G" && bcc[f] !== "K" && bcc[f] !== "L" && bcc[f] !== "M" && bcc[f] !== "N" && bcc[f] !== "O" && bcc[f] !== "P" && bcc[f] !== "Q" && bcc[f] !== "R" && bcc[f] !== "S" && bcc[f] !== "U" && bcc[f] !== "V" && bcc[f] !== "W" && bcc[f] !== "X" && bcc[f] !== "Y" && bcc[f] !== "Z" && bcc[f] !== "T" && bcc[f] !== "J") {} else {
						bbb += bcc[f] + ",";
					}
				}

				bbb = bbb.slice(0, bbb.length - 1);

				bbb = bbb.split(",");
				bbb.unshift("热");
				salf.shouzimu = bbb;
			});
		}
	},
	mounted: function mounted() {
		this.getid = this.$route.params.id;
		this.getlist();
		this.getl();
		var sale = this;

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('touchmove', function (eve) {

			var page = 0;
			for (var i = 0; i < sale.shouzimu.length; i++) {
				if (sale.shouzimu[i] == "热") {
					sale.isShow = 0;
				} else {
					try {
						if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).scrollTop() > __WEBPACK_IMPORTED_MODULE_1_jquery___default()("." + sale.shouzimu[i] + "").offset().top - 49) {

							page = i;
							beack;
						}
					} catch (error) {}
				}
			}
			sale.isShow = page;
		});
	},


	components: {
		xtitle: __WEBPACK_IMPORTED_MODULE_3__xtitle_vue___default.a,
		xlouti: __WEBPACK_IMPORTED_MODULE_4__xlouti_vue___default.a,
		xload: __WEBPACK_IMPORTED_MODULE_2__xload_vue___default.a

	}
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xstom_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xstom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__xstom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xtop_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xtop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xtop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xplay_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__xplay_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			title: null,
			bigimg: null,
			getid: 0,
			xiangxi: null,
			mylist: {},
			outtime: null,
			singer: false,
			keyong: false,
			getshou: [],
			topPopup: false,
			collect: "请先登录",
			myhash: null,
			yandn: false,
			mtss: null,
			isShow: false,
			gaoll: null
		};
	},


	methods: {

		sort: function sort() {

			var salf = this;
			__WEBPACK_IMPORTED_MODULE_0_axios___default()({
				url: "https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/info/" + salf.getid + "&json=true",
				method: 'get'
			}).then(function (response) {

				salf.title = response.data.info.singername;
				var res = response.data.info.imgurl.replace('{size}', '400');

				salf.xiangxi = response.data.info.profile;
				salf.outtime = response.data.info.intro;

				salf.bigimg = res;
				var arry = [];
				var name = [];

				response.data.songs.list.forEach(function (item) {
					var obj = {};
					obj.name = item.filename.split(' - ')[1];
					obj.list = item.filename.split(' - ')[0];
					obj.hash = item.hash;

					arry.push(obj);
				});

				salf.mylist = arry;
			}).catch(function (error) {
				console.log(error);
			});
		},
		open: function open(position) {
			this[position + 'Popup'] = true;
		},
		close: function close(position) {
			this[position + 'Popup'] = false;
		},

		goback: function goback() {
			history.back();
		},
		changeDirection: function changeDirection() {

			this.$store.state.isshow = true;
		},
		setImg: function setImg(songsPlay, mindex) {
			var arr = [songsPlay];
			this.gaoll = mindex;
			this.$store.dispatch('setImg', [this.bigimg, true]);
			this.$store.dispatch('setSongs', arr);
		},


		jiantin: function jiantin(hash) {

			this.$store.state.getshou = this.getshou;
			this.myhash = hash;
		}
	},
	mounted: function mounted() {

		this.getshou = this.$store.state.getshou;

		this.$store.state.showPlay = true;

		this.getid = this.$route.params.id;

		this.sort();

		var salf = this;

		function getCookie(name) {
			var a;
			var reg = new RegExp("(^|)" + name + "=([^;]*)(;|$)");
			if (a = document.cookie.match(reg)) {
				return a[2];
			}
		};

		if (getCookie("tel") === undefined) {

			this.isShow = true;
		} else {}

		__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".liebiao").on("click", "li", function () {

			var myimg = __WEBPACK_IMPORTED_MODULE_3_jquery___default()("<img/>").attr({
				src: "data:image/png;base64,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"
			}).css({
				width: "20",
				position: "absolute",
				'left': '5px',
				'top': '15px'
			});

			var gaodu = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".play").offset().top - __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).offset().top;

			__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).append(myimg);

			myimg.animate({
				top: 0
			}, function () {
				myimg.animate({
					top: gaodu
				}, 1000, function () {
					myimg.remove();
				});
			});
		});
	},

	watch: {
		topPopup: function topPopup(val) {
			var _this = this;

			if (val) {
				setTimeout(function () {
					_this.topPopup = false;
				}, 1000);
			}
		}
	},
	updated: function updated() {

		var salf = this;
		__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.demo-checkbox').on("click", function () {
			if (salf.isShow) {
				salf.topPopup = true;
			} else {
				salf.topPopup = false;
			}
		});
	},

	computed: {
		news: function news() {
			if (this.getshou == "") {} else {
				this.$store.state.getshou = this.getshou;
			}

			return this.getshou;
		}
	},

	components: {
		xstom: __WEBPACK_IMPORTED_MODULE_1__xstom_vue___default.a,
		xtop: __WEBPACK_IMPORTED_MODULE_2__xtop_vue___default.a,
		xplay: __WEBPACK_IMPORTED_MODULE_4__xplay_vue___default.a
	}
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			hotsinger: ''

		};
	},

	methods: {
		sort: function sort() {

			var salf = this;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://bird.ioliu.cn/v1?url=http://m.kugou.com/singer/class&json=true").then(function (response) {
				var sing = response.data.list;

				salf.hotsinger = sing;
			}).catch(function (error) {
				console.log(error);
			});
		},
		singerlist: function singerlist(getid, title) {

			window.location.href = "#/singlist/" + getid;
			window.localStorage.setItem("name", title);
		}
	},
	mounted: function mounted() {
		this.sort();
	}
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {
		getRange: function getRange() {
			return this.$store.dispatch("getRange");
		}
	},
	mounted: function mounted() {
		this.getRange();
		this.$store.dispatch('setIndex', 1);
	},

	computed: {
		list: function list() {
			if (this.$store.getters.getRange) {
				var str = this.$store.getters.getRange.rank.list;
				for (var i = 0; i < str.length; i++) {
					str[i].banner7url = str[i].banner7url.replace(/{size}/g, '400');
					str[i].bannerurl = str[i].bannerurl.replace(/{size}/g, '400');
					str[i].imgurl = str[i].imgurl.replace(/{size}/g, '400');
				}
				for (var i = 0; i < str.length; i++) {
					if (str[i].rankname.slice(0, 2) == '酷狗') {
						str[i].rankname = '爱乐' + str[i].rankname.slice(2);
					}
				}
				return str;
			}
		}
	}
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ["xinfo"],
	methods: {
		goBack: function goBack() {
			history.go(-1);
		}
	}
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ["xsongs"],
	data: function data() {
		return {
			list: [],
			xlsx: false,
			getpage: null,
			lbwx: false,
			fh: false
		};
	},
	mounted: function mounted() {
		this.$watch("xsongs", function () {
			if (this.xsongs.length != 0) {
				this.list = this.list.concat(this.xsongs);
				var xthis = this;
				if (xthis.xsongs.length < 30) {
					xthis.xlsx = false;
					xthis.lbwx = true;
				}
				document.querySelector("body").onscroll = function (e) {
					var xhigth = document.documentElement.clientHeight;
					var zhight = document.body.clientHeight;
					var top = document.querySelector("body").scrollTop;

					var title = document.querySelector("body .title");
					if (title) {
						if (top > 250) {
							title.style.background = '#fc378c';
						} else {
							title.style.background = '-webkit-linear-gradient(top,rgba(0,0,0,.6),transparent)';
						}
					}

					if (xhigth + top == zhight) {
						if (xthis.xsongs.length < 30) {
							xthis.xlsx = false;
							xthis.lbwx = true;
						} else {
							xthis.xlsx = true;
						}
						xthis.getpage = xthis.getPage + 1;
						xthis.$store.dispatch('setPage', xthis.getpage);
						xthis.$store.dispatch("rangeDetails");
					}
					if (top > xhigth) {
						xthis.fh = true;
					} else {
						xthis.fh = false;
					}
				};
			} else {
				this.xlsx = false;
				this.lbwx = true;
			}
		});

		this.$watch("newMusic", function () {
			var arr = [this.newMusic];
			this.$store.dispatch('setImg', [this.newMusic.imgUrl, true]);
			this.$store.dispatch('setSongs', arr);
		});
	},

	methods: {
		onfh: function onfh() {
			var i = 0;
			var timer = setInterval(function () {
				i += 10;
				document.body.scrollTop = document.body.scrollTop - i;
				if (document.body.scrollTop <= 0) {
					clearInterval(timer);
				}
			}, 5);
		},
		music: function music(e) {
			document.querySelector("#app .kgmusic").style.display = 'block';

			var xhz = this.list[e].hash;

			this.$store.dispatch('setMusic', xhz);
		},
		xiazai: function xiazai() {
			this.$watch("newMusic", function () {
				window.location.href = this.newMusic.url;
			});
		}
	},
	computed: {
		getPage: function getPage() {
			if (this.$store.getters.giePage) {
				return this.$store.getters.giePage;
			}
		},
		newMusic: function newMusic() {
			if (this.$store.getters.newMusic) {
				var img = this.$store.getters.newMusic;
				img.imgUrl = img.imgUrl.replace(/{size}/g, '400');
				return img;
			}
		}
	}
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {
		getzxrm: function getzxrm() {
			return this.$store.dispatch("getzxrm");
		}
	},
	mounted: function mounted() {
		this.getzxrm();
	},

	computed: {
		list: function list() {
			if (this.$store.getters.getzxrm) {
				return this.$store.getters.getzxrm.data.info;
			}
		}
	}
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			list: [],
			lbwx: false,
			xlsx: false,
			getid: null,
			fh: false
		};
	},

	methods: {
		getzxrm: function getzxrm() {
			return this.$store.dispatch("getzxrm");
		},
		setsearch: function setsearch() {
			if (this.zjrm) {
				return this.$store.dispatch('setsearch', this.zjrm.keyword);
			}
		},
		getsearch: function getsearch() {
			return this.$store.dispatch("getsearch");
		},
		onfh: function onfh() {
			var i = 0;
			var timer = setInterval(function () {
				i += 10;
				document.body.scrollTop = document.body.scrollTop - i;
				if (document.body.scrollTop <= 0) {
					clearInterval(timer);
				}
			}, 5);
		},
		music: function music(e) {
			document.querySelector("#app .kgmusic").style.display = 'block';

			var xhz = this.list[e].hash;

			this.$store.dispatch('setMusic', xhz);
		},
		tooss: function tooss() {
			var tss = document.querySelector("#app .tss");
			var xthis = this;
			tss.onclick = function () {
				var val = document.querySelector("#app .ecss").value;
				xthis.list = [];
				xthis.$store.dispatch('setId', 1);
				xthis.$store.dispatch("getsearch");
			};
		},
		xiazai: function xiazai() {
			this.$watch("newMusic", function () {
				window.location.href = this.newMusic.url;
			});
		}
	},
	mounted: function mounted() {
		this.$store.dispatch('setId', 1);
		this.getzxrm();
		this.setsearch();
		this.getsearch();
		this.$watch("newsearch", function () {
			if (this.newsearch.length != 0) {
				this.list = this.list.concat(this.newsearch);
				var xthis = this;
				if (xthis.newsearch.length < 30) {
					xthis.xlsx = false;
					xthis.lbwx = true;
				}
				document.querySelector("body").onscroll = function (e) {
					var xhigth = document.documentElement.clientHeight;
					var zhight = document.body.clientHeight;
					var top = document.querySelector("body").scrollTop;

					if (xhigth + top == zhight) {
						if (xthis.newsearch.length < 30) {
							xthis.xlsx = false;
							xthis.lbwx = true;
						} else {
							xthis.xlsx = true;
						}
						xthis.getid = xthis.getId + 1;
						xthis.$store.dispatch('setId', xthis.getid);
						xthis.$store.dispatch("getsearch");
					}
					if (top > xhigth) {
						xthis.fh = true;
					} else {
						xthis.fh = false;
					}
				};
			} else {
				this.xlsx = false;
				this.lbwx = true;
			}
		});

		this.$watch("newMusic", function () {
			var arr = [this.newMusic];
			this.$store.dispatch('setImg', [this.newMusic.imgUrl, true]);
			this.$store.dispatch('setSongs', arr);
		});
		this.tooss();
	},

	computed: {
		getId: function getId() {
			if (this.$store.getters.getId) {
				return this.$store.getters.getId;
			}
		},
		zjrm: function zjrm() {
			if (this.$store.getters.getzxrm) {
				var s = this.$store.getters.getzxrm.data.info;
				var y = this.$route.query.id;
				return s[y - 1];
			}
		},
		newsearch: function newsearch() {
			if (this.$store.getters.getsearch) {
				return this.$store.getters.getsearch.data.info;
			}
		},
		newMusic: function newMusic() {
			if (this.$store.getters.newMusic) {
				var img = this.$store.getters.newMusic;
				img.imgUrl = img.imgUrl.replace(/{size}/g, '400');
				return img;
			}
		}
	}
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			ssgq: null
		};
	},

	methods: {
		fh: function fh() {
			history.go(-1);
		},
		huoqu: function huoqu() {
			this.$store.dispatch('setgq', this.ssgq);
		}
	}
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            bannerList: null,
            dataList: null,
            swiperOption: {
                autoplay: 3000,
                setWrapperSize: true,
                pagination: '.swiper-pagination',
                paginationClickable: true,
                observeParents: true
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/?json=true').then(function (response) {
            _this.bannerList = response.data.banner;
        }).catch(function (error) {
            console.log(error);
        });
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            column: null
        };
    },

    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 15) {
                return input.slice(0, 15) + '...';
            } else {
                return input;
            }
        }
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            column: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/?json=true').then(function (response) {
            _this.column = response.data.data;
        }).catch(function (error) {
            console.log(error);
        });
    },

    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 15) {
                return input.slice(0, 15) + '...';
            } else {
                return input;
            }
        }
    }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            commend: null,
            isClick: false,
            isShowMore: false,
            isShowMask: false,
            swiperOption: {
                pagination: '.swiper-pagination',
                slidesPerView: 5,
                paginationClickable: true,
                spaceBetween: 12,
                freeMode: true
            },
            isShowPlay: false,
            hash: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com?json=true').then(function (response) {
            _this.commend = response.data.data.splice(6, 5);
            console.log(_this.commend);
        }).catch(function (error) {
            console.log(error);
        });
    },

    methods: {
        showMore: function showMore() {
            this.isShowMore = !this.isShowMore;
            this.isShowMask = !this.isShowMask;
        },
        hide: function hide() {
            this.isShowMore = false;
            this.isShowMask = false;
        },
        showPlay: function showPlay(num) {
            var arr = document.getElementsByTagName('img');
            console.log(arr);

            var songList = [this.commend[num - 10]];
            this.$store.dispatch('setImg', [arr[num + 1].currentSrc, true]);
            this.$store.dispatch('setSongs', songList);
        }
    },
    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 10) {
                return input.slice(0, 10) + '...';
            } else {
                return input;
            }
        }
    }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            screenHight: null,

            isClick: false,
            comData: null,
            isShowAlert: false,

            ifUpdate: false,
            newArr: []
        };
    },
    mounted: function mounted() {
        this.screenHight = window.screen.availHeight;
        var self = this;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('../static/data/comment.json').then(function (response) {
            var commentCount = self.$route.params.id * 1;
            self.comData = response.data.RECORDS.splice(commentCount, 10);
            console.log(self.comData);
            self.ifUpdate = false;
        }).catch(function (error) {
            console.log(error);
        });
    },

    computed: {
        showComment: function showComment() {
            if (this.$store.state.showComment == true) {
                this.screenHight = 0;
            } else {
                this.screenHight = window.screen.availHeight;
            }
        },
        newComment: function newComment() {
            return this.$store.state.newComment;
        }
    },
    methods: {
        hideComment: function hideComment() {
            this.$store.state.showComment = false;
            this.$store.state.isShowContainer = true;
            console.log(this.$store.state.isShowContainer);
        },
        buttonClick: function buttonClick() {
            this.isClick = true;
        },
        send: function send() {
            var cookie = com.getCookie('tel');

            if (cookie == '') {
                this.isShowAlert = true;
            } else {
                this.ifUpdate = true;
                var date = new Date();
                var now = com.currentTime(date);
                var self = this;

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:8008/savecomment', {
                    params: {
                        imgurl: '../../static/images/404.png',
                        author: com.getCookie('tel'),
                        editetime: now,
                        content: document.getElementsByTagName('input')[0].value
                    }
                }).then(function (response) {
                    self.newArr.push(response.data[0]);
                    self.$store.state.newComment = self.newArr;
                    self.$store.state.newCommentCount = self.newArr.length;
                    console.log(self.$store.state.newCommentCount);
                    document.getElementsByTagName('input')[0].value = '';
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        hideAlert: function hideAlert() {
            this.isShowAlert = false;
        }
    }
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {



module.exports = {
	computed: {
		title: function title() {
			return this.$store.getters.getCount;
		},
		sildeShow: function sildeShow() {
			return this.$store.state.sildeShow;
		}
	},
	mouted: function mouted() {
		this.$store.state.sildeShow = false;
	},

	methods: {
		changeDirection: function changeDirection() {
			this.$store.state.direction = "right";

			this.$store.state.sildeShow = true;
		},
		search: function search() {
			window.location.href = '#/search';
		}
	}
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hotList: null,

            isShowPlay: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com?json=true').then(function (response) {
            _this.hotList = response.data.data.splice(0, 6);
            console.log(_this.hotList);
        }).catch(function (error) {
            console.log(error);
        });
    },

    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 15) {
                return input.slice(0, 15) + '...';
            } else {
                return input;
            }
        }
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ["getload"],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			_telephone: '',
			_password: '',
			dialog: false,
			openCon: ''
		};
	},
	mounted: function mounted() {
		this.$store.state.sildeShow = false;
	},

	methods: {
		handlechange: function handlechange(val) {
			console.log('you choose ' + val);
		},
		handleInput: function handleInput(val) {
			this.dataSource = [val, val + val, val + val + val];
		},
		open: function open() {
			this.dialog = true;
		},
		close: function close() {
			this.dialog = false;
		},
		toRegister: function toRegister() {
			location.href = "#/register";
		},
		gotoLogin: function gotoLogin() {
			var inputCon = document.getElementsByClassName("mu-text-field-input");
			this._telephone = inputCon[0].value;
			this._password = inputCon[1].value;
			console.log(this._telephone, this._password);

			document.cookie = 'tel=' + this._telephone;

			this.sendLogin();
		},

		sendLogin: function sendLogin() {
			var _this = this;

			this.$ajax({
				url: 'http://localhost:12345/login',
				params: {
					telephone: this._telephone,
					password: this._password
				}
			}).then(function (res) {

				console.log(res);
				_this.open();
				if (res.data.user.length == 0) {
					console.log(123);
					_this.openCon = '登录帐号或登录密码错误';
				}
				if (res.data.user.length == 1) {
					console.log(222);
					console.log(_this.$store.state.loginStatus);
					var cookies = document.cookie;
					if (cookies) {
						console.log(666);
						var arr = cookies.split('; ');
						arr.forEach(function (item) {
							var temp = item.split('=');
							location.href = '/app/newSong/';
						});
					}
				}
			}).catch(function (error) {
				console.log(error);
				_this.openCon = '香菇，登录失败了,请重新输入';
			});
		}
	}
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	computed: {
		louti: function louti() {

			return this.$store.state.louti;
		},
		zimu: function zimu() {
			return this.$store.state.zimu;
		}
	}
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isClick: true,
            isShowMore: false,
            isShowMask: false,
            music_src: '',
            songName: '',
            singerName: '',
            page: 0,
            src: '' };
    },

    methods: {
        playStatus: function playStatus() {
            var audio = document.getElementById('audio');

            this.isClick = audio.paused;
            if (audio.paused) {
                audio.play();
            } else {
                audio.pause();
            }
        },
        showMore: function showMore() {
            this.isShowMore = !this.isShowMore;
            this.isShowMask = !this.isShowMask;
        },
        hide: function hide() {
            this.isShowMore = false;
            this.isShowMask = false;
        },
        icondiyPlay: function icondiyPlay(index, hash) {
            var _this = this;

            this.page = index;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash).then(function (response) {
                _this.music_src = response.data.url;

                _this.singerName = response.data.singerName;
                _this.songName = response.data.songName;

                _this.isClick = true;
                _this.isShowMore = false;
                _this.isShowMask = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        download: function download() {
            var audio = document.getElementById('audio');
            var down = document.getElementById('down');
            var src = audio.src;
        },
        record_msg: function record_msg() {
            window.location.href = "#/song";
        }
    },
    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 15) {
                return input.slice(0, 15) + '...';
            } else {
                return input;
            }
        }
    },
    computed: {
        imgUrl: function imgUrl() {
            return this.$store.getters.getImgurl;
        },
        showPlay: function showPlay() {
            return this.$store.getters.showPlay;
        },
        songsPlay: function songsPlay() {
            var _this2 = this;

            if (this.$store.getters.songsPlay.length === 0) {
                return;
            }

            var hash = this.$store.getters.songsPlay[0].hash;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash).then(function (response) {
                _this2.music_src = response.data.url;

                _this2.singerName = response.data.singerName;
                _this2.songName = response.data.songName;

                var audio = document.getElementById('audio');
                _this2.page = 0;
                _this2.isClick = true;

                var record = _this2.$store.getters.songsPlay;
                _this2.$store.dispatch('setRecord', record);
                _this2.$store.dispatch('setrecordCover', record);
            }).catch(function (error) {
                console.log(error);
            });
            return this.$store.getters.songsPlay;
        }
    },
    mounted: function mounted() {
        var index = 2;
        var audio = document.getElementById('audio');
        audio.onended = function (e) {
            var _this3 = this;

            var hash = self.$store.getters.songsPlay[index].hash;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash).then(function (response) {
                _this3.music_src = response.data.url;
                console.log(_this3.music_src);

                _this3.singerName = response.data.singerName;
                _this3.songName = response.data.songName;

                var audio = document.getElementById('audio');
                audio.play();
                _this3.isClick = true;
            }).catch(function (error) {
                console.log(error);
            });
        };

        var progress = document.getElementById('progress');
        var bar = document.getElementById('bar');

        audio.addEventListener('timeupdate', function () {
            var scales = audio.currentTime / audio.duration;
            bar.style.width = progress.offsetWidth * scales + "px";
        }, false);
    }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            telephone: '',
            password: '',
            repassword: '',
            nickname: '',
            imgurl: '',
            dialog: false,
            openCon: '',
            picImg: false,
            data: ''
        };
    },
    mounted: function mounted() {
        this.$store.state.sildeShow = false;
    },

    methods: {
        open: function open() {
            this.dialog = true;
        },
        close: function close() {
            this.dialog = false;
        },
        gotoRegister: function gotoRegister() {
            this.open();

            var inputCon = document.getElementsByClassName("mu-text-field-input");
            var imgurl = document.querySelector('#uploadForm input').files;

            var _telephone = inputCon[0].value;

            this.telephone = _telephone;

            if (!/^1[3-57-9]\d{9}$/.test(_telephone)) {
                this.openCon = '您输入的手机号不正确！请重新输入正确的手机号';
                return false;
            }

            var _nickname = inputCon[1].value;

            this.nickname = _nickname;
            if (!/^([\u2E80-\u9FFF]*)|[a-zA-Z]*$/.test(_nickname)) {
                this.openCon = '您的输入不符合规则，请输入中/英文的昵称';
                return false;
            }

            var _password = inputCon[2].value;

            this.password = _password;

            if (!/^\S{6,20}$/.test(_password)) {
                this.openCon = '密码不合法,请输入6-20位的密码';
                return false;
            }

            var _repassword = inputCon[3].value;

            this.repassword = _repassword;

            if (_repassword !== _password) {
                this.openCon = '两次输入密码不一致';
                return false;
            }

            this.sendReg();
        },
        sendReg: function sendReg() {
            var _this = this;

            this.$ajax({
                url: 'http://localhost:12345/register',
                params: {
                    telephone: this.telephone,
                    nickname: this.nickname,
                    password: this.password,
                    repassword: this.repassword
                }
            }).then(function (res) {
                var inputCon = document.getElementsByClassName("mu-text-field-input");
                _this._telephone = inputCon[0].value;
                _this._password = inputCon[1].value;
                console.log(_this._telephone, _this._password);

                document.cookie = 'tel=' + _this._telephone;

                var cookies = document.cookie;
                if (cookies) {
                    console.log(666, cookies);
                    var arr = cookies.split('; ');
                    arr.forEach(function (item) {
                        var temp = item.split('=');
                        location.href = '/';
                    });
                }
            }).catch(function (error) {
                console.log(error);
                _this.openCon = '蓝瘦，注册不幸失败了，请重新注册';
            });
        },
        doUpload: function doUpload() {
            var dd = new FormData(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#uploadForm')[0]);
            var _self = this;
            console.log(dd);
            console.log(_self);
            dd.append('headpic', document.querySelector('#uploadForm input').files[0]);
            console.log(document.querySelector('#uploadForm input').files);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: 'http://localhost:12345/upload-single',
                type: 'POST',
                cache: false,
                data: dd,
                processData: false,
                contentType: false,
                success: function success(data) {
                    console.log(_self.telephone);
                    console.log(data);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".headpic").attr("src", "../../static/uploads/" + data);

                    console.log(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".headpic").attr("src", "../../static/uploads/" + data)[0].src);
                    var imgurl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".headpic").attr("src", "../../static/uploads/" + data)[0].src;

                    _self.$ajax({
                        url: 'http://localhost:12345/touxiang',
                        params: {
                            telephone: _self.telephone,
                            imgurl: imgurl
                        }
                    }).then(function (res) {
                        console.log(res);
                        console.log(6666, res.config.params.imgurl);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        uploadImg: function uploadImg() {
            console.log(123);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#uploadForm input").trigger('click');
        }
    }

});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			telephone: '',
			singername: ''
		};
	},

	methods: {}
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
	data: function data() {
		return {
			logReg: false,
			nickname: null,
			savePage: false
		};
	},

	computed: {
		direction: function direction() {
			return this.$store.state.direction;
		},
		sildeShow: function sildeShow() {
			return this.$store.state.sildeShow;
		}
	},
	mounted: function mounted() {
		this.$store.state.sildeShow = false;
	},

	methods: {
		changeDirection: function changeDirection() {
			this.$store.state.direction = "left";

			this.$store.state.sildeShow = false;
		},
		clearCookie: function clearCookie() {
			this.logReg = false;
			com.setCookie('tel', '');
		}
	}
}, 'mounted', function mounted() {
	var cookie = com.getCookie('tel');
	console.log(com.getCookie('tel'));
	if (cookie.length > 0) {
		this.logReg = true;
	} else {
		this.logReg = false;
	}
	this.nickname = com.getCookie('tel');
}));

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            info: ''
        };
    },

    methods: {
        setImg: function setImg(imgUrl, songsPlay) {
            this.$store.dispatch('setImg', [imgUrl, true]);
            this.$store.dispatch('setSongs', songsPlay);
        }
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/plist/index&json=true').then(function (response) {
            _this.info = response.data.plist.list.info.map(function (item) {
                item.imgurl = item.imgurl.replace('{size}', '400');
                return item;
            });
        }).catch(function (error) {
            console.log(error);
        });
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

	props: ["list", "get", "xiang", "outtime"],
	methods: {
		show: function show() {
			this.$store.state.isshow = false;
		}
	},
	computed: {
		isShow: function isShow() {
			console.log("1");
			return this.$store.state.isshow;
		}
	}
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			mytitle: ''
		};
	},

	methods: {
		goback: function goback() {
			history.back();
		}
	},
	mounted: function mounted() {
		this.mytitle = window.localStorage.getItem("name");
	}
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            column: null
        };
    },

    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 15) {
                return input.slice(0, 15) + '...';
            } else {
                return input;
            }
        }
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_xheader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    xheader: __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue___default.a,
    Tab: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue___default.a,
    TabItem: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue___default.a,
    xsilde: __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue___default.a
  },
  data: function data() {
    return {
      index: NaN
    };
  },
  mounted: function mounted() {
    this.index = this.getIndex;
  },

  computed: {
    getIndex: function getIndex() {
      if (this.$store.getters.Index) {
        return parseInt(this.$store.getters.Index);
      }
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    methods: {
        send: function send() {
            var askSpan = document.createElement('span');
            var askLi = document.createElement('li');
            var Ul = document.getElementsByClassName('msg')[0];
            askLi.classList.add("ask");
            Ul.appendChild(askLi);
            askLi.appendChild(askSpan);
            askSpan.innerText = document.getElementsByTagName('input')[0].value;

            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://www.tuling123.com/openapi/api?key=f34ac5e4a62f423fb7638f65ecc97e4d', {
                params: {
                    info: document.getElementsByTagName('input')[0].value
                }
            }).then(function (response) {
                var answerSpan = document.createElement('span');
                var answerLi = document.createElement('li');
                Ul.appendChild(answerLi);
                answerLi.classList.add("answer");
                answerLi.appendChild(answerSpan);
                answerSpan.innerText = response.data.text;
                document.getElementsByTagName('input')[0].value = "";
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            page: 1,

            data: null,
            total: null,
            pageConut: null,
            pageNum: []
        };
    },

    methods: {
        changeContent: function changeContent(index) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:8008/comment', {
                params: {
                    page: index + 1
                }
            }).then(function (response) {
                self.data = response.data.data;
                console.log(self.data);
                console.log(self);
            }).catch(function (error) {
                console.log(error);
            });
        },
        sendId: function sendId(did) {
            console.log(did);
        }
    },
    mounted: function mounted() {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:8008/comment', {
            params: {
                page: this.page
            }
        }).then(function (response) {
            self.data = response.data.data;
            self.total = response.data.num;
            self.pageCount = Math.ceil(self.total / 10);
            console.log(self.pageNum, self.pageCount, self.total);
            for (var i = 1; i <= self.pageCount; i++) {
                self.pageNum.push(i);
            }
            console.log(self.pageNum);
        }).catch(function (error) {
            console.log(error);
        });
    },

    filters: {
        shortTitle: function shortTitle(input) {
            if (input.length > 10) {
                return input.slice(0, 10) + '...';
            } else {
                return input;
            }
        }
    },
    computed: {}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xlogin_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xlogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_xlogin_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		xlogin: __WEBPACK_IMPORTED_MODULE_0__components_xlogin_vue___default.a
	}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            singleComment: null
        };
    },
    mounted: function mounted() {
        console.log(this.$route.params.id * 1);
        var self = this;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:8008/mod', {
            params: {
                id: this.$route.params.id * 1
            }
        }).then(function (response) {
            self.singleComment = response.data[0];
            console.log(self.singleComment);
        }).catch(function (error) {
            console.log(error);
        });
    },

    methods: {
        showAlert: function showAlert() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://localhost:8008/save', {
                params: {
                    id: self.singleComment.id,
                    title: self.singleComment.title,
                    subtitle: self.singleComment.subtitle,
                    rating: self.singleComment.rating,
                    content: self.singleComment.content
                }
            }).then(function (response) {
                self.singleComment = response.data[0];
                console.log(self.singleComment);
            }).catch(function (error) {
                console.log(error);
            });
            console.log(this.singleComment.content);
            alert('保存成功');
        }
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xbanner_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xbanner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_xbanner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_xhot_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_xhot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_xhot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xcommend_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xcommend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_xcommend_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xcolumn_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xcolumn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_xcolumn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xchosen_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xchosen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xchosen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xzhuanlang_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xzhuanlang_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xzhuanlang_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xplay_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xplay_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		xbanner: __WEBPACK_IMPORTED_MODULE_0__components_xbanner_vue___default.a,
		xhot: __WEBPACK_IMPORTED_MODULE_1__components_xhot_vue___default.a,
		xcommend: __WEBPACK_IMPORTED_MODULE_2__components_xcommend_vue___default.a,
		xcolumn: __WEBPACK_IMPORTED_MODULE_3__components_xcolumn_vue___default.a,
		xchosen: __WEBPACK_IMPORTED_MODULE_4__components_xchosen_vue___default.a,
		xzhuanlang: __WEBPACK_IMPORTED_MODULE_5__components_xzhuanlang_vue___default.a,
		xplay: __WEBPACK_IMPORTED_MODULE_6__components_xplay_vue___default.a
	},
	mounted: function mounted() {
		this.$store.dispatch('setIndex', '0');
	}
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xcomment_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xcomment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_xcomment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        xcomment: __WEBPACK_IMPORTED_MODULE_2__components_xcomment_vue___default.a
    },
    data: function data() {
        return {
            data: null,
            word: ['关注', '已关注'],
            num: 0,
            newCommentCount: [],
            height: ''
        };
    },
    updated: function updated() {
        var height = JSON.parse(com.getCookie('height'));
        for (var i = 0; i < height.length; i++) {
            if (height[i].id == this.$store.state.commentNum) {
                window.scrollTo(0, height[i].height);
            }
        }
    },
    mounted: function mounted() {
        var id = this.$route.params.id * 1;
        console.log(this.isShowContainer);
        var self = this;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('../static/data/passage.json').then(function (response) {
            self.data = response.data.RECORDS[9 - id];
            self.$store.state.commentNum = self.data.id;
            console.log(self.data);
        }).catch(function (error) {
            console.log(error);
        });
    },

    methods: {
        focusStatus: function focusStatus(num) {
            if (this.num == 0) {
                this.num = 1;
            } else {
                this.num = 0;
            }
        },
        showInput: function showInput() {
            this.isShowInput = true;
        },
        watchComment: function watchComment() {
            this.$store.state.showComment = true;
            this.$store.state.isShowContainer = false;
        },
        historyHight: function historyHight() {
            var obj = { "id": this.data.id, "height": window.scrollY };
            this.$store.state.arrHight.push(obj);
            com.setCookie('height', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.arrHight));
        }
    },
    computed: {
        isShowContainer: function isShowContainer() {
            return this.$store.state.isShowContainer;
        }
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_r_content_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_r_content_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_r_content_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    r_content: __WEBPACK_IMPORTED_MODULE_0__components_r_content_vue___default.a
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rangeDetails_banner_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rangeDetails_banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_rangeDetails_banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rangeDetails_list_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rangeDetails_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_rangeDetails_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xplay_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_xplay_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	components: {
		Banner: __WEBPACK_IMPORTED_MODULE_0__components_rangeDetails_banner_vue___default.a,
		List: __WEBPACK_IMPORTED_MODULE_1__components_rangeDetails_list_vue___default.a,
		xplay: __WEBPACK_IMPORTED_MODULE_2__components_xplay_vue___default.a
	},
	methods: {
		getDetails: function getDetails() {
			return this.$store.dispatch("rangeDetails");
		}
	},
	mounted: function mounted() {
		this.$store.dispatch('setPage', 1);
		this.$store.dispatch('setDetails', this.$route.params.id);
		this.getDetails();
		this.$watch("songs", function () {});
	},

	computed: {
		info: function info() {
			if (this.$store.getters.getDetails) {
				var str = this.$store.getters.getDetails.info;
				str.banner7url = str.banner7url.replace(/{size}/g, '400');
				str.bannerurl = str.bannerurl.replace(/{size}/g, '400');
				str.imgurl = str.imgurl.replace(/{size}/g, '400');
				for (var i = 0; i < str.length; i++) {
					if (str[i].rankname.slice(0, 2) == '酷狗') {
						str[i].rankname = '爱乐' + str[i].rankname.slice(2);
					}
				}
				return str;
			} else {
				return ' ';
			}
		},
		songs: function songs() {
			if (this.$store.getters.getDetails) {
				return this.$store.getters.getDetails.songs.list;
			}
		}
	}
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xregister_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xregister_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_xregister_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		xregister: __WEBPACK_IMPORTED_MODULE_0__components_xregister_vue___default.a
	}
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_xheader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_sheader_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_sheader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_search_sheader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xplay_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xplay_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    xheader: __WEBPACK_IMPORTED_MODULE_2__components_xheader_vue___default.a,
    Tab: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tab_tab_vue___default.a,
    TabItem: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tab_tab_item_vue___default.a,
    xsilde: __WEBPACK_IMPORTED_MODULE_3__components_xsilde_vue___default.a,
    sheader: __WEBPACK_IMPORTED_MODULE_4__components_search_sheader_vue___default.a,
    xplay: __WEBPACK_IMPORTED_MODULE_5__components_xplay_vue___default.a
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xshoucang_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xshoucang_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_xshoucang_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		xshoucang: __WEBPACK_IMPORTED_MODULE_0__components_xshoucang_vue___default.a
	}
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	mounted: function mounted() {
		this.$store.dispatch('setIndex', 3);
	}
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_skPlayer_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_skPlayer_scss__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_skPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_skPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            "zhuan": true,
            "appear": true,
            afterlyric: [],
            time: null,
            currentIndex: -1,
            i: 0
        };
    },

    computed: {
        songlist: function songlist() {
            return this.$store.getters.getRecord;
        },
        test: function test() {
            return this.$store.getters.getRecord[0].cover;
        },
        recordCover: function recordCover() {
            return this.$store.getters.getrecordCover;
        },
        lyric: function lyric() {
            var i = this.i;
            return this.$store.getters.getRecord[i].lyric;
        }
    },
    filters: {
        lyric: function lyric(val) {
            val = val.replace(/\[\d{2}:\d{2}.\d{2}\]/g, '');
            return val;
        }
    },
    methods: {
        back: function back() {
            window.history.back();
        },
        parseLyric: function parseLyric(lyric) {
            var lines = lyric.split('\n');
            var pattern = /\[\d{2}:\d{2}.\d{2}\]/g;
            var result = [];
            while (!pattern.test(lines[0])) {
                lines = lines.slice(1);
            }
            lines[lines.length - 1].length === 0 && lines.pop();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var data = _step.value;

                    var index = data.indexOf(']');
                    var time = data.substring(0, index + 1);
                    var value = data.substring(index + 1);
                    var timeString = time.substring(1, time.length - 2);
                    var timeArr = timeString.split(':');
                    result.push([Math.floor(timeArr[0], 10) * 60 + Math.floor(timeArr[1]), value]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            result.sort(function (a, b) {
                return a[0] - b[0];
            });
            return result;
        }
    },
    mounted: function mounted() {
        var songlist = this.$store.getters.getRecord;
        var player = new __WEBPACK_IMPORTED_MODULE_1__lib_skPlayer_js__["a" /* default */]({
            listshow: false,
            music: {
                type: 'file',
                source: songlist
            }
        });
        player.play();

        var audio = document.querySelector('.skPlayer-source');
        var kPlayer = document.querySelector('.skPlayer-play-btn');
        var self = this;
        var list = document.querySelectorAll('.skPlayer-list li');

        kPlayer.onclick = function () {
            if (audio.paused) {
                self.zhuan = false;
            } else {
                self.zhuan = true;
            }
        };

        var _loop = function _loop(i) {
            list[i].onclick = function () {
                setTimeout(function () {
                    var imgHead = document.querySelector('.skPlayer-cover');
                    self.$store.dispatch('setrecordCover', imgHead.src);
                }, 300);

                if (audio.paused) {
                    self.zhuan = true;
                } else {
                    self.zhuan = true;
                }

                self.i = i;
                self.afterlyric = self.parseLyric(self.lyric);
            };
        };

        for (var i = 0; i < list.length; i++) {
            _loop(i);
        }

        var lyric = this.parseLyric(this.lyric);
        this.afterlyric = lyric;

        audio.ontimeupdate = function () {
            var playtime = Math.floor(audio.currentTime);
            var currentIndex = 0;
            for (var i = 0; i < self.afterlyric.length; i++) {
                if (playtime === self.afterlyric[i][0]) {
                    self.currentIndex = i;
                }
            }
        };

        var ad = document.querySelector('.skPlayer-list-switch');
        ad.onclick = function () {

            if (self.appear) {
                self.appear = false;
            } else {
                self.appear = true;
            }
        };
    },

    watch: {
        afterlyric: function afterlyric(val) {
            this.afterlyric = val;
            console.log(this.afterlyric);
        },
        test: function test(val) {
            console.log('test', val);
        }
    }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xsonglist_xsonglist_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_xsonglist_xsonglist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_xsonglist_xsonglist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_xplay_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_xplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_xplay_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		xsonglist: __WEBPACK_IMPORTED_MODULE_0__components_xsonglist_xsonglist_vue___default.a,
		xplay: __WEBPACK_IMPORTED_MODULE_1__components_xplay_vue___default.a
	},
	mounted: function mounted() {
		this.$store.dispatch('setIndex', 2);
	}
});

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABTklEQVRYR+2W7W3CMBCG8QZsQDsBjBA2gAmADdiAMAkwQdkAmKDdANgAJgjPSRfJ6o/6/KFGICydHCmO3+fe80dcr+PmOtbvvQFe04GmaT6ccxfL+iruAOI1wisATHObBlkykTGIb+lmxAJ9eQ62YgAqPkFxaRUXumwAhPvMcyA+iQrxn2Da3oAsgFzxLAcQHzHBF3EnJtZV/9udJAdUXGy/qu23GNv9sdEAiFea+Yl+TubJ4tElQHzORxtih7A8ZzezA3K6oXYuKR7lgNb9m4+mZL/PTl0nMDsg41NOuhBoFIBC1PQrosaJdUgg9D4aQCHaxbgFYhES+et9EoBCVPSyFtp1kbQdkwEUQk7Do+6OccqZkAWgEHIZCcSAEIj/u4za2uqlJOUY6jYVIFPLdsBXSdmmRQH8bdrJL5lXku5+Sk2F9wYVL8Eb4OkceADIkW8hn/RFxwAAAABJRU5ErkJggg=="

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAMAAABf788oAAAA21BMVEXW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tYTgVLNAAAASHRSTlMAAQIDBAUGCAkKCw0QExYXGRofIygtOjxCSU9WV1xdZWxtdHx9hY2OlZydpKWrrK6yub/FytDU1dna297i5unw8/X3+Pn7/P4lVMsaAAAAoElEQVQYGVXB5wKBABQG0I8QiuyRvSOjInuPuu//RH527zlIL2sQ8vdnA0Ll+jEhlI5BF4LhhwMI+pbGEDIuzWLgUitaKOCUOa1T4GJTcrMQRrTVIfRD34DQ+Z1KEMy3D6H+OINrvm5VMO3vpQymFxyKYIbhLgdmQp6GSNwiR0UkYZOdRER1yIojonk0AZPbhUMwhX3QA5M5f1vgEpsmuD9uphGpqZmkPQAAAABJRU5ErkJggg=="

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAMAAADn2eWTAAAAtFBMVEW7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7sIZiW3AAAAO3RSTlMAAQMEBQYJDQ8TFBUXHB4pKi0zP0BKS1FfZ2xtdHh+gYSNkpakpqipqqu0vczOz9DR0t3j7fDy8/X2/KcZEEkAAACySURBVCjP7c5HDsJADEBR0yGh995rqKGHf/97sZgAE8SwY8df2XqSZRG90nGVFmNTaJrVgc5fJdToWy/NDyoBrYObfGjhxC2vaxtYxpRmDkBZ18QamIQd6CRdYBIKnE5tgJED3SUwDb/9ldoAVzgDsyfmhjU1WFv85gprw5zs8eKK7W0A4x57AbL+GXsHsIioLQvoKrYLi6gYVKxx74EfVO/3Wi1+quqrOfG+4EVaFzO27nF/QCFT9MC+AAAAAElFTkSuQmCC"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAoCAMAAADT08pnAAABdFBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+8RKoNAAAAe3RSTlMAAQIDBAUGBwgJCgsNDg8QERMUFhcYGRscHyAhJykrLzI1ODo+QUJERklLT1NXWFldXmNlZmhqbm9wcXZ4e36DhImMj5KWl5ufoqSmqK6wsrS4uby9v8HDxcfLzM3O0NTW19ja3N7f4ePl5ujq6+7v8fP09fb3+Pn6/P68ekp6AAABD0lEQVQYGW3B1UJCURQE0LliYndhd2J3d3cXtiiILTE/r2e/nQ1rIYHW6+AgEvBGSI4gzkCU/4LQxmI0zqFMUQSqYXHmKJ48sCQtUdyVw5K8RuErhiVti+IsHxb3HsVRNiw5xxS7blgKLig2U2Ep8VGsumCpuKdYdGDx+ClmHVhqAhSTsNWHaMSGYWv6oBHtg635m0a4C8ojjZ92aC80QnXQuqM03huheSM0vtqgdfzSCHdCa/mkEe2B1vBGIzYErfaVYgJa1TPFDLTKB4oFB0rpDcWKC0rhJcVGKpTcE4qdDCiZBxSHWVDStylO86CkrFNcFUFxLVPclkFx5in2EWeahh/xxmMkR5FAbzDQjz+Z84hQwwhIsQAAAABJRU5ErkJggg=="

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAADe0lEQVR4Xu3dsW4TQRDG8VxNQQ+ip0mBFEoeAypaeluy5MfAxgVPwIukoaBLwwsgJBQqOku2zAIiOuTYXDFa3d780vq0Nzvz1858s7uXbjabHS78pfVAB4C0sf89cQDkjj8Aksf/GIDD4fCq67rb7I6Z4vxLbN+X2D7tz+0oBez3+yebzebLFB2QfU6l3vtUfHAFgKQkACBp4P9OGwAAkAIyM2AFyBz9MncAAEAKyMyAFSBz9KWA5NEHAACkgOQMAAAAVEBmBqwAmaOvCEwefQAAQApIzkB6AJbL5cPtdvvsDAfb1Wr1caqcpAdgPp+/KOfirk8FuPz2db1ePwbARM8EAiD5mUAAAEAKyHwq2ApgBbACWAGogLQXQ6QAKUAKkAKkACngRKtPJ7A4Zsq3g9UAagA1gBpADaAGUAPceSDVF0LUAGoANYAaQA2gBlADqAHuY0AjSCPImUCdQIdCJ/uhSDKQDCQDyUAykAwkA8lAMvCPB+wF9EjQB9AH0AfQB9AH0AeY6PVg18NdD8/9lTCdQJ1AnUCdQJ3Aap3AxWLxYLfbPR9RTXVZbHl3xp7v5beXI7L3W/lm0ecoe6oXgSXnXpbmyk3UBBKO86EA8Dpq3gCI8mS9cQBQz9ejfBMARhmWekYBoJ6vR/kmAIwyLPWMAkA9X4/yTQAYZVjqGdU2APX8NOxN9gLsBdgLsBdgL6DaXsCwhbneU1KAFCAFSAFSgBRwIus4Fl4c41SwU8FOBderS6u+qfp5gKqzG/AyKoAKoAKoACqACqAC7jzgdnAPBjKQDHQ7WB9AH0AfYICkbPERfQC3g90O9t/DL67IQDKQDLyPATKQDCQDyUAykAxsUeMNsJkMJAPJQDKQDLw+tVpSAVQAFUAFUAFUwICKusVHqAAqgAqgAqgAKqCXv5wJdCZwdugXNFQAFTBlFfDr07WbMxX8bfk065i+FRwqNtKrgFBvNjgYABoMWqTJAIj0ZoNjAaDBoEWaDIBIbzY4FgAaDFqkyQCI9GaDYwGgwaBFmgyASG82OBYAGgxapMkAiPRmg2MBoMGgRZoMgEhvNjgWABoMWqTJAIj0ZoNjAaDBoEWaDIBIbzY4FgAaDFqkyQCI9GaDYw0CoJyZe9t13Y8G58fk/3igxPZNie2j/mNHx8J5MZcHAJAr3kezBQAA/r0Yktwf6ab/ExQ5RHn/OBK7AAAAAElFTkSuQmCC"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.a5dc46c.png";

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xshoucang')
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xregister')], 1)
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.singleComment) ? _c('div', [_vm._v("\n    标题：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.title),
      expression: "singleComment.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.title = $event.target.value
      }
    }
  }), _vm._v(" 类目：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.subtitle),
      expression: "singleComment.subtitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.subtitle = $event.target.value
      }
    }
  }), _vm._v(" 等级：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.rating),
      expression: "singleComment.rating"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.rating)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.rating = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 内容：\n    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.content),
      expression: "singleComment.content"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.singleComment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', [_c('a', {
    attrs: {
      "href": "#/db/"
    },
    on: {
      "click": _vm.showAlert
    }
  }, [_vm._v("保存")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xsonglist'), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerList) ? _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.bannerList), function(i) {
    return _c('swiper-slide', {
      key: i.id
    }, [_c('img', {
      attrs: {
        "src": i.imgurl
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('xheader'), _vm._v(" "), _c('xsilde'), _vm._v(" "), _c('tab', {
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, [_c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/newSong'
    }
  }, [_vm._v("新歌")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/range'
    }
  }, [_vm._v("排行")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/songSheet'
    }
  }, [_vm._v("歌单")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/singer'
    }
  }, [_vm._v("歌手")])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hotList) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "firstErji"
  }), _vm._v(" "), _c('span', {
    staticClass: "firstBofang"
  }), _vm._v(" "), _c('i', {
    staticClass: "firstI"
  }, [_vm._v(_vm._s(_vm.hotList[0].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://y.gtimg.cn/music/photo_new/T002R300x300M000002sib2i06iuRx.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[0].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "middle"
  }, [_c('span', {
    staticClass: "firstErji"
  }), _vm._v(" "), _c('span', {
    staticClass: "firstBofang"
  }), _vm._v(" "), _c('i', {
    staticClass: "firstI"
  }, [_vm._v(_vm._s(_vm.hotList[1].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000nKeGK4Fy9tu.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[1].filename)))])]), _vm._v(" "), _c('section', [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[2].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002glrSP3MSICO.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[2].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "four"
  }, [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[3].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000cKyUv3XjHPm.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[3].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "middle"
  }, [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[4].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000003Nhohk0w0hey.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[4].filename)))])]), _vm._v(" "), _c('section', [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[5].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002zVHhH3WaYou.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[5].filename)))])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("热门推荐")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xlogin')], 1)
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab-item",
    class: [_vm.currentSelected ? _vm.activeClass : '', {
      'vux-tab-selected': _vm.currentSelected,
      'vux-tab-disabled': _vm.disabled
    }],
    style: (_vm.style),
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default"), _vm._v(" "), (typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '') ? _c('span', {
    staticClass: "vux-tab-item-badge",
    style: ({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })
  }, [_vm._v(_vm._s(_vm.badgeLabel))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 5
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_musicmall_focus/124141.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("陈粒在蓬莱")])])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 8
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124253.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("中年贾跃亭和朴树，都在为钱奔波")])])]), _vm._v(" "), _c('section', {
    staticClass: "bottom"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 7
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124060.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("歌都不会唱当什么超级英雄")])])]), _vm._v(" "), _c('section', {
    staticClass: "left bottom"
  }, [_c('a', {
    attrs: {
      "href": '#/passageDetail/' + 9
    }
  }, [_c('img', {
    attrs: {
      "src": "https://y.gtimg.cn/music/common/upload/t_focus_info_iphone/124219.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("我欲渡你成佛，却被你渡成魔")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("专栏")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('r_content')], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "song"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "iconfont icon-home",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-search"
  })]), _vm._v(" "), _c('div', {
    staticClass: "song-info"
  }, [_c('div', {
    class: {
      'zhuan': _vm.zhuan
    },
    attrs: {
      "id": "picture"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.recordCover,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lyric"
  }, [_c('ul', {
    staticClass: "lrc-inner",
    staticStyle: {
      "transition": "all 0.3s ease-out"
    },
    style: ({
      'top': (-20 * _vm.currentIndex + 'px')
    })
  }, _vm._l((_vm.afterlyric), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'font': index === _vm.currentIndex
      },
      style: ({
        'color': index === _vm.currentIndex ? '#fc378c' : '#8e9ba1'
      }),
      attrs: {
        "id": index
      }
    }, [_vm._v("\n                    " + _vm._s(item[1]) + "\n                ")])
  }))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-content"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "author"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('i', {
    staticClass: "iconfont icon-love"
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xiazai1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play"
  }, [_c('div', {
    attrs: {
      "id": "skPlayer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  })])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sildeShow),
      expression: "sildeShow"
    }],
    staticClass: "leftContent",
    class: {
      'silde-right': _vm.direction == 'right', 'silde-left': _vm.direction == 'left'
    }
  }, [_c('form', {
    attrs: {
      "id": "uploadForm"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "logo",
      "multiple": "multiple"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headcon"
  }, [_c('img', {
    staticClass: "headpic",
    attrs: {
      "src": __webpack_require__(234)
    },
    on: {
      "click": function($event) {
        _vm.uploadPic()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('section', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "index-page"
  }, [_c('a', {
    staticClass: "sildeLeft ",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("首页")])])]), _vm._v(" "), _c('div', {
    staticClass: "mine-page"
  }, [_c('a', {
    staticClass: "sildeLeft ",
    attrs: {
      "href": "#/shoucang"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" " + _vm._s(_vm.savePage ? '' : '收藏'))])]), _vm._v(" "), _c('div', {
    staticClass: "log-reg"
  }, [_c('a', {
    staticClass: "sildeLeft",
    attrs: {
      "href": "#/login"
    },
    on: {
      "click": _vm.clearCookie
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.logReg ? '退出' : '登录'))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "exit_silde_page"
  }, [_c('a', {
    staticClass: "exit_silde",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ask-help"
  }, [_c('a', {
    staticClass: "sildeLeft",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "#C0BFC4"
    },
    attrs: {
      "href": "#/connection"
    }
  }, [_vm._v("联系客服")])])])])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "container"
  }, [(_vm.isShowContainer) ? _c('div', {
    staticClass: "mainContainer"
  }, [_c('a', {
    attrs: {
      "href": "#/app/newSong"
    },
    on: {
      "click": _vm.historyHight
    }
  }, [_c('span', {
    staticClass: "back"
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('section', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.imgurl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("阅读:" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm.data.eiditetime))]), _vm._v(" "), _c('span', {
    staticClass: "focus",
    on: {
      "click": _vm.focusStatus
    }
  }, [_vm._v(_vm._s(_vm.word[_vm.num]))])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("文/" + _vm._s(_vm.data.author))]), _vm._v(" "), _c('section', {
    staticClass: "bottom"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.data.mainContent))])]), _vm._v(" "), _c('section', {
    staticClass: "comment"
  }, [_c('div', [_c('span'), _vm._v(" "), _c('div', {
    staticClass: "sendComment"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show"
    }],
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("评论")]), _vm._v(" "), _c('i', {
    staticClass: "commentIcon",
    on: {
      "click": _vm.watchComment
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "commentNum"
  }, [_vm._v(_vm._s(_vm.data.id))])]), _vm._v(" "), _c('span', {
    staticClass: "share"
  })])])]) : _vm._e(), _vm._v(" "), _c('xcomment')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com_container",
    style: ('margin-top:' + _vm.screenHight + 'px'),
    attrs: {
      "show": _vm.showComment
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("最新评论"), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.newArr.length))])]), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.hideComment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.newComment), function(n) {
    return (_vm.newComment) ? _c('section', {
      staticClass: "newData"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('img', {
      attrs: {
        "src": n.imgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v(_vm._s(n.author))]), _vm._v(" "), _c('p', {
      staticClass: "editetime"
    }, [_vm._v(_vm._s(n.editetime))]), _vm._v(" "), _c('span', {
      staticClass: "sendReply"
    })]), _vm._v(" "), _c('p', {
      staticClass: "comment_content"
    }, [_vm._v(_vm._s(n.content))]), _vm._v(" "), _c('div', {
      staticClass: "reply"
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.comData), function(c) {
    return _c('section', {
      staticClass: "comData"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('img', {
      attrs: {
        "src": c.imgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v(_vm._s(c.author))]), _vm._v(" "), _c('p', {
      staticClass: "editetime"
    }, [_vm._v(_vm._s(c.editetime))]), _vm._v(" "), _c('span', {
      staticClass: "sendReply"
    })]), _vm._v(" "), _c('p', {
      staticClass: "comment_content"
    }, [_vm._v(_vm._s(c.content))]), _vm._v(" "), _c('div', {
      staticClass: "reply"
    })])
  })], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.screenHight),
      expression: "!screenHight"
    }],
    staticClass: "sendComment"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "发表评论",
      "value": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发表")])]), _vm._v(" "), _c('section', {
    staticClass: "alert"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAlert),
      expression: "isShowAlert"
    }],
    staticClass: "js_dialog",
    attrs: {
      "id": "iosDialog2"
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    on: {
      "click": _vm.hideAlert
    }
  }), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog"
  }, [_c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("发表评论前请先登录")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("登录")])])])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.commend) ? _c('div', {
    staticClass: "container"
  }, [_c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/3e45432c82692d9c2bfa776e9507c285/544242028/544242028.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(10)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[0].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[0].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")]), _vm._v(" "), _c('span', {
    staticClass: "dujia"
  }, [_vm._v("独家")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000vxCRG30GnbT.jpg?max_age=2592000",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(11)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[1].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[1].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/73a3804e1b971cbebc63d99260278136/540058817/540058817.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(12)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[2].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[2].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/ecc06795d3e3879a5717ba93f5cf995e/261998351/261998351.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(13)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[3].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[3].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/8bace09eaa5d8860eb80fd5773d14d3c/540132627/540132627.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(14)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[4].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[4].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "actionSheet_wrap"
    }
  }, [_c('div', {
    staticClass: "weui-mask_transparent actionsheet__mask",
    class: {
      'active': _vm.isShowMask
    },
    attrs: {
      "id": "mask"
    },
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.isShowMore
    },
    attrs: {
      "id": "weui-actionsheet"
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_c('div', {
    staticClass: "songName"
  }, [_vm._v("歌曲名")]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("下载")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("分享")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("评论")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("查看歌手")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("歌词海报")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("查看专辑")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("背景音乐")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell",
    attrs: {
      "id": "actionsheet_cancel"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("每日为你推荐30首")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gridlist-demo-container"
  }, [_c('mu-grid-list', {
    staticClass: "gridlist-demo",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "0px",
      "margin-bottom": "0px",
      "margin-right": "0px"
    }
  }, _vm._l((_vm.hotsinger), function(tile, index) {
    return _c('mu-grid-tile', {
      key: index,
      attrs: {
        "titlePosition": "top",
        "titleBarClass": "myclass"
      }
    }, [_c('img', {
      staticClass: "setimg",
      attrs: {
        "src": tile.imgurl
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      slot: "title"
    }, [_vm._v(_vm._s(tile.classname))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "top": "0",
        "left": "0",
        "height": "100%",
        "z-index": "1"
      },
      on: {
        "click": function($event) {
          _vm.singerlist(tile.classid, tile.classname)
        }
      }
    })])
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('xsilde'), _vm._v(" "), _c('sheader'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab",
    class: {
      'vux-tab-no-animate': !_vm.animate
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
    staticClass: "vux-tab-ink-bar",
    class: _vm.barClass,
    style: (_vm.barStyle)
  }, [(_vm.customBarWidth) ? _c('span', {
    staticClass: "vux-tab-bar-inner",
    style: (_vm.innerBarStyle)
  }) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    attrs: {
      "id": "zezhao"
    }
  }, [_c('div', {
    staticClass: "tu"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.list,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.get))])]), _vm._v(" "), _c('div', {
    staticClass: "details",
    staticStyle: {
      "margin-top": "-6px",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('p', {
    staticClass: "biao"
  }, [_c('span', {
    staticClass: "setpan"
  }, [_vm._v(_vm._s(_vm.xiang)), _c('p', [_vm._v(_vm._s(_vm.outtime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "remove"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(233),
      "alt": ""
    },
    on: {
      "click": _vm.show
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zjrm"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(i) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/search/keywordSearch?id=' + i.sort
      },
      domProps: {
        "textContent": _vm._s(i.keyword)
      }
    })])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("最近热门")])])
}]}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_wrap"
  }, [_c('div', {
    staticClass: "m_header",
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    staticClass: "goback",
    attrs: {
      "href": "#/app/newSong"
    }
  }, [_vm._v("<返回")]), _vm._v(" 账号注册\n            "), _c('a', {
    staticClass: "m_header_refresh",
    attrs: {
      "href": "javascript:;"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "register-form",
      "name": "pop-form-login",
      "method": "post"
    }
  }, [_c('form', {
    attrs: {
      "id": "uploadForm"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "deviceinfo",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.doUpload()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "m_label"
  }, [_c('img', {
    staticClass: "headpic",
    attrs: {
      "src": __webpack_require__(58)
    },
    on: {
      "click": function($event) {
        _vm.uploadImg()
      }
    },
    model: {
      value: (_vm.imgurl),
      callback: function($$v) {
        _vm.imgurl = $$v
      },
      expression: "imgurl"
    }
  })])]), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "注册帐号",
      "hintText": "请输入注册手机号码",
      "labelFloat": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "昵称",
      "hintText": "请输入昵称",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "输入密码",
      "hintText": "请输入6-20位密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "确认密码",
      "hintText": "再次确认密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "geetest"
  }, [_c('div', {
    staticClass: "gt_bg"
  }), _vm._v(" "), _c('div', [_c('mu-raised-button', {
    staticClass: "submit-btn demo-raised-button",
    attrs: {
      "label": "确认注册",
      "id": "reg-btn",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoRegister()
      }
    }
  })], 1)])], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "小提示"
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.openCon) + "\n        "), _c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-media', {
    staticStyle: {
      "height": "250px",
      "overflow": "hidden"
    },
    attrs: {
      "title": _vm.title,
      "subTitle": "粉丝：66.3万"
    }
  }, [_c('img', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "src": _vm.bigimg
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "liebiao"
  }, [_c('ul', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.mylist), function(n, index) {
    return _c('li', {
      class: {
        gaol: _vm.gaoll == index
      },
      on: {
        "click": function($event) {
          _vm.setImg(n, index)
        }
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(n.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(n.list))]), _vm._v(" "), _c('mu-checkbox', {
      staticClass: "demo-checkbox",
      attrs: {
        "uncheckIcon": "favorite_border",
        "nativeValue": n.hash,
        "disabled": _vm.isShow,
        "checkedIcon": "favorite"
      },
      model: {
        value: (_vm.getshou),
        callback: function($$v) {
          _vm.getshou = $$v
        },
        expression: "getshou"
      }
    })], 1), _vm._v(" "), _vm._m(0, true)])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.goback
    }
  }, [_c('img', {
    staticStyle: {
      "height": "30px",
      "margin-left": "20px",
      "margin-top": "20px",
      "padding": "0"
    },
    attrs: {
      "src": __webpack_require__(231),
      "alt": ""
    }
  })]), _vm._v(" "), _c('xstom', {
    attrs: {
      "list": _vm.bigimg,
      "get": _vm.title,
      "xiang": _vm.xiangxi,
      "outtime": _vm.outtime
    }
  }), _vm._v(" "), _c('xtop'), _vm._v(" "), _c('xplay'), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "top",
      "overlay": false,
      "popupClass": "demo-popup-top",
      "open": _vm.topPopup,
      "overlayColor": "#fff"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.collect) + "\n\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.news))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": __webpack_require__(232),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("我的收藏")])]), _vm._v(" "), _c('span', {
    staticClass: "back"
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])])]), _vm._v(" "), _c('a', {
    staticClass: "weui-media-box weui-media-box_appmsg save_singerList",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', {
    staticClass: "weui-media-box__hd"
  }, [_c('img', {
    staticClass: "weui-media-box__thumb",
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-media-box__bd"
  }, [_c('h4', {
    staticClass: "weui-media-box__title"
  }, [_vm._v("song")]), _vm._v(" "), _c('p', {
    staticClass: "weui-media-box__desc"
  }, [_c('span', [_vm._v("singer: ")]), _vm._v(" "), _c('span', [_vm._v("8888")])])])])])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getload),
      expression: "getload"
    }],
    attrs: {
      "id": "loadingToast"
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "id": "iosMask"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("数据加载中")])])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlay),
      expression: "showPlay"
    }],
    staticClass: "kgmusic"
  }, [_c('section', [_c('div', {
    staticClass: "play"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": function($event) {
        _vm.record_msg()
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.songName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.singerName))]), _vm._v(" "), _c('i', {
    staticClass: "playButton",
    class: {
      'active': _vm.isClick
    },
    on: {
      "click": _vm.playStatus
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "more",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "play_audio"
  }, [_c('audio', {
    attrs: {
      "src": _vm.music_src,
      "controls": "controls",
      "autoplay": "autoplay",
      "id": "audio"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "actionSheet_wrap"
    }
  }, [_c('div', {
    staticClass: "weui-mask_transparent actionsheet__mask",
    class: {
      'active': _vm.isShowMask
    },
    attrs: {
      "id": "mask"
    },
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.isShowMore
    },
    attrs: {
      "id": "weui-actionsheet"
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songsPlay), function(n, index) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      attrs: {
        "id": index
      }
    }, [_c('span', {
      class: {
        'icondiy-play': _vm.page === index
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "songsName",
      on: {
        "click": function($event) {
          _vm.icondiyPlay(index, n.hash)
        }
      }
    }, [_vm._v(_vm._s(n.filename))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.music_src,
        "download": n.filename,
        "id": "down"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-xiazai1",
      on: {
        "click": function($event) {
          _vm.download()
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell cancel",
    attrs: {
      "id": "actionsheet_cancel"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("关闭")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "progress"
    }
  }, [_c('span', {
    attrs: {
      "id": "bar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span'), _vm._v("播放列表")])
}]}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r_banner"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("爱乐")])]), _vm._v(" "), _c('span', {
    staticClass: "bigtitle"
  }, [_vm._v("爱乐")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.xinfo.banner7url,
      "alt": ""
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r_list"
  }, [_c('ul', [_vm._l((_vm.list), function(i, index) {
    return _c('li', {
      staticClass: "li",
      on: {
        "click": function($event) {
          _vm.music(index)
        }
      }
    }, [_c('div', {
      staticClass: "left",
      class: [{
        red: index == 0
      }, {
        dh: index == 1
      }, {
        qh: index == 2
      }]
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "conter"
    }, [_c('p', [_vm._v(_vm._s(i.filename))])]), _vm._v(" "), _c('div', {
      staticClass: "right",
      on: {
        "click": _vm.xiazai
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(230),
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xlsx),
      expression: "xlsx"
    }],
    staticClass: "xl"
  }, [_c('span', [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lbwx),
      expression: "lbwx"
    }],
    staticClass: "lbw"
  }, [_c('p', [_vm._v("没有更多了...")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fh),
      expression: "fh"
    }],
    staticClass: "fh",
    on: {
      "click": _vm.onfh
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(57)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.column) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "first"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/c0024iakzyd_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[0].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/g00243r2wk7_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[1].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "three"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/a0024l5a58w_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[2].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/b0024xgh79z_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[3].filename))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("独家专区")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xtitle'), _vm._v(" "), _c('div', {
    staticClass: "gridlist-demo-container",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('div', {
    staticClass: "hot"
  }, [_vm._v("热门")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.title), function(n) {
    return _c('mu-col', {
      key: n.singerid,
      staticStyle: {
        "margin": "10px"
      },
      attrs: {
        "width": "20",
        "tablet": "30",
        "desktop": "25"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": "50%"
      },
      attrs: {
        "src": n.imgurl,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.songlist(n.singerid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "text-align": "center",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(n.singername))])])
  })), _vm._v(" "), (_vm.xianA) ? _c('div', {
    staticClass: "hot A"
  }, [_vm._v("A")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myA), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianB) ? _c('div', {
    staticClass: "hot B"
  }, [_vm._v("B")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myB), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianC) ? _c('div', {
    staticClass: "hot C"
  }, [_vm._v("C")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myC), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianD) ? _c('div', {
    staticClass: "hot D"
  }, [_vm._v("D")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myD), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianE) ? _c('div', {
    staticClass: "hot E"
  }, [_vm._v("E")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myE), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianF) ? _c('div', {
    staticClass: "hot F"
  }, [_vm._v("F")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myF), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianG) ? _c('div', {
    staticClass: "hot G"
  }, [_vm._v("G")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myG), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianH) ? _c('div', {
    staticClass: "hot H"
  }, [_vm._v("H")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myH), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianI) ? _c('div', {
    staticClass: "hot I"
  }, [_vm._v("I")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myI), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianJ) ? _c('div', {
    staticClass: "hot J"
  }, [_vm._v("J")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myJ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianK) ? _c('div', {
    staticClass: "hot K"
  }, [_vm._v("K")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myK), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianL) ? _c('div', {
    staticClass: "hot L"
  }, [_vm._v("L")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myL), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianM) ? _c('div', {
    staticClass: "hot M"
  }, [_vm._v("M")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myM), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianN) ? _c('div', {
    staticClass: "hot N"
  }, [_vm._v("N")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myN), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianO) ? _c('div', {
    staticClass: "hot O"
  }, [_vm._v("O")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myO), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianP) ? _c('div', {
    staticClass: "hot P"
  }, [_vm._v("P")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myP), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianQ) ? _c('div', {
    staticClass: "hot Q"
  }, [_vm._v("Q")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myQ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianR) ? _c('div', {
    staticClass: "hot R"
  }, [_vm._v("R")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myR), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianS) ? _c('div', {
    staticClass: "hot S"
  }, [_vm._v("S")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myS), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianT) ? _c('div', {
    staticClass: "hot T"
  }, [_vm._v("T")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myT), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianU) ? _c('div', {
    staticClass: "hot U"
  }, [_vm._v("U")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myU), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianV) ? _c('div', {
    staticClass: "hot V"
  }, [_vm._v("V")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myV), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianW) ? _c('div', {
    staticClass: "hot W"
  }, [_vm._v("W")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myW), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianX) ? _c('div', {
    staticClass: "hot X"
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myX), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianY) ? _c('div', {
    staticClass: "hot Y"
  }, [_vm._v("Y")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myY), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xianZ) ? _c('div', {
    staticClass: "hot Z"
  }, [_vm._v("Z")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.myZ), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), (_vm.xian) ? _c('div', {
    staticClass: "hot jin"
  }, [_vm._v("#")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.my), function(item) {
    return [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": item.singername
      },
      on: {
        "click": function($event) {
          _vm.songlist(item.singerid)
        }
      }
    }), _vm._v(" "), _c('mu-divider')]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "outbox"
  }, [_c('div', {
    staticClass: "word_sort",
    attrs: {
      "id": "J_word_sort"
    }
  }, [_c('ul', _vm._l((_vm.shouzimu), function(ele, index) {
    return _c('li', {
      class: {
        'gao': _vm.isShow == index
      },
      attrs: {
        "name": index
      },
      on: {
        "click": function($event) {
          _vm.setscroll(ele, index)
        }
      }
    }, [_vm._v(_vm._s(ele))])
  }))])]), _vm._v(" "), _c('xload', {
    attrs: {
      "getload": _vm.load
    }
  }), _vm._v(" "), _c('xlouti')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.list), function(i) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/rangeDetails/' + i.rankid
      }
    }, [_c('div', {
      staticClass: "imgcontainer"
    }, [_c('img', {
      attrs: {
        "src": i.imgurl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("爱乐")])]), _vm._v(" "), _c('div', [_c('h5', {
      domProps: {
        "textContent": _vm._s(i.rankname)
      }
    })]), _vm._v(" "), _vm._m(0, true)])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tb"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(229)
    }
  })])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "jg"
  }, [_vm._v("搜索结果")]), _vm._v(" "), _c('ul', [_vm._l((_vm.list), function(i, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.music(index)
        }
      }
    }, [_c('p', {
      domProps: {
        "textContent": _vm._s(i.filename)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "xz",
      on: {
        "click": _vm.xiazai
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xlsx),
      expression: "xlsx"
    }],
    staticClass: "xl"
  }, [_c('span', [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lbwx),
      expression: "lbwx"
    }],
    staticClass: "lbw"
  }, [_c('p', [_vm._v("没有更多了...")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fh),
      expression: "fh"
    }],
    staticClass: "fh",
    on: {
      "click": _vm.onfh
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(57)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xbanner'), _vm._v(" "), _c('xhot'), _vm._v(" "), _c('xcommend'), _vm._v(" "), _c('xcolumn'), _vm._v(" "), _c('xchosen'), _vm._v(" "), _c('xzhuanlang'), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.data), function(d) {
    return _c('tr', {
      model: {
        value: (_vm.data),
        callback: function($$v) {
          _vm.data = $$v
        },
        expression: "data"
      }
    }, [_c('td', [_vm._v(_vm._s(d.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.author))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("shortTitle")(d.title)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("shortTitle")(d.subtitle)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.rating))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("shortTitle")(d.content)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.editetime))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.sendId(d.id)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#/mod/' + d.id
      }
    }, [_vm._v("编辑")])]), _vm._v(" "), _c('button', [_vm._v("删除")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagenation"
  }, _vm._l((_vm.pageNum), function(item, index) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.changeContent(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h4', [_vm._v("后台管理系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', [_c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("评论数据")])])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("用户数据")])])]), _vm._v(" "), _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("文章列表")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("作者")]), _vm._v(" "), _c('th', [_vm._v("标题")]), _vm._v(" "), _c('th', [_vm._v("类目")]), _vm._v(" "), _c('th', [_vm._v("等级")]), _vm._v(" "), _c('th', [_vm._v("内容")]), _vm._v(" "), _c('th', [_vm._v("时间")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', {
    staticClass: "search",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("爱乐音悦台")])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Banner', {
    attrs: {
      "xinfo": _vm.info
    }
  }), _vm._v(" "), _c('List', {
    attrs: {
      "xsongs": _vm.songs
    }
  }), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "sendComment"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "欢迎来撩",
      "value": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("bilibili客服")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "msgContainer"
  }, [_c('ul', {
    staticClass: "msg"
  }, [_c('li', {
    staticClass: "answer"
  }, [_c('span', [_vm._v("bilibili软萌妹子为您服务")])])])])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "songlists-hot"
  }, [_c('h2', [_vm._v("热门歌单")]), _vm._v(" "), _c('div', {
    staticClass: "ul row"
  }, _vm._l((_vm.info), function(n, index) {
    return _c('div', {
      key: n.id,
      staticClass: "li",
      attrs: {
        "track-by": "$index"
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (n.imgurl),
        expression: "n.imgurl"
      }]
    }), _vm._v(" "), _c('div', {
      staticClass: "playNum"
    }, [_c('i', {
      staticClass: "iconfont icon-ear"
    }), _vm._v(" " + _vm._s(n.playcount) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "btn-play iconfont icon-play",
      on: {
        "click": function($event) {
          _vm.setImg(n.imgurl, n.songs)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("\n                        " + _vm._s(n.username) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                        " + _vm._s(n.specialname) + "\n                    ")])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('form', {
    staticClass: "m_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "login-form",
      "name": "pop-form-login",
      "method": "post",
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "appkey",
      "value": ""
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "登录帐号",
      "hintText": "请输入登录手机号码",
      "labelFloat": ""
    }
  }), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "登录密码",
      "hintText": "请输入密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "geetest"
  }, [_c('div', {
    staticClass: "gt_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "mr_b15"
  }, [_c('mu-raised-button', {
    staticClass: "submit-btn demo-raised-button",
    attrs: {
      "label": "登录",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoLogin(_vm.open)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mr_b15"
  }, [_c('mu-raised-button', {
    staticClass: "reg-btn demo-raised-button",
    attrs: {
      "label": "注册",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.toRegister()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "width90"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cross_post",
      "value": "1"
    }
  })])], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "小提示"
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.openCon) + "\n\t\t\t"), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m_header"
  }, [_c('a', {
    staticClass: "goback",
    attrs: {
      "href": "#/app/newSong"
    }
  }, [_vm._v("返回")]), _vm._v("\n\t\t\t账号登录\n\t\t\t"), _c('a', {
    staticClass: "m_header_refresh J_refresh",
    attrs: {
      "href": "javascript:;"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "m_label"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(58)
    }
  })])])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-back-top', {
    attrs: {
      "height": 500,
      "bottom": 86,
      "right": 45,
      "duration": 1000
    }
  }, [_c('mu-raised-button', {
    staticClass: "demo-raised-button mu-icon material-icons",
    attrs: {
      "label": "keyboard_arrow_up",
      "primary": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.louti),
      expression: "louti"
    }],
    attrs: {
      "id": "loadingToast"
    }
  }, [_c('div', {
    staticClass: "weui-toast"
  }, [_c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.zimu))])])])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    on: {
      "click": _vm.fh
    }
  }), _vm._v(" "), _c('p', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssgq),
      expression: "ssgq"
    }],
    staticClass: "ecss",
    attrs: {
      "type": "text",
      "placeholder": "歌手/歌名/拼音"
    },
    domProps: {
      "value": (_vm.ssgq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssgq = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "tss",
    attrs: {
      "href": "#/search/keywordSearch"
    },
    on: {
      "click": _vm.huoqu
    }
  }, [_vm._v("搜索")])])])])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "go"
  }, [_c('span', {
    staticClass: "back"
  }, [_c('img', {
    staticStyle: {
      "left": "0",
      "top": "7px",
      "position": "absolute"
    },
    attrs: {
      "src": __webpack_require__(228),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mytitle))])])])
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("精选电台")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })]), _vm._v(" "), _c('section', {
    staticClass: "type"
  }, [_c('span', {
    staticClass: "first"
  }, [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/KWul6PEBRTRXtxIIqGZBSdyWapkicmbusJPHZcrIfhqfiacbTnEGfltw/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("90后")])]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/8HhavvWNIicpyjlv0UnT5TTPic7kJoZ4IqytNr1WVqoJNgTtE6kry79w/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("古风")])]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/eO1iarCrMC5jNLJicQibtNolrqRaiafSMJMRTPmZiaTibX5Bgcp3yPSDS70Q/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("民俗")])])]), _vm._v(" "), _c('div', {
    staticClass: "showBox"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000h2IRx0Ap45C.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("唱反调 | 吃火锅底料的GAI爷")]), _vm._v(" "), _c('p', [_vm._v("主播：DJ周杨")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.3万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000004ULoqM4HpMKF.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("回到过去 | 磁带里走出的夏天")]), _vm._v(" "), _c('p', [_vm._v("主播：任志红")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.1万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002xaPnq0BXNav.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("幽暗恢宏迷离消逝-英国才华横溢...")]), _vm._v(" "), _c('p', [_vm._v("主播：Konekt Asia")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.3万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000003fMl4c3ItNV4.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("九张机(Cover叶炫清)")]), _vm._v(" "), _c('p', [_vm._v("主播：ayo又")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.5万")])])])])])
}]}

/***/ }),
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-650d79c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-521669a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  "data-v-459c457a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-69b1598f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  "data-v-587eaf59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-5a588dea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  "data-v-4f234e9b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  "data-v-6de9be37",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-e322c5f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  "data-v-1005f047",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-fb533ce6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-5ff5c11e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  "data-v-3cff8578",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  "data-v-3b3c9558",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  "data-v-1f972ac2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-c81516c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-d9e8e908",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-51821104",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-52924d26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-9920ea2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-f9bacfe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-cbacd86c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  "data-v-2239ff97",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-74566f5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  "data-v-0b96d1f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-3a102ff2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-c5f7e64e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  "data-v-2ac5119c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })
],[92]);


// WEBPACK FOOTER //
// static/js/app.2a33724929b875f72496.js